<template>
  <div
    class="page-header align-items-start moo-cart-page"
    style="font-size: 14px"
    :style="styleObject"
  >
    <span class="mask"></span>

    <div
      v-if="!loaderActivePayTopUp"
      class="container cart-shell"
      style="padding-left: 0px; padding-right: 0px"
      @click="hideDiv($event)"
    >
      <div class="row">
        <div class="notifications">
          <material-alert
            v-if="error"
            color="danger"
            icon="ni ni-like-2 ni-lg"
            dismissible
          >
            {{ error }}
          </material-alert>
        </div>
        <div class="col-12">
          <!-- MTH066: shared top bar (same as the menu page) — back + brand logo
               + language pill. -->
          <OrderTopBar show-back @back="goBack" @lang="syncCartNames" />
          <div class="moo-cart-pills-row">
            <div v-if="tableCode" class="moo-cart-table-pill">
              <i class="material-icons">table_restaurant</i>
              <span>{{ $t('cart.table', { code: tableLabel }) }}</span>
            </div>
            <!-- M986 follow-up: the channel asks Pickup / Delivery instead, so no Dine In / Take Away pill. -->
            <div
              v-if="!(branch && branch.show_pickup_delivery_option_moo == 1)"
              class="moo-cart-table-pill"
              :class="{ 'moo-cart-table-pill--clickable': canSwitchDiningOption }"
              @click="openDiningOptionModal()"
            >
              <i class="material-icons">{{ takeAwayOrDineIn == DINE_IN ? 'restaurant' : 'takeout_dining' }}</i>
              <span>{{ takeAwayOrDineIn == DINE_IN ? $t('cart.dineIn') : $t('cart.takeAway') }}</span>
              <i v-if="canSwitchDiningOption" class="material-icons moo-cart-table-pill__chevron">edit</i>
            </div>
          </div>
          <div
            class="card-body"
            style="padding-top: 5px; padding-bottom: 5px; margin-top: 15px"
          >
            <div
              v-if="showCartUpdatedAfterClearItemsOutStock"
              class="moo-cart-updated-banner"
            >
              <i class="material-icons">error_outline</i>
              <span>{{ $t('cart.cartUpdated') }}</span>
            </div>
            <!-- MTH105: the advocado reskin (PR #169) dropped the old
                 "Ready in about : ..." line and merchants noticed.
                 M961: customers complained it was still easy to miss as a
                 thin grey line under the pills, so it is now a card in the same
                 rhythm as the item cards — label left, value right in the brand
                 colour, the same shape every amount on this page uses, kept to
                 one line. It lives inside .card-body so it shares their width;
                 outside it the card was wider than everything below it, which
                 read as pasted on. waitingTimeText is empty
                 when the branch is set to "Do not display waiting time", which
                 hides the whole card. -->
            <div v-if="waitingTimeText" class="moo-cart-waiting-card">
              <i class="material-icons moo-cart-waiting-card__icon" style="margin-bottom: 2px;">schedule</i>
              <span class="moo-cart-waiting-card__label">{{ $t('cart.waitingTimeLabel') }}</span>
              <span class="moo-cart-waiting-card__value">{{ waitingTimeText }}</span>
            </div>
            <div class="text-introduce" v-if="!isLogined && !hideMemberLogin">
              <span @click="gotoSignIn()">{{ $t('cart.login') }}</span> {{ $t('cart.orWord') }}
              <span @click="gotoSignUp()">{{ $t('cart.signUp') }}</span> {{ $t('cart.enjoyBenefits') }}
            </div>
            <div
              class="div-order-items"
              v-for="(item, index) in cartDisplayItems"
              :key="index"
              style="display: flex; align-items: center"
            >
              <div
                style="
                  width: 100%;
                  display: flex;
                  align-items: center;
                  height: 50px;
                "
                v-if="item.isEditQuantity"
                class="boxEditQuantity"
              >
                <div
                  class="boxEditQuantity"
                  @click="showQuantityForMainItem(index)"
                  style="
                    width: 17%;
                    height: 100%;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 5px;
                    border-radius: 3px;
                  "
                >
                  {{ item.quantity }}
                </div>
                <div style="width: 3%" class="boxEditQuantity"></div>
                <div
                  class="boxEditQuantity"
                  style="
                    width: 48%;
                    height: 100%;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 5px;
                    border-radius: 3px;
                    color: var(--color) !important;
                  "
                >
                  <div
                    class="boxEditQuantity"
                    @click="handleQuantityForMainItem(item, 1, index)"
                    style="
                      width: 49%;
                      align-items: center;
                      display: flex;
                      justify-content: center;
                      font-size: 25px;
                    "
                  >
                    -
                  </div>
                  <div
                    class="boxEditQuantity"
                    style="width: 2%; border-left: 1px solid gray; height: 50%"
                  ></div>
                  <div
                    class="boxEditQuantity"
                    @click="handleQuantityForMainItem(item, 2, index)"
                    style="
                      width: 49%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 25px;
                    "
                  >
                    +
                  </div>
                </div>
                <div class="boxEditQuantity" style="width: 3%"></div>
                <div
                  class="boxEditQuantity"
                  style="
                    width: 30%;
                    height: 100%;
                    align-items: center;
                    justify-content: flex-end;
                    display: flex;
                    color: var(--moo-muted, #bdbdbd);
                  "
                >
                  {{ getMainItemPriceAndModifiersPrice(item) }}
                </div>
              </div>
              <div
                style="width: 100%; display: flex; align-items: center"
                v-else
              >
                <div
                  style="
                    width: 100%;
                    display: flex;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                  <div style="flex: 0 0 64px; align-items: flex-start; display: flex; margin-right: 12px">
                    <img :src="item.image" style="width: 64px; height: 64px; border-radius: 12px; object-fit: cover; display: block" />
                  </div>
                  <div
                    style="
                      flex: 1;
                      min-width: 0;
                      align-items: flex-start;
                      display: flex;
                    "
                  >
                    <div class="w-100" :class="{'w-100': item.source == 'upsell' }">
                      <div class="div-items" style="position: relative">
                        <div
                          class="item-name"
                          style="
                            width: 100%;
                            line-height: normal;
                            word-break: break-word;
                          "
                        >
                          <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                            <span
                              class="moo-cart-item-name"
                              :class="{ 'item-voucher-applied': item.is_free_item }"
                              :style="{ opacity: item.isCanGet == 1 ? 0.3 : 1 }"
                              >{{ item.quantity }}x {{ tName(item.item_name) }}<span
                                v-if="isEnableBcrs && parseInt(item.eligible_bcrs) === 1"
                                class="bcrs-badge"
                                >BCRS</span
                              ></span
                            >
                            <div
                              v-if="itemOwnPrice(item)"
                              style="display: grid; justify-items: end; flex-shrink: 0;"
                              :style="{ opacity: item.isCanGet == 1 ? 0.3 : 1 }"
                            >
                              <span
                                v-if="itemOwnPriceWas(item)"
                                style="color: var(--moo-muted, #bdbdbd); text-decoration: line-through; font-size: 12px;"
                                >{{ itemOwnPriceWas(item) }}</span
                              >
                              <span style="font-size: 12px; font-weight: 600; white-space: nowrap;">{{ itemOwnPrice(item) }}</span>
                            </div>
                          </div>
                          <div v-if="priceUpdateOf(item)" class="moo-price-updated">
                            {{ $t('cart.priceUpdatedLine', { from: '$' + priceUpdateOf(item).from.toFixed(2), to: '$' + priceUpdateOf(item).to.toFixed(2) }) }}
                          </div>
                          <div
                            v-if="item.isCanGet == 1"
                            style="color: var(--color); font-size: 12px"
                          >
                            {{ $t('cart.notAvailableItem') }}
                          </div>

                          <div v-if="item.choice && item.choice_selected">
                            <div
                              v-for="(itemChoice, indexChoice) in item
                                .choice_selected.items"
                              :key="indexChoice"
                            >
                              <div v-if="itemChoice.item_detail">
                                <div class="item-name" style="width: 100%">
                                  {{
                                    itemChoice.qty +
                                    " x " +
                                    tName(itemChoice.item_detail.item_name)
                                  }}<span
                                    v-if="isEnableBcrs && parseInt(itemChoice.item_detail.eligible_bcrs) === 1"
                                    class="bcrs-badge"
                                    >BCRS</span>
                                </div>

                                <div
                                  v-for="(
                                    modifierOption, indexModifierOption
                                  ) in itemChoice.item_detail.modifier_group"
                                  :key="indexModifierOption"
                                  class="ms-2"
                                >
                                  <div
                                    style="position: relative; display: grid"
                                    class="div-items"
                                    v-for="(
                                      itemModifierOption, indexItemModifierOption
                                    ) in modifierOption.items"
                                    :key="indexItemModifierOption"
                                  >
                                    <div class="div-items">
                                      <div v-if="itemModifierOption.description" style="width: 100%">
                                        <div
                                          class="item-name"
                                          style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;"
                                        >
                                          <div style="flex: 1; min-width: 0;">
                                            <span
                                              :style="{
                                                opacity:
                                                  itemModifierOption.isCanGet == 1
                                                    ? 0.3
                                                    : 1,
                                              }"
                                              style="font-size: 12px"
                                              >{{
                                                itemModifierOption.description
                                              }}</span
                                            >
                                            <br /><span
                                              :style="{
                                                opacity:
                                                  itemModifierOption.isCanGet == 1
                                                    ? 0.3
                                                    : 1,
                                              }"
                                              style="font-size: 12px"
                                              >{{
                                                modifierName(itemModifierOption)
                                              }}</span
                                            ><span
                                              v-if="isEnableBcrs && parseInt(itemModifierOption.eligible_bcrs) === 1"
                                              class="bcrs-badge"
                                              >BCRS</span>
                                            <div
                                              v-if="
                                                itemModifierOption.isCanGet == 1
                                              "
                                              style="
                                                color: var(--color);
                                                font-size: 12px;
                                              "
                                            >
                                              {{ $t('cart.notAvailableItem') }}
                                            </div>
                                          </div>
                                          <span
                                            v-if="modifierLinePrice(itemModifierOption, item.quantity * itemChoice.qty)"
                                            style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                            >{{ modifierLinePrice(itemModifierOption, item.quantity * itemChoice.qty) }}</span
                                          >
                                        </div>
                                      </div>
                                      <div v-else style="width: 100%">
                                        <div
                                          class="item-name"
                                          style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;"
                                        >
                                          <div style="flex: 1; min-width: 0;">
                                            <span
                                              :style="{
                                                opacity:
                                                  itemModifierOption.isCanGet == 1
                                                    ? 0.3
                                                    : 1,
                                              }"
                                              style="font-size: 12px"
                                              >{{
                                                modifierName(itemModifierOption)
                                              }}</span
                                            ><span
                                              v-if="isEnableBcrs && parseInt(itemModifierOption.eligible_bcrs) === 1"
                                              class="bcrs-badge"
                                              >BCRS</span>
                                            <div
                                              v-if="
                                                itemModifierOption.isCanGet == 1
                                              "
                                              style="
                                                color: var(--color);
                                                font-size: 12px;
                                              "
                                            >
                                              {{ $t('cart.notAvailableItem') }}
                                            </div>
                                          </div>
                                          <span
                                            v-if="modifierLinePrice(itemModifierOption, item.quantity * itemChoice.qty)"
                                            style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                            >{{ modifierLinePrice(itemModifierOption, item.quantity * itemChoice.qty) }}</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="ms-2"
                                      v-if="itemModifierOption.item_in_mog"
                                    >
                                      <div
                                        v-for="(
                                          subModifierOption,
                                          indexSubModifierOption
                                        ) in itemModifierOption.item_in_mog
                                          .modifier_group"
                                        :key="indexSubModifierOption"
                                      >
                                        <div
                                          style="
                                            position: relative;
                                            display: grid;
                                          "
                                          class="div-items"
                                          v-for="(
                                            subItemModifierOption,
                                            indexSubItemModifierOption
                                          ) in subModifierOption.items"
                                          :key="indexSubItemModifierOption"
                                        >
                                          <div
                                            class="item-name"
                                            style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;"
                                          >
                                            <span style="font-size: 12px">{{
                                              modifierName(subItemModifierOption)
                                            }}<span
                                              v-if="isEnableBcrs && parseInt(subItemModifierOption.eligible_bcrs) === 1"
                                              class="bcrs-badge"
                                              >BCRS</span
                                            ></span>
                                            <span
                                              v-if="modifierLinePrice(subItemModifierOption, item.quantity * itemChoice.qty)"
                                              style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                              >{{ modifierLinePrice(subItemModifierOption, item.quantity * itemChoice.qty) }}</span
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="(
                              modifierOption, indexModifierOption
                            ) in item.modifier_group"
                            :key="indexModifierOption"
                          >
                            <div
                              style="position: relative; display: grid"
                              class="div-items"
                              v-for="(
                                itemModifierOption, indexItemModifierOption
                              ) in modifierOption.items"
                              :key="indexItemModifierOption"
                            >
                              <div class="div-items">
                                <div v-if="itemModifierOption.description" style="width: 100%">
                                  <div class="item-name" style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                                    <div style="flex: 1; min-width: 0;">
                                      <span
                                        :style="{
                                          opacity:
                                            itemModifierOption.isCanGet == 1
                                              ? 0.3
                                              : 1,
                                        }"
                                        style="font-size: 12px"
                                        >{{ itemModifierOption.description }}</span
                                      >
                                      <br /><span
                                        :style="{
                                          opacity:
                                            itemModifierOption.isCanGet == 1
                                              ? 0.3
                                              : 1,
                                        }"
                                        style="font-size: 12px"
                                        >{{ modifierName(itemModifierOption) }}</span
                                      ><span
                                        v-if="isEnableBcrs && parseInt(itemModifierOption.eligible_bcrs) === 1"
                                        class="bcrs-badge"
                                        >BCRS</span>
                                      <div
                                        v-if="itemModifierOption.isCanGet == 1"
                                        style="color: var(--color); font-size: 12px"
                                      >
                                        {{ $t('cart.notAvailableItem') }}
                                      </div>
                                    </div>
                                    <span
                                      v-if="modifierLinePrice(itemModifierOption, item.quantity)"
                                      style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                      >{{ modifierLinePrice(itemModifierOption, item.quantity) }}</span
                                    >
                                  </div>
                                </div>
                                <div v-else style="width: 100%">
                                  <div class="item-name" style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                                    <div style="flex: 1; min-width: 0;">
                                      <span
                                        :style="{
                                          opacity:
                                            itemModifierOption.isCanGet == 1
                                              ? 0.3
                                              : 1,
                                        }"
                                        style="font-size: 12px"
                                        >{{ modifierName(itemModifierOption) }}</span
                                      ><span
                                        v-if="isEnableBcrs && parseInt(itemModifierOption.eligible_bcrs) === 1"
                                        class="bcrs-badge"
                                        >BCRS</span>
                                      <div
                                        v-if="itemModifierOption.isCanGet == 1"
                                        style="color: var(--color); font-size: 12px"
                                      >
                                        {{ $t('cart.notAvailableItem') }}
                                      </div>
                                    </div>
                                    <span
                                      v-if="modifierLinePrice(itemModifierOption, item.quantity)"
                                      style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                      >{{ modifierLinePrice(itemModifierOption, item.quantity) }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                class="ms-2"
                                v-if="itemModifierOption.item_in_mog"
                              >
                                <div
                                  v-for="(
                                    subModifierOption, indexSubModifierOption
                                  ) in itemModifierOption.item_in_mog
                                    .modifier_group"
                                  :key="indexSubModifierOption"
                                >
                                  <div
                                    style="position: relative; display: grid"
                                    class="div-items"
                                    v-for="(
                                      subItemModifierOption,
                                      indexSubItemModifierOption
                                    ) in subModifierOption.items"
                                    :key="indexSubItemModifierOption"
                                  >
                                    <div class="item-name" style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
                                      <span style="font-size: 12px">{{
                                        modifierName(subItemModifierOption)
                                      }}<span
                                        v-if="isEnableBcrs && parseInt(subItemModifierOption.eligible_bcrs) === 1"
                                        class="bcrs-badge"
                                        >BCRS</span
                                      ></span>
                                      <span
                                        v-if="modifierLinePrice(subItemModifierOption, item.quantity)"
                                        style="font-size: 12px; color: var(--moo-muted, #bdbdbd); white-space: nowrap; flex-shrink: 0;"
                                        >{{ modifierLinePrice(subItemModifierOption, item.quantity) }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center"
                        style="
                          width: 100%;
                          margin-top: 8px;
                        "
                      >
                        <a
                          v-if="item.source != 'upsell'"
                          class="moo-cart-edit"
                          :class="{ 'moo-cart-edit--disabled': item.isCanGet == 1 || item.is_free_item }"
                          @click="
                            item.isCanGet == 1 || item.is_free_item
                              ? null
                              : editCartItem(item, index)
                          "
                        >
                          <i class="material-icons">edit</i>
                          <span>{{ $t('cart.edit') }}</span>
                        </a>
                        <div
                          class="cart-qty-pill"
                          :style="{ opacity: item.isCanGet == 1 || item.is_free_item ? 0.4 : 1 }"
                        >
                          <span
                            class="cart-qty-btn"
                            @click="item.isCanGet == 1 || item.is_free_item ? null : handleQuantityForMainItem(item, 1, index)"
                            >&minus;</span
                          >
                          <span class="cart-qty-num">{{ item.quantity }}</span>
                          <span
                            class="cart-qty-btn"
                            @click="item.isCanGet == 1 || item.is_free_item ? null : handleQuantityForMainItem(item, 2, index)"
                            >+</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty cart: prompt to order more -->
            <div
              v-if="cartDisplayItems.length === 0"
              class="empty-cart-order-more"
            >
              <div class="order-more-button" @click="goBack">
                <span class="material-icons" style="font-size: 18px; padding-bottom: 3px">add</span>
                {{ $t('cart.orderMore') }}
              </div>
            </div>
          </div>
          <div class="card-body" v-if="slides && slides.length > 0">
            <div class="banner">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :loop="true"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
                :pagination="{
                  clickable: true,
                  el: '.swiper-pagination',
                }"
              >
                <swiper-slide v-for="(value, index) in slides" :key="index">
                  <div
                    class="slider"
                    @click="clickLink(value)"
                    style="
                      position: relative;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div
                      v-if="
                        value.direct_to_suggested_adds_on == 1 &&
                        value.itemSelected
                      "
                      style="
                        position: absolute;
                        width: 90%;
                        height: 90%;
                        align-items: center;
                        display: flex;
                      "
                    >
                      <div
                        style="
                          width: 100%;
                          height: 80%;
                          display: inline-flex;
                          gap: 2%;
                        "
                      >
                        <div style="width: 49%; height: 100%">
                          <img
                            :src="value.itemSelected.image"
                            alt="error"
                            style="height: 100%"
                          />
                        </div>
                        <div style="width: 49%">
                          <div
                            style="
                              background: gray;
                              color: white;
                              padding-left: 10px;
                            "
                          >
                            <div>ADDS ON ${{ value.itemSelected.price }}</div>
                          </div>
                          <div
                            style="
                              background: gray;
                              color: white;
                              margin-top: 5px;
                              padding-left: 10px;
                            "
                          >
                            <div>{{ tName(value.itemSelected.item_name) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img :src="value.file_url" alt="error" />
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0px">
            <!-- MTH092: once a voucher is applied the cart shows which one is
                 applied, with an x to drop it, and the CTA below turns into
                 "Change Voucher" instead of disappearing. -->
            <div
              v-if="showVoucherCta && appliedReward"
              class="moo-applied-voucher"
            >
              <span class="material-icons moo-applied-voucher__icon">redeem</span>
              <div class="moo-applied-voucher__body">
                <div class="moo-applied-voucher__title">
                  {{ appliedRewardTitle }}
                </div>
                <!-- MTH090: on the second and later orders of a pay-later table the
                     voucher comes from the table session, so say where it came from
                     instead of offering an expiry the guest can no longer act on. -->
                <div
                  v-if="isSessionLockedVoucher"
                  class="moo-applied-voucher__subtitle"
                >
                  {{ $t('cart.voucherLockedToTable') }}
                </div>
                <div
                  v-else-if="appliedReward.expiry_date_text"
                  class="moo-applied-voucher__subtitle"
                >
                  {{ $t('rewards.validTill', { date: appliedReward.expiry_date_text }) }}
                </div>
              </div>
              <button
                v-if="!isSessionLockedVoucher"
                type="button"
                class="moo-applied-voucher__remove"
                :aria-label="$t('cart.remove')"
                @click="removeReward()"
              >
                <span class="material-icons">close</span>
              </button>
            </div>
            <div
              v-if="showVoucherCta && !isSessionLockedVoucher"
              class="cart-cta"
              @click="selectReward()"
            >
              <div class="cart-cta__left">
                <span class="material-icons cart-cta__icon">confirmation_number</span>
                <span class="cart-cta__label">{{
                  appliedReward ? $t('cart.changeVoucher') : $t('cart.applyVoucher')
                }}</span>
              </div>
              <span class="material-icons cart-cta__chevron">chevron_right</span>
            </div>
            <!-- MTH105: promo code is no longer a dashed CTA card competing with
                 the voucher one — it collapses to a single link that opens the
                 same modal. showPromoCodeCta (pay-later gate + mutually
                 exclusive with an applied voucher) is unchanged. -->
            <button
              v-if="showPromoCodeCta"
              type="button"
              class="moo-cart-promo-link"
              @click="enterPromoCode()"
            >
              {{ $t('cart.havePromoCode') }}
            </button>
            <section
              v-if="popularAddOns && popularAddOns.length"
              class="moo-addons-card"
            >
              <header class="moo-addons-card__header">
                <span class="moo-addons-card__emoji">🔥</span>
                <h2 class="moo-addons-card__title">{{ $t('cart.popularAddOns') }}</h2>
              </header>
              <div class="moo-addons-card__grid">
                <button
                  v-for="(upsellItem, idxAddOn) in popularAddOns.slice(0, 2)"
                  :key="upsellItem.item.id + '-' + idxAddOn"
                  type="button"
                  class="moo-addons-card__item"
                  @click="addPopularAddOnToCart(upsellItem)"
                >
                  <div class="moo-addons-card__image-wrap">
                    <img
                      v-if="upsellItem.item.image"
                      :src="upsellItem.item.image"
                      :alt="upsellItem.item.item_name"
                      class="moo-addons-card__image"
                      loading="lazy"
                    />
                    <div
                      v-else
                      class="moo-addons-card__image moo-addons-card__image--placeholder"
                    ></div>
                  </div>
                  <div class="moo-addons-card__meta">
                    <span class="moo-addons-card__label">
                      {{ tName(upsellItem.item.item_name) }}
                    </span>
                    <span class="moo-addons-card__price">
                      $ {{ Number(upsellItem.item.price_default).toFixed(2) }}
                    </span>
                  </div>
                </button>
              </div>
            </section>
            <div class="moo-summary-card">
            <h3 class="moo-summary-heading">{{ $t('cart.orderSummary') }}</h3>
            <div class="total-section" style="width: 100%; text-align: end; position: relative;">
              <div class="total-label">{{ $t('cart.subtotal') }}</div>
              <div class="total-amount">
                $ {{ (calculateTotal() - deliveryFeeLineAmount).toFixed(2) }}
              </div>
            </div>
            <!-- M986 follow-up: the delivery fee is its own summary row (like iMakan), not an item line. -->
            <div
              class="total-section"
              style="width: 100%; text-align: end; position: relative;"
              v-if="shouldApplyDeliveryFee() && deliveryFeeCartItem"
            >
              <div class="total-label">{{ $t('cart.deliveryFee') }}</div>
              <div class="total-amount">
                {{ deliveryFeeLineAmount > 0 ? '$ ' + deliveryFeeLineAmount.toFixed(2) : $t('cart.deliveryFeeFree') }}
              </div>
            </div>
            <!-- MTH076: pay-later carts used to show only Subtotal plus a
                 "subject to prevailing charges" note. They now share the exact
                 same summary rows as pay-now — the amounts were already being
                 computed and submitted for pay-later orders (take_away_fee /
                 gst_amount / total_payment_amount), they just weren't shown. -->
            <div>
              <!-- MTH068: discount rows are the only coloured rows in the summary
                   (green), matching advocado's order summary. -->
              <div
                class="fee-section moo-summary-row--discount"
                style="width: 100%; text-align: end"
                v-if="rewardSelect && rewardSelect.length > 0"
              >
                <div class="fee-label">{{ $t('cart.voucherDiscount') }} ({{ rewardSelect[0].reward_title }})</div>
                <div class="fee-amount">
                   {{  rewardSelect[0].reward_type == freeItem
                          ? $t('cart.freeItem')
                          : appliedVoucherDiscount()
                            ? "-$ " + appliedVoucherDiscount().toFixed(2)
                            : "-$ 0.00" }}
                </div>
              </div>
              <div
                class="fee-section moo-summary-row--discount"
                style="width: 100%; text-align: end"
                v-if="isPromoCodeApplied"
              >
                <div class="fee-label">{{  promoCodeApplied.promo_name }}</div>
                <div class="fee-amount">
                   {{  getPromoDiscountAmount()
                          ? "-$ " + getPromoDiscountAmount().toFixed(2)
                          : "-$ 0.00" }}
                </div>
              </div>
              <div
                class="fee-section"
                style="width: 100%; text-align: end"
                v-if="
                  (takeAwayOrDineIn == DINE_IN || isOrderPayLater) &&
                  branch.service_charge_rate > 0
                "
              >
                <div class="fee-label">{{ $t('cart.serviceCharge') }}</div>
                <div class="fee-amount">
                  $ {{ totalDineInFee().toFixed(2) }}
                </div>
              </div>
              <div
                class="total-section"
                style="width: 100%; text-align: end; position: relative;"
                v-if="Math.abs(branch.gst_rate) != 0 && convertedValueGstRate() > 0"
              >
                <div class="total-label">
                  {{ $t('cart.gstPercent', { percent: Math.abs(branch.gst_rate) }) }}
                </div>
                <div class="total-amount">
                  $ {{ convertedValueGstRate().toFixed(2) }}
                </div>
              </div>
              <div
                class="total-section"
                style="width: 100%; text-align: end; position: relative;"
                v-if="Math.abs(branch.gst_rate) != 0 && convertedValueGstRate() == 0"
              >
                <div class="total-label">
                  {{ $t('cart.gstPercent', { percent: Math.abs(branch.gst_rate) }) }}
                </div>
                <div class="total-amount">
                  $ {{ totalGSTInclusive().toFixed(2) }}
                </div>
              </div>
              <div class="total-section" style="width: 100%; text-align: end; position: relative;">
                <div class="total-label font-weight-bold" v-if="convertedValueGstRate() > 0">
                  {{ $t('cart.billTotal') }}
                </div>
                <div class="total-label font-weight-bold" v-else>{{ Math.abs(branch.gst_rate) != 0 ? $t('cart.billTotalInclGst') : $t('cart.billTotal') }}</div>
                <div class="total-amount font-weight-bold">
                  $ {{ finalTotal() }}
                </div>
              </div>
              <div
                class="fee-section"
                style="width: 100%; text-align: end"
                v-if="isEnableBcrs"
              >
                <div class="fee-label">{{ $t('cart.bcrsDeposit') }} {{ '(' + parseInt(this.totalBcrs / this.branch.each_bcrs_amount) + ' x ' + this.branch.each_bcrs_amount + ')' }}</div>
                <div class="fee-amount">
                  $ {{ totalBcrs.toFixed(2) }}
                </div>
              </div>
              <div
                class="fee-section font-weight-bold"
                style="width: 100%; text-align: end"
                v-if="isEnableBcrs"
              >
                <div class="fee-label">{{ $t('cart.totalPayable') }}</div>
                <div class="fee-amount">
                  $ {{ totalPayable() }}
                </div>
              </div>
            </div>
            </div>
          </div>
          <div
            v-if="
              branch && branch.show_special_instructions_on_ordering_online == 1
            "
            class="cart-divider"
          ></div>
          <div
            v-if="
              branch && branch.show_special_instructions_on_ordering_online == 1
            "
            class="card-body"
            style="padding-top: 5px; padding-bottom: 5px"
          >
            <div>
              <div class="div_root_cutlery">
                <div class="div_notes">
                  <div class="image_notes">
                    <img
                      src="../assets/img/my-cart/notes.jpeg"
                      style="width: 25px; height: 25px"
                    />
                  </div>
                  <div class="color-black">{{ $t('cart.specialInstructions') }}</div>
                </div>
                <!-- MTH057: ô input nằm cùng hàng với label -->
                <div class="notes-input">
                  <material-input
                    id="special-instructions"
                    v-model="notes"
                    :placeholder="
                      branch.special_instructions_placeholder || 'Enter here'
                    "
                    :maxLength="specialInstructionsMaxLength"
                    @beforeinput="onSpecialInstructionsBeforeInput"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if=" branch && branch.show_open_request_option_moo == 1" >
            <!-- MTH081: canh lề ngang bằng .card-body (1rem) để hàng title +
                 radio thẳng cột với các khối Pickup/Buyer Details -->
            <div
              class="d-flex justify-content-between align-items-center mx-3 mt-3"
            >
              <div class="title-text">
                {{ branch.open_request_title }}
              </div>
              <div class="d-flex gap-3">
                <MaterialRadio
                  :value="1"
                  class="ps-0 d-flex align-items-center mb-1"
                  v-model="isEnableOpenRequestOptionMoo"
                  name="show_open_request_option_moo"
                >
                  {{ $t('common.yes') }}
                </MaterialRadio>
                <MaterialRadio
                  :value="0"
                  class="ps-0 d-flex align-items-center mb-1"
                  v-model="isEnableOpenRequestOptionMoo"
                  name="show_open_request_option_moo"
                >
                  {{ $t('common.no') }}
                </MaterialRadio>
              </div>
            </div>
            <div class="pb-3 mx-3" style="border-bottom: 1px solid var(--theme-40, #bdbdbd)" v-if="isEnableOpenRequestOptionMoo == 1">
              <input
                maxlength="50"
                type="text"
                :placeholder="branch.open_request_placeholder_text"
                class="custom-input mt-2"
                v-model="openRequestRemark"
              />
            </div>
          </div>
          <div class="card-body" style="padding-bottom: 0px" v-if="!isOrderPayLater && !queue && branch.show_pickup_delivery_option_moo && !forcedPickupDelivery">
            <div class="cart-divider mb-3"></div>
            <div class="d-flex gap-2">
              <span
                :class="{'pickup-delivery-active': btnSelected === 1 }"
                class="pickup-delivery-btn mb-0"
                @click="selectPickup"
                style="text-transform: unset; font-size: medium;"
              >
                {{ $t('cart.pickUp') }}
              </span>
              <span
                class="pickup-delivery-btn mb-0"
                :class="{ 'pickup-delivery-active': btnSelected === 2 }"
                @click="selectDelivery"
                style="text-transform: unset; font-size: medium;"
              >
                {{ $t('cart.delivery') }}
              </span>
            </div>
          </div>
          <div class="card-body mt-0"
            v-if="
              !isOrderPayLater &&
              !queue &&
              isEnablePickup &&
              ((btnSelected == 1 && branch.show_pickup_delivery_option_moo == 1) || branch.show_pickup_delivery_option_moo != 1)
            "
          >
            <span class="text-danger d-block mb-2" v-if="branch.show_pickup_delivery_option_moo == 1">{{ branch.pickup_notes ?? '' }}</span>
            <!-- M986 follow-up: pickup minimum -->
            <div v-if="pickupMinimumOrder > 0" class="delivery-minimum mb-2" :class="{ 'delivery-minimum-met': pickupShortfall <= 0 }">
              {{ pickupShortfall > 0
                ? $t('cart.pickupMinimumShortfall', { amount: '$' + pickupShortfall.toFixed(2), minimum: '$' + pickupMinimumOrder.toFixed(2) })
                : $t('cart.pickupMinimumMet', { minimum: '$' + pickupMinimumOrder.toFixed(2) }) }}
            </div>
            <div v-if="pickupError" class="is-invalid mb-2" style="color: red;">{{ pickupError }}</div>
            <div class="title-text">{{ $t('cart.pickupDetails') }}</div>
            <div
              class="d-flex align-items-center mt-1 pb-3"
              style="border-bottom: 1px solid var(--theme-40, #bdbdbd)"
            >
              <div class="date-wrapper">
                <Datepicker
                  v-model="pickupDetails.date"
                  :enableTimePicker="false"
                  class="date-time pe-3"
                  :format="format"
                  :placeholder="$t('cart.phDate')"
                  :autoApply="true"
                  :clearable="false"
                  :min-date="new Date()"
                  :max-date="pickupMaxDate"
                />
                <span class="custom-icon">📅</span>
              </div>
              <div class="date-wrapper">
                <Datepicker
                  v-model="pickupDetails.time"
                  time-picker
                  :placeholder="$t('cart.phTime')"
                  :autoApply="true"
                  :clearable="false"
                  :min-date="isSelectedDateToday ? new Date() : null"
                />
                <span class="custom-icon">⏰</span>
              </div>
            </div>
          </div>

          <div class="card-body mt-0" v-if="!isOrderPayLater && !queue && btnSelected == 2 && branch.show_pickup_delivery_option_moo == 1">
            <!-- M986 follow-up: delivery day + slot (earliest pre-selected) and the delivery minimum. -->
            <div class="title-text">{{ $t('cart.deliveryTime') }}</div>
            <div v-if="deliveryDays.length" class="d-flex gap-2 mt-1 mb-2">
              <select class="custom-input delivery-select" v-model="deliveryDate" @change="onDeliveryDateChange">
                <option v-for="day in deliveryDays" :key="day.date" :value="day.date">{{ day.label }}</option>
              </select>
              <select class="custom-input delivery-select" v-model="deliveryTime">
                <option v-for="slot in deliverySlotsForDate" :key="slot.time" :value="slot.time">{{ slot.label }}</option>
              </select>
            </div>
            <div v-else-if="deliverySlotsLoaded" class="text-danger mt-1 mb-2">{{ $t('cart.noDeliverySlot') }}</div>
            <div v-if="deliveryMinimumOrder > 0" class="delivery-minimum mb-2" :class="{ 'delivery-minimum-met': deliveryShortfall <= 0 }">
              {{ deliveryShortfall > 0
                ? $t('cart.deliveryMinimumShortfall', { amount: '$' + deliveryShortfall.toFixed(2), minimum: '$' + deliveryMinimumOrder.toFixed(2) })
                : $t('cart.deliveryMinimumMet', { minimum: '$' + deliveryMinimumOrder.toFixed(2) }) }}
            </div>
            <div class="title-text">{{ $t('cart.deliveryAddress') }}</div>
            <div class="form-group mt-1">
              <input
                type="text"
                :placeholder="$t('cart.phPostalCode')"
                class="custom-input mt-1"
                v-model="deliveryAddress.postal_code"
                @input="lookupDeliveryAddress"
              />
              <!-- M988: the address comes from the postal code only; the customer cannot type it. -->
              <input
                type="text"
                :placeholder="$t('cart.phAddress1')"
                class="custom-input custom-input-locked mt-1"
                v-model="deliveryAddress.address_line_1"
                readonly
                tabindex="-1"
              />
              <input
                type="text"
                :placeholder="$t('cart.phAddress2')"
                class="custom-input custom-input-locked mt-1"
                v-model="deliveryAddress.address_line_2"
                readonly
                tabindex="-1"
              />
              <!-- M996: OneMap has no unit number, so the customer types it. -->
              <input
                type="text"
                :placeholder="$t('cart.phUnitNo')"
                class="custom-input mt-1"
                maxlength="30"
                v-model="deliveryAddress.unit_no"
              />
              <div v-if="isDeliveryFeeByDistance && deliveryDistanceKm !== null && deliveryFeeQuote !== null" class="delivery-fee-note mt-1">
                {{
                  freeDeliveryThresholdReached
                    ? $t('cart.deliveryFeeByDistanceFree', { distance: deliveryDistanceKm })
                    : $t('cart.deliveryFeeByDistance', { distance: deliveryDistanceKm, fee: '$' + deliveryFeeQuote.toFixed(2) })
                }}
              </div>
              <div v-else-if="isDeliveryFeeByDistance && deliveryFeeError" class="text-danger fs-14 mt-1">{{ deliveryFeeError }}</div>
              <!-- M1004 -->
              <div v-if="cbdSurcharge > 0 && deliveryFeeCartItem" class="delivery-fee-note mt-1">
                {{ $t('cart.cbdSurchargeNote', { fee: '$' + Number(cbdSurcharge).toFixed(2) }) }}
              </div>
              <div v-if="addressLookupError && !(isDeliveryFeeByDistance && deliveryFeeError)" class="text-danger fs-14 mt-1">{{ addressLookupError }}</div>
            </div>
            <template v-if="isShowDeliveryContact">
            <div class="title-text mt-1">{{ $t('cart.deliveryContact') }}</div>
            <div class="form-group mt-1 pb-3" style="border-bottom: 1px solid var(--theme-40, #bdbdbd)">
              <input
                type="text"
                :placeholder="$t('cart.phRecipient')"
                class="custom-input mt-1"
                v-model="deliveryContact.recipient_name"
              />
              <div class="custom-input-with-prefix mt-2">
                <span class="prefix">
                  <img src="https://flagcdn.com/w20/sg.png" alt="SG" /> +65
                </span>
                <input
                  type="number"
                  :placeholder="$t('cart.phPhone')"
                  class="input-prefix"
                  v-model="deliveryContact.recipient_phone"
                />
              </div>
            </div>
            </template>
            <div v-if="deliveryError" class="is-invalid mt-2" style="color: red;">{{ deliveryError }}</div>
          </div>
          <div class="card-body" style="padding-bottom: 0px" v-if="!isOrderPayLater && !queue && isEnableContact">
            <div class="title-text">{{ $t('cart.buyerDetails') }}</div>
            <div class="form-group mt-1">
              <input
                :disabled="isLogined && contactDetails.name != null && contactDetails.name != ''"
                type="text"
                :placeholder="$t('cart.phNameAlias')"
                class="custom-input mt-1"
                v-model="contactDetails.name"
              />
              <div v-if="contactFieldRequired.name" class="is-invalid" style="color: red;">{{ $t('cart.fieldRequired') }}</div>

              <div class="custom-input-with-prefix mt-2">
                <span class="prefix">
                  <img src="https://flagcdn.com/w20/sg.png" alt="SG" /> +65
                </span>
                <input
                  :disabled="isLogined && contactDetails.phone != null && contactDetails.phone != ''"
                  type="number"
                  :placeholder="$t('cart.phPhone')"
                  class="input-prefix"
                  v-model="contactDetails.phone"
                />
              </div>
              <div v-if="contactFieldRequired.phone" class="is-invalid" style="color: red;">{{ contactDetails.phone ? 'Invalid phone number' : 'This field is required' }}</div>

              <input
                :disabled="isLogined && contactDetails.email != null && contactDetails.email != ''"
                type="email"
                :placeholder="$t('cart.phEmail')"
                class="custom-input mt-2"
                v-model="contactDetails.email"
              />
            </div>
          </div>
          <!-- Terms and Conditions Checkbox -->
          <div class="card-body my-3" style="padding-top: 0px; padding-bottom: 0px" v-if="!queue && checkTrimLength(branch.terms_conditions)">
            <div class="cart-divider mb-3"></div>
            <div class="d-flex align-items-center justify-content-center">
              <input
                type="checkbox"
                id="termsCheckbox"
                v-model="agreeToTerms"
                class="form-check-input me-2"
                style="
                  width: 18px;
                  height: 18px;
                "
              />
              <label class="form-check-label" style="color: black; font-size: 14px; cursor: pointer;" @click="openTermsModal">
                {{ $t('cart.agreeTerms') }}
              </label>
            </div>
          </div>
          <div
            class="card-body pb-0"
            v-if="!isOrderPayLater && !queue"
          >
            <div class="flex-container" v-if="paymentMode == ALLINPAY || paymentMode == QLUB || branch.allow_creditcard || branch.allow_paynow">
              <div class="inline-flex-container">
                <div class="title-text" style="font-size: 15px">
                  {{ $t('cart.paymentMethods') }}
                </div>
              </div>
            </div>
            <div>
              <div
                v-if="isLogined && branch.allow_ewallet"
                class="flex-container pay-method-row"
                :class="{ 'pay-method-row--active': selectPaymentMethod == 1 }"
                @click="selectInputMintyWallet"
              >
                <div class="inline-flex-container">
                  <span
                    class="material-icons color-green md-30"
                    style="width: 30px"
                    >monetization_on</span
                  >
                  <div class="text-container">
                    E-Wallet (Balance:
                    {{
                      memberInfo && memberInfo.amount_in_account_format
                        ? memberInfo.amount_in_account_format
                        : "$ 0.00"
                    }})
                    <span
                      v-if="disablePayWithMintyWallet"
                      style="font-size: 11px; color: red"
                      >insufficient</span
                    >
                    <div v-if="memberInfo" style="color: var(--color)">
                      Logged in as {{ memberInfo.name ? memberInfo.name : "" }}
                      {{ memberInfo.last_name ? memberInfo.last_name : "" }}
                    </div>
                  </div>
                  <div
                    v-if="
                      isCheckMerchantConnectedStripe === true &&
                      memberPermissions.includes('Top-up') &&
                      isLogined &&
                      memberInfo &&
                      Number(Number(memberInfo.amount_in_account).toFixed(2)) <
                        Number(finalTotal())
                    "
                  >
                    <span
                      style="font-size: 20px"
                      v-if="openBoxMintyWallet"
                      class="material-icons color-green md-30"
                      @click="handleOpenBoxMintyWallet"
                      >keyboard_arrow_up</span
                    >
                    <span
                      style="font-size: 20px"
                      v-else
                      class="material-icons color-green md-30"
                      @click="handleOpenBoxMintyWallet"
                      >keyboard_arrow_down</span
                    >
                  </div>
                </div>
                <div>
                  <div class="inline-flex-container gap-container">
                    <div class="mt-3 mb-3 inline-flex-container gap-container">
                      <input
                        @click="selectInputMintyWallet"
                        :disabled="disablePayWithMintyWallet"
                        id="paymentMethodMintyWalletInput"
                        v-model="selectPaymentMethod"
                        value="1"
                        class="radio-input"
                        type="radio"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-container" v-if="promotionalTopupList.length && finalTotal() > 0">
              <div style="width: 10%"></div>
              <div style="width: 90%">
                <div
                  v-for="(promotionalTopup, index) in promotionalTopupList"
                  :key="index"
                  class="inline-flex-container gap-container margin-top-text pe-2"
                >
                  <div
                    @click="openModalConfirmPromotionalTopup(promotionalTopup)"
                    class="voucher-container"
                  >
                    <div class="inline-flex-container align-items-center">
                      <img
                        src="../assets/img/my-cart/minty_wallet.png"
                        alt="minty_wallet"
                        class="wallet-icon"
                      />
                      <div class="white-bold-text" style="font-size: 16px">
                        {{
                          "x" +
                          promotionalTopup.payment_amount +
                          " top-up and your payment’s totally free"
                        }}
                      </div>
                    </div>
                    <div class="padding-container">
                      <div class="voucher-text">
                        Payment Amount: ${{
                          parseFloat(
                            finalTotal() * promotionalTopup.payment_amount
                          ).toFixed(2)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex-container"
              v-if="
                branch.allow_ewallet &&
                isCheckMerchantConnectedStripe === true &&
                memberPermissions.includes('Top-up') &&
                isLogined &&
                openBoxMintyWallet &&
                memberInfo &&
                Number(Number(memberInfo.amount_in_account).toFixed(2)) <
                  Number(finalTotal())
              "
            >
              <div style="width: 10%"></div>
              <div style="width: 90%">
                <!-- <div class="not-enough-text">(Not enough to pay)</div> -->
                <div
                  v-for="(item, index) in topupList"
                  :key="index"
                  class="inline-flex-container gap-container margin-top-text"
                  style="height: auto; width: 60%; text-align: left"
                >
                  <div
                    @click="openModalConfirmTopup(item)"
                    class="voucher-container"
                  >
                    <div class="inline-flex-container align-items-center">
                      <img
                        src="../assets/img/my-cart/minty_wallet.png"
                        alt="minty_wallet"
                        class="wallet-icon"
                      />
                      <div class="white-bold-text">{{ item.topup_name }}</div>
                    </div>
                    <div class="padding-container">
                      <div class="voucher-text">
                        Get ${{ Number(item.payment_amount).toFixed(2) }}
                        {{
                          item.bonus_amount && item.bonus_amount > 0
                            ? " + $" + Number(item.bonus_amount).toFixed(2)
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex-container pay-method-row"
              :class="{ 'pay-method-row--active': selectPaymentMethod == 2 }"
              @click="selectInputStripe"
              v-if="paymentMode"
            >
              <div class="inline-flex-container" v-if="paymentMode == ALLINPAY">
                <div class="icon-container">
                  <img src="@/assets/paynow.png" style="height:15px; width: auto;" alt="error" />
                </div>
              </div>
              <div class="inline-flex-container" v-else-if="paymentMode == QLUB && !branch.allow_creditcard && !branch.allow_paynow">
                <div class="icon-container">
                  <img src="@/assets/card.png" style="height:40px; width: auto;" alt="error" />
                </div>
              </div>
              <div class="inline-flex-container" v-else>
                <div class="icon-container">
                  <img v-if="branch.allow_creditcard" src="@/assets/card.png" style="height:40px; width: auto;" alt="error" />
                  <div v-if="branch.allow_creditcard && branch.allow_paynow" class="ms-2 me-2"> | </div>
                  <img v-if="branch.allow_paynow" src="@/assets/paynow.png" style="height:15px; width: auto;" alt="error" />
                </div>
              </div>
              <div v-if="paymentMode == ALLINPAY || paymentMode == QLUB || branch.allow_creditcard || branch.allow_paynow">
                <div class="mt-3 mb-3">
                  <input
                    @click="selectInputStripe"
                    id="paymentMethodStripeInput"
                    v-model="selectPaymentMethod"
                    value="2"
                    class="radio-input"
                    type="radio"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- <hr /> -->
          <div class="card-body" v-if="!queue">
            <div
              v-if="isCanPay == 0"
              style="color: red; font-weight: bold; margin-bottom: 5px"
            >
              {{ $t('cart.removeNotAvailable') }}
            </div>
            <div
              style="margin-bottom: 30px"
              v-if="
                display_special_request_in_pos == '1' ||
                display_special_request_in_pos == '2' ||
                display_special_request_in_pos == 1 ||
                display_special_request_in_pos == 2
              "
            >
              <div>{{ $t('cart.specialRequests') }}</div>
              <div>{{ $t('cart.howWouldYouLike') }}</div>
              <div
                style="margin-top: 10px; display: flex; gap: 10px"
                @click="selectNonSpicy"
              >
                <input
                  id="non-spicy"
                  v-model="selectSpicyValue"
                  value="不辣 Non-Spicy"
                  class="radio-input"
                  type="radio"
                />
                <div>不辣 Non-Spicy</div>
              </div>
              <div
                style="margin-top: 5px; display: flex; gap: 10px"
                @click="selectSpicy"
              >
                <input
                  id="spicy"
                  v-model="selectSpicyValue"
                  value="辣 Spicy"
                  class="radio-input"
                  type="radio"
                />
                <div>辣 Spicy</div>
              </div>
            </div>
            <SubmitOrderBar
              :label="isOrderPayLater ? $t('cart.submitOrderPayLater') : $t('cart.submitOrder')"
              :waiting-label="$t('cart.waitingTimeLabel')"
              :waiting-time="waitingTimeText"
              :disabled="payDisabled"
              :loading="payLoad"
              @submit="reloadOrder(1)"
            />
          </div>
          <div v-else style="margin-top: 10px; text-align: center">
            Powered by Minty™
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success' || snackbar === 'warning'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive || loaderActivePayTopUp" />
    <!-- MTH075: a guest tapping Apply Voucher gets the same card the Rewards
         tab shows, instead of the older ModalNotificationSignIn. Dismissing
         only closes it — unlike the Rewards tab, the guest stays on the cart. -->
    <GuestRewardPrompt
      :show="showGuestPrompt"
      @signin="gotoSignInFromGuestPrompt()"
      @dismiss="showGuestPrompt = false"
    />
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-notes-modal"
        data-bs-toggle="modal"
        data-bs-target="#modalShowNotes"
      ></button>
      <div
        class="modal fade"
        id="modalShowNotes"
        tabindex="-1"
        aria-labelledby="modalShowNotes"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <material-textarea
                rows="12"
                v-model="notes"
                id="notes"
                name="notes"
                :placeholder="$t('cart.phSpecialRequest')"
              />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success btn-close-modal btn-sm"
                data-bs-dismiss="modal"
                style="
                  color: white !important;
                  background: var(--color) !important;
                  border-radius: 10px !important;
                "
              >
                {{ $t('common.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-confirm-topup-modal"
        data-bs-toggle="modal"
        data-bs-target="#modalConfirmTopup"
      ></button>
      <div
        class="modal fade"
        id="modalConfirmTopup"
        tabindex="-1"
        aria-labelledby="modalConfirmTopup"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header" style="">{{ $t('cart.topUpWallet') }}</div>
            <div class="modal-body">
              <div v-if="topupCurrentlyHandle">
                Top Up Amount: ${{
                  Number(topupCurrentlyHandle.topup_amount).toFixed(2)
                }}
              </div>
              <div
                v-if="
                  topupCurrentlyHandle &&
                  topupCurrentlyHandle.bonus_amount &&
                  topupCurrentlyHandle.bonus_amount > 0
                "
              >
                Bonus Amount: ${{
                  Number(topupCurrentlyHandle.bonus_amount).toFixed(2)
                }}
              </div>
              <div v-if="topupCurrentlyHandle">
                Payment Amount: ${{
                  Number(topupCurrentlyHandle.payment_amount).toFixed(2)
                }}
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-close-confirm-topup-modal btn-sm"
                data-bs-dismiss="modal"
                style="
                  color: white !important;
                  background: gray !important;
                  border-radius: 10px !important;
                "
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                @click="
                  topupCurrentlyHandle && topupCurrentlyHandle.promotion_type
                    ? reloadOrder(1, 1)
                    : processPaymentTopUp()
                "
                type="button"
                class="btn btn-sm"
                style="
                  color: white !important;
                  background: var(--color) !important;
                  border-radius: 10px !important;
                "
              >
                {{ $t('cart.pay') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-timeout-order-modal"
        data-bs-toggle="modal"
        data-bs-target="#modalTimeOutOrder"
      ></button>
      <div
        class="modal fade"
        id="modalTimeOutOrder"
        tabindex="-1"
        aria-labelledby="modalTimeOutOrder"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div>
                {{ $t('cart.submissionFailed') }}
              </div>
            </div>
            <div class="modal-footer">
              <button
                @click="closedModalOrderFail()"
                type="button"
                class="btn btn-sm"
                style="
                  color: white !important;
                  background: var(--color) !important;
                  border-radius: 10px !important;
                "
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalPromoCodeMOO @apply-promo-code="handleApplyPromoCode" />

    <!-- Terms and Conditions Modal -->
    <div>
      <button
        style="display: none"
        type="button"
        class="btn-terms-modal"
        data-bs-toggle="modal"
        data-bs-target="#modalTermsConditions"
      ></button>
      <div
        class="modal fade"
        id="modalTermsConditions"
        tabindex="-1"
        aria-labelledby="modalTermsConditions"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-center">
              <h5 class="modal-title">{{ $t('cart.termsTitle') }}</h5>
            </div>
            <div class="modal-body" style="max-height: 500px; overflow-y: auto;">
              <div v-html="branch.terms_conditions"></div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-secondary mb-0"
                data-bs-dismiss="modal"
                style="background-color: var(--color) !important; color: #fff !important;"
              >
                {{ $t('common.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalNotification :message="txtNotification" :theme2="true" />
  <ModalPricesUpdated ref="pricesUpdatedModal" :items="pricesUpdatedLines" />
  <ModalConfirm
    :message="pendingDiningOption ? diningOptionConfirmMessage : 'Some item prices in your cart have changed. Press Yes to clear your cart and reload the latest prices, or No to keep your current cart.'"
    :process-yes="pendingDiningOption ? confirmDiningOptionChange : clearCartOnPriceMismatch"
    :theme2="true"
  />
  <ModalNotificationSignIn :message="$t('cart.loginToUseVoucher')" />
  <ModalNotificationOutStockItems :itemSelect="itemSelect" :theme2="true" />
  <ModalSelectDiningOption
    :diningLocation="diningLocation"
    :selectDiningOption="changeDiningOption"
    :isKiosk="false"
  />
  <ModalCustomization
    :categoryId="categoryIdSelect"
    :itemId="itemIdSelect"
    :itemDetail="itemDetail"
    :isLogined="isLogined"
    :reloadModal="reloadModal"
    :editMode="true"
    :editItemIndex="editItemIndex"
    @clear-data-item="clearDataItem"
    @item-updated="handleItemUpdated"
  />
</template>

<script>
import MaterialAlert from "@/components/MaterialAlert.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import PromocodeService from "../services/promocode.service";
import OrderService from "../services/order.service";
import { applyCartPrices, carryRepricedLines } from "@/config/cartPrices";
import AllinpayService from "../services/allinpay.service";
import AirwallexService from "../services/airwallex.service";
import AuthService from "../services/auth.service";
import SlideService from "../services/slide.service";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import ModalNotification from "@/components/ModalNotification.vue";
import ModalPricesUpdated from "@/components/ModalPricesUpdated.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalNotificationSignIn from "@/components/ModalNotificationSignIn.vue";
import GuestRewardPrompt from "@/components/GuestRewardPrompt.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ModalNotificationOutStockItems from "@/components/ModalNotificationOutStockItems.vue";
import ModalPromoCodeMOO from "@/components/ModalPromoCodeMOO.vue";
import EventBus from "vue3-eventbus";
import MemberService from "../services/member.service";
import { gotoMemberLogin, localStorageName, getDiningOption, getCartItemIndexesInvalidForDiningOption, scrollToFirstInvalid, clearCartIfPendingPaymentPaid, clearPendingPaymentMarker, pollTransactionPaid, redirectToPaymentSuccess, ensureMerchantId } from "@/config/utils";
import { FREE_ITEM, PERCENTAGE_OFF, FIXED_AMOUNT_OFF, DINE_IN, TAKE_AWAY, STRIPE, ALLINPAY, AIRWALLEX, QLUB, isPromoCodeError } from "@/config/const";
import { promoDiscountAmount, promoRemovedMessage, promoReasonText } from "@/config/promoCode";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import ModalSelectDiningOption from "./kiosk/components/ModalSelectDiningOption.vue";
import ModalCustomization from './ModalCustomization.vue';
import SubmitOrderBar from "@/components/SubmitOrderBar.vue";
import OrderTopBar from "@/components/OrderTopBar.vue";

import {
  collectItemNames,
  syncMenuTranslations,
  translatedName,
} from "@/i18n/menuTranslate";

// ModalNotification renders its message with v-html and centres it in bold, so
// a second sentence appended as plain text runs straight into the first. This is
// a block of its own, lighter and smaller, which reads as an explanation of the
// headline rather than part of it. Inline styles because the modal's scoped CSS
// cannot reach markup injected through v-html.
const VOUCHER_DROPPED_NOTE =
  '<div style="margin-top:12px;font-size:13.5px;font-weight:500;line-height:1.5;opacity:.8">' +
  "Your voucher was removed — it had already been locked to that order." +
  "</div>";

SwiperCore.use([Pagination, Autoplay]);

export default {
  name: "My Cart",
  components: {
    MaterialAlert,
    MaterialSnackbar,
    MaterialLoading,
    MaterialTextarea,
    MaterialRadio,
    Swiper,
    SwiperSlide,
    ModalNotification,
    ModalPricesUpdated,
    ModalConfirm,
    ModalNotificationSignIn,
    GuestRewardPrompt,
    MaterialInput,
    ModalNotificationOutStockItems,
    ModalPromoCodeMOO,
    Datepicker,
    ModalCustomization,
    SubmitOrderBar,
    OrderTopBar,
    ModalSelectDiningOption,
  },
  data() {
    return {
      snackbar: null,
      error: "",
      paymentMethod: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      cutleryChecked: true,
      memberInfo: JSON.parse(
        localStorage.getItem(localStorageName("memberInfo"), "")
      ),
      memberId: 0,
      memberPhone: null,
      memberName: null,
      showErrorName: false,
      showErrorPhone: false,
      loaderActive: false,
      myRewardData: [],
      searchKeyword: "",
      selectedItem: null,
      selectVoucher: false,
      progressPercentage: 10, // Set the initial percentage here
      progressBarColor: `linear-gradient(90deg, red 50%, gray 50%)`,
      contentTermAndCondition: "",
      selectedReward: [],
      showMessageLimitSelectedReward: "",
      isActiveCutlery: false,
      isActiveUseCashback: false,
      takeAwayOrDineIn:
        localStorage.getItem(localStorageName("DINING_OPTION")) ?? DINE_IN,
      // 0 = both dine-in/takeaway offered, 1 = takeaway only, 2 = dine-in only.
      // Prefer the value Order.vue cached from the menu API (dining_location_moo,
      // order-context-aware); if the cart was opened without visiting Order.vue
      // first, fall back to the branch-level config instead of assuming "both".
      diningLocation: (() => {
        const cached = localStorage.getItem(localStorageName("DINING_LOCATION"));
        if (cached !== null) return Number(cached);
        const branchInfo = JSON.parse(
          localStorage.getItem(localStorageName("BRANCH_INFO"), "") || "null"
        );
        return branchInfo && branchInfo.dining_location != null
          ? Number(branchInfo.dining_location)
          : 0;
      })(),
      itemSelect: [],
      popularAddOns: [],
      rewardSelect: JSON.parse(
        localStorage.getItem(localStorageName("SELECTED_REWARD"), [])
      ),
      take_away_fee: 0,
      notes: localStorage.getItem(localStorageName("ORDER_NOTES"), ""),
      // MTH057: giới hạn ký tự của ô Special Instructions — dùng chung cho
      // maxlength của input, watcher chặn cứng và nội dung thông báo.
      specialInstructionsMaxLength: 25,
      selectPaymentMethod: localStorage.getItem(
        localStorageName("PAYMENT_METHOD"),
        1
      ),
      disablePayWithMintyWallet: false,
      openBoxMintyWallet: true,
      totalVoucherDiscount: 0,
      voucher_deducted_format: "",
      voucher_deducted: "",
      isLogined: false,
      isYourFriendLogined: false,
      slides: [],
      isCanPay: 1,
      cartName: "ORDER_INFO",
      // Dining option the customer picked in the cart while holding items whose
      // modifiers only apply to the other option; applied once they confirm.
      pendingDiningOption: null,
      txtNotification: "",
      // Price Schedules: lines just repriced by onCartPriceMismatch, highlighted until the
      // guest leaves the cart (screen state only, never saved with the cart).
      repricedLines: [],
      pricesUpdatedLines: [],
      lastReloadPriceChanges: 0,
      MERCHANT_BRAND_NAME: "",
      isSaveOrder: false,
      cartFormStorageKey: null,
      messageErrorVoucher: "",
      payLoad: false,
      merchantCode: "",
      branchCode: "",
      pathType: "",
      tableCode: "",
      // MTH090: voucher this pay-later table session is locked to (null until fetched).
      tableVoucherLock: null,
      tableInfo: null,
      isOrderPayLater: false,
      // MTH075: drives the shared guest reward prompt
      showGuestPrompt: false,
      guest: localStorage.getItem(localStorageName("NUMBER_OF_GUESTS"), 0),
      showCartUpdatedAfterClearItemsOutStock: false,
      topupList: [],
      promotionalTopupList: [],
      topupCurrentlyHandle: null,
      memberPermissions: [],
      isCheckMerchantConnectedStripe: false,
      loaderActivePayTopUp: false,
      date_time_send_to_megapos: null,
      intervalId: null,
      timeoutId: null,
      stopOrdering: 0,
      selectSpicyValue: "不辣 Non-Spicy",
      display_special_request_in_pos: localStorage.getItem(
        localStorageName("DISPLAY_SPECIAL_REQUEST_IN_POS"),
        ""
      ),
      allow_payment_by_minty_wallet: localStorage.getItem(
        localStorageName("ALLOW_PAYMENT_BY_MINTY_WALLET"),
        ""
      ),
      allow_show_apply_voucher: localStorage.getItem(
        localStorageName("ALLOW_SHOW_APPLY_VOUCHER"),
        ""
      ),
      default_payment_method_name: localStorage.getItem(
        localStorageName("DEFAULT_PAYMENT_METHOD_NAME"),
        "Credit/Debit Card"
      ),
      accept_payment_on_moo: true,
      isPaying: false,
      queue: false,
      itemVoucherApplied: [],
      freeItem: FREE_ITEM,
      // Promo code properties
      promoCodeApplied: null,
      isPromoCodeApplied: false,
      DINE_IN: DINE_IN,
      TAKE_AWAY: TAKE_AWAY,
      isEnablePickup: true,
      isEnableContact: true,
      contactFieldRequired: {
        name: false,
        phone: false
      },
      pickupDetails: {
        date: new Date(),
        time: new Date(),
      },
      contactDetails: {
        name: null,
        phone: null,
        email: null,
      },
      // Terms and conditions
      agreeToTerms: false,
      termsContent: '',
      isEnableOpenRequestOptionMoo: 0,
      openRequestRemark: '',
      paymentMode: 0,
      STRIPE,
      ALLINPAY,
      AIRWALLEX,
      QLUB,
      categoryIdSelect: 0,
      itemIdSelect: 0,
      itemDetail: {},
      reloadModal: 'reload-item-detail',
      editItemIndex: -1,
      btnSelected: 1, // 1: Pickup, 2: Delivery
      // M986 follow-up: delivery days/slots from order/delivery-slots, the picked slot,
      // the delivery minimum and the inline error shown when Pay is blocked.
      deliveryDays: [],
      deliverySlotsLoaded: false,
      deliveryDate: "",
      deliveryTime: "",
      deliveryMinimumOrder: 0,
      deliveryError: "",
      // M986 follow-up: by-distance delivery fee for the postal code typed (null = not priced yet).
      deliveryFeeQuote: null,
      deliveryDistanceKm: null,
      deliveryFeeError: "",
      // M1004: CBD surcharge for the delivery postal code (0 outside the CBD / own delivery).
      cbdSurcharge: 0,
      // M988: shown when the postal code typed has no address on OneMap.
      addressLookupError: "",
      pickupError: "",
      deliveryAddress: {
        address_line_1: null,
        address_line_2: null,
        postal_code: null,
        // M996: typed by the customer; sent inside address_line_2.
        unit_no: null,
      },
      deliveryContact: {
        recipient_name: null,
        recipient_phone: null,
      },
      isEnableBcrs: 0
    };
  },
  mounted() {
    $(".modal-backdrop.fade.show").remove();

    const cancel = this.$route.query.cancel ?? false;
    const stripeId = this.$route.query.stripe_id ?? null;
    const airwallexIntentId = this.$route.query.airwallex_intent_id ?? null;
    const isQlubReturn = this.$route.query.qlub ?? null;
    const paidTransactionId = this.$route.query.transaction_id ?? null;

    if (cancel) {
      // Clear right away so a later reload of this same tab doesn't re-trigger handling
      // for a stale, already-resolved payment attempt.
      this.$router.replace({ query: {} });
    }

    if (cancel && stripeId && paidTransactionId) {
      // Apple Pay / PayNow can return the customer to the cancel_url even when the
      // payment actually succeeded on Stripe. Verify the real session status before
      // treating this as a cancellation, and forward to the success page if paid.
      this.showLoader();
      OrderService.checkCheckoutSessionStripe({ stripe_id: stripeId }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            redirectToPaymentSuccess(this.$store.state.branchCode, paidTransactionId, {
              tableInfo: this.tableInfo,
              tableCode: this.tableCode,
              extraQuery: "stripe_id=" + stripeId,
            });
          } else {
            this.hideLoader();
            this.txtNotification =
              "Payment is cancelled" +
              (this.dropVoucherAfterCancelledPayment() ? VOUCHER_DROPPED_NOTE : "");
            $(".btn-notification-modal").click();
            // Confirmed not paid - stop re-checking this transaction on future visits.
            clearPendingPaymentMarker();
          }
        },
        () => {
          // Couldn't reach Stripe to verify (network/timeout) - do NOT assume cancelled,
          // since the customer may already have been charged. Fall back to checking our
          // own order records before letting them retry payment.
          this.confirmCancelledOrRedirectIfPaid("stripe_id=" + stripeId, paidTransactionId);
        }
      );
    } else if (cancel && airwallexIntentId && paidTransactionId) {
      // Same check for the Airwallex HPP. check-hpp also cancels the intent when it
      // is still unpaid, so the abandoned HPP link can no longer take a payment.
      this.showLoader();
      OrderService.checkHppAirwallex({
        payment_intent_id: airwallexIntentId,
        transaction_id: paidTransactionId,
        cancel_if_unpaid: 1,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            redirectToPaymentSuccess(this.$store.state.branchCode, paidTransactionId, {
              tableInfo: this.tableInfo,
              tableCode: this.tableCode,
              extraQuery: "airwallex_intent_id=" + airwallexIntentId,
            });
          } else {
            this.hideLoader();
            this.txtNotification =
              "Payment is cancelled" +
              (this.dropVoucherAfterCancelledPayment() ? VOUCHER_DROPPED_NOTE : "");
            $(".btn-notification-modal").click();
            clearPendingPaymentMarker();
          }
        },
        () => {
          this.confirmCancelledOrRedirectIfPaid("airwallex_intent_id=" + airwallexIntentId, paidTransactionId);
        }
      );
    } else if (cancel && isQlubReturn && paidTransactionId) {
      // Qlub has no status API for us to ask: only its Close Order call marks the
      // order paid, so check our own order before calling this a cancellation.
      this.showLoader();
      this.confirmCancelledOrRedirectIfPaid("qlub=1", paidTransactionId);
    } else if (cancel) {
      this.txtNotification =
        "Payment is cancelled" +
        (this.dropVoucherAfterCancelledPayment() ? VOUCHER_DROPPED_NOTE : "");
      $(".btn-notification-modal").click();
      clearPendingPaymentMarker();
    }

    EventBus.on("ClearItemsOutStockSuccess", async () => {
      this.isCanPay = 1;
      this.showCartUpdatedAfterClearItemsOutStock = true;
      this.itemSelect = JSON.parse(localStorage.getItem(this.cartName, []));
      this.syncCartNames();

      this.cleanupDeliveryFeeItemIfInvalid();

      if (this.memberInfo && this.memberInfo.amount_in_account && this.branch.allow_ewallet) {
        var amount_in_account = Number(this.memberInfo.amount_in_account);

        if (Number(amount_in_account.toFixed(2)) < Number(this.finalTotal())) {
          this.selectPaymentMethod = 2;
          this.disablePayWithMintyWallet = true;
        } else {
          this.selectPaymentMethod = 1;
          this.disablePayWithMintyWallet = false;
        }

        localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
        localStorage.setItem(
          localStorageName("PAYMENT_METHOD"),
          this.selectPaymentMethod
        );
      }
    });

    // Back/forward navigation (e.g. hitting "back" after a reload/connection loss
    // stranded the customer on a blank page mid-checkout) can restore this page from
    // the browser's bfcache instead of reloading it - created()/mounted() do not run
    // again in that case, so re-check pending payment status explicitly.
    window.addEventListener("pageshow", this.handlePageShow);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.clearIsEditQuantity());
    window.removeEventListener("pageshow", this.handlePageShow);
  },
  async created() {
    this.cartName = await this.$store.dispatch("cartName");
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    await ensureMerchantId(this.branchCode);
    this.getPopularAddOns();

    this.cartFormStorageKey = localStorageName(`CART_FORM_STATE_${this.cartName}`);
    this.restoreCartFormState();
    if (this.forcedPickupDelivery) {
      this.btnSelected = this.forcedPickupDelivery;
    }
    if (this.branch && this.branch.show_pickup_delivery_option_moo == 1 && this.btnSelected == 2) {
      this.loadDeliverySlots();
      this.loadDeliveryFee();
    }
    this.pathType = this.$route.params.type;
    this.tableCode = this.$route.params.table_code;
    this.tableInfo = JSON.parse(
      localStorage.getItem(
        "table_" +
          this.merchantCode.toLowerCase() +
          "_" +
          this.branchCode.toLowerCase() +
          "_" +
          this.tableCode.toLowerCase(),
        null
      )
    );
    this.queue = this.$route.query.queue ?? false;
    this.isEnablePickup = this.branch.show_pickup_details ?? false;
    this.isEnableContact = this.branch.show_contact_details ?? false;
    this.isEnableBcrs = parseInt(this.branch?.enable_bcrs) ?? 0;

    if (this.queue) {
      this.cartName = this.cartName.replace("ORDER_INFO_", "ORDER_QUEUE_INFO_");
    }

    if (this.tableInfo) {
      this.accept_payment_on_moo =
        this.tableInfo.accept_payment_on_moo ?? false;

      if (this.tableInfo.stripe_connect) {
        this.isOrderPayLater = false;
      } else {
        this.isYourFriendLogined = this.queue
          ? false
          : this.tableInfo.is_member_order ?? false;
        this.isOrderPayLater = true;
      }
    } else {
      this.isOrderPayLater = false;
    }
    this.itemSelect = JSON.parse(localStorage.getItem(this.cartName, []));
    this.syncCartNames();

    this.cleanupDeliveryFeeItemIfInvalid();
    this.syncDeliveryFeeItem();
    localStorage.removeItem(localStorageName("ORDER_NOTES"));
    localStorage.removeItem(localStorageName("PAYMENT_METHOD"));

    // Runs in the background - only acts (clears cart + redirects) if it actually finds
    // a confirmed-paid pending transaction, which is the rare case. Deliberately not
    // awaited: the cart above should render immediately, not wait on this network poll.
    this.checkPendingPaymentAndRefreshCart();

    if (this.memberInfo || this.isYourFriendLogined) {
      if (this.memberInfo) {

        this.contactDetails.name = this.memberInfo.name ?? null;
        this.contactDetails.phone = this.memberInfo.phone_number ?? null;
        this.contactDetails.email = this.memberInfo.email ?? null;
        this.memberId = this.memberInfo.id ?? 0;
      }
      this.isLogined = true;

      // Ensure member details take precedence over any restored localStorage data
      this.persistCartFormState();
    }

    // Load promo code from localStorage if exists
    const savedPromoCode = localStorage.getItem(
      localStorageName("PROMO_CODE_APPLIED")
    );
    if (savedPromoCode) {
      try {
        const promoData = JSON.parse(savedPromoCode);
        // Keep the saved code on the cart, then re-validate it: a code that can no longer be
        // used is dropped with a modal saying why, any other failure leaves it as it is.
        // Runs after the cart and the member are loaded: check-promo-code needs the items
        // (report-group promos), their total and the member (member prices).
        this.promoCodeApplied = promoData;
        this.isPromoCodeApplied = true;
        this.handleApplyPromoCode(promoData.promo_code, true);
      } catch (error) {
        console.error("Error parsing saved promo code");
        // Clear invalid data
        localStorage.removeItem(localStorageName("PROMO_CODE_APPLIED"));
      }
    }

    this.getMemberInfo();
    this.getSlides();
    this.reloadOrder();
    this.checkMemberPermissions();

    if (!this.isOrderPayLater) {
      this.getTopupList();
    }

    this.getTableVoucherLock();
  },
  computed: {
    diningOptionConfirmMessage() {
      const option = this.pendingDiningOption == DINE_IN ? this.$t('cart.dineIn') : this.$t('cart.takeAway');
      const count = getCartItemIndexesInvalidForDiningOption(this.itemSelect, this.pendingDiningOption).length;
      return this.$t('cart.diningOptionRemoveItems', { count, option });
    },
    // Switching dine-in/takeaway from the cart is only offered when the branch
    // has the feature on AND lets the customer pick either option — dining_location
    // 0 = both, 1 = takeaway only, 2 = dine-in only (matches ModalSelectDiningOption).
    canSwitchDiningOption() {
      return !!(
        this.branch &&
        this.branch.show_dining_option_moo &&
        this.diningLocation == 0
      );
    },
    // MTH074: pay-later carts used to reach vouchers through a small inline
    // link inside the order summary; they now use the same CTA cards as
    // pay-now carts. Pay-later keeps that link's own accept_payment_on_moo
    // gate, and deliberately skips the "hide once something is applied" gate,
    // so a pay-later cart can always re-open the voucher list. MTH076 gave
    // pay-later the full pay-now summary rows but deliberately left this
    // always-visible behaviour unchanged.
    // M1051: the Sale Channel hides member Login and Rewards (guest-only ordering).
    hideMemberLogin() {
      return !!(this.branch && this.branch.hide_member_login_moo == 1);
    },
    showVoucherCta() {
      if (this.hideMemberLogin) return false;
      const allowed =
        this.allow_show_apply_voucher == 1 || this.allow_show_apply_voucher == "1";
      if (!allowed) return false;
      if (this.isOrderPayLater) return !!this.accept_payment_on_moo;
      // MTH092: an applied voucher no longer hides the CTA — it stays as
      // "Change Voucher" so the member can swap it (the x on the card above
      // is the way to drop it). The promo-code gate is unchanged: the two
      // stay mutually exclusive.
      if (this.appliedReward) return true;
      return !this.isPromoCodeApplied;
    },
    appliedReward() {
      return this.rewardSelect && this.rewardSelect.length > 0
        ? this.rewardSelect[0]
        : null;
    },
    // MTH090: this voucher came from the table session, not from this cart — it
    // stays for the whole pay-later bill, so it can be neither removed nor
    // swapped here.
    isSessionLockedVoucher() {
      return !!(this.appliedReward && this.appliedReward.is_session_locked);
    },
    appliedRewardTitle() {
      return (
        (this.appliedReward && this.appliedReward.reward_title) ||
        this.$t("cart.appliedRewardFallback")
      );
    },
    showPromoCodeCta() {
      if (this.isOrderPayLater) return !!this.accept_payment_on_moo;
      return (
        !this.isPromoCodeApplied &&
        (!this.rewardSelect || this.rewardSelect.length === 0)
      );
    },
    // MTH105: the branch's estimated waiting time, as the backend already
    // formats it ("10 - 20 Minutes"). MerchantSettingController sends "" when
    // the branch chose "Do not display waiting time", so an empty string is the
    // signal to show nothing.
    waitingTimeText() {
      const text = (this.branch && this.branch.waiting_time_text) || "";
      // The backend enum is title-cased ("10 - 20 Minutes", "Less than 10
      // Minutes") but this label puts it mid-sentence, where lowercase reads
      // naturally. The enum itself is shared with the kiosk, PaymentSuccess and
      // the merchant portal's dropdown, so lowercase it here rather than there.
      return text.toLowerCase();
    },
    // MTH072: the pill shows the human table number, not the QR table code.
    // tableInfo is the same localStorage record Order.vue reads, so no extra
    // request is needed; fall back to the code when it has no table_no so the
    // pill never loses the table it is standing for.
    tableLabel() {
      return this.tableInfo?.table_no || this.tableCode;
    },
    styleObject() {
      const base =
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a";
      return {
        "--color": base,
        "--theme-20": this.blendWhite(base, 0.04),
        "--theme-30": this.blendWhite(base, 0.0675),
        "--theme-40": this.blendWhite(base, 0.16),
        "--moo-muted": "rgba(82, 67, 66, 0.55)",
        "--btn-color": this.$store.state.primaryButtonColorTheme2 || base,
      };
    },
    // MTH023: consolidated pay/submit disabled state (preserves the exact
    // member vs non-member conditions the inline button used).
    payDisabled() {
      const noItems = !this.itemSelect || this.itemSelect.length == 0;
      const termsBlock =
        this.checkTrimLength(this.branch.terms_conditions) && !this.agreeToTerms;
      if (this.memberInfo) {
        return Boolean(
          (this.disablePayWithMintyWallet && this.selectPaymentMethod == 1) ||
            this.messageErrorVoucher != "" ||
            Number(this.finalTotal()) < 0 ||
            noItems ||
            this.isCanPay == 0 ||
            termsBlock
        );
      }
      return Boolean(
        Number(this.totalPayable()) < 0 ||
          noItems ||
          this.isCanPay == 0 ||
          termsBlock
      );
    },
    deliverySlotsForDate() {
      const day = this.deliveryDays.find((d) => d.date === this.deliveryDate);
      return day ? day.slots : [];
    },
    // The delivery minimum is judged on the items, without the delivery fee line.
    deliveryShortfall() {
      const fee = this.deliveryFeeCartItem;
      const feeLine = fee
        ? (this.isLogined ? fee.member_price : fee.price_default) * (fee.quantity || 1) || 0
        : 0;
      return Math.max(0, this.deliveryMinimumOrder - (this.calculateTotal() - feeLine));
    },
    isDeliveryFeeByDistance() {
      return !!(this.branch && this.branch.delivery_fee_mode == 2);
    },
    cartItemQuantity() {
      return (this.itemSelect || [])
        .filter((item) => item && !item.is_delivery_fee_item)
        .reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    },
    pickupMinimumOrder() {
      return parseFloat(this.branch && this.branch.pickup_minimum_order) || 0;
    },
    // M994: Sale Channel switch; off (the default) hides the recipient block and sends no delivery_contact.
    isShowDeliveryContact() {
      return Number(this.branch && this.branch.show_delivery_contact_moo) === 1;
    },
    // M995: 1 / 2 when the Sale Channel offers only Pickup / only Delivery, 0 when the
    // customer chooses.
    forcedPickupDelivery() {
      if (!this.branch || this.branch.show_pickup_delivery_option_moo != 1) return 0;
      const mode = Number(this.branch.pickup_delivery_mode);
      return mode === 1 || mode === 2 ? mode : 0;
    },
    pickupShortfall() {
      return Math.max(0, this.pickupMinimumOrder - this.calculateTotal());
    },
    pickupMaxDate() {
      const days = parseInt(this.branch && this.branch.delivery_advance_days, 10);
      if (!Number.isFinite(days) || days < 0) return null;
      const date = new Date();
      date.setDate(date.getDate() + days);
      return date;
    },
    // M986 follow-up: what the delivery fee line adds to calculateTotal() (same price rule).
    deliveryFeeLineAmount() {
      const fee = this.deliveryFeeCartItem;
      if (!fee || !this.shouldApplyDeliveryFee()) return 0;
      const price = this.isLogined ? fee.member_price : fee.price_default;
      return (Number(price) || 0) * (Number(fee.quantity) || 0);
    },
    cartDisplayItems() {
      return (this.itemSelect || []).filter(
        (item) => !item.is_delivery_fee_item
      );
    },
    deliveryFeeCartItem() {
      return (this.itemSelect || []).find(
        (item) => item && item.is_delivery_fee_item
      );
    },
    freeDeliveryThresholdReached() {
      if (
        !this.branch ||
        this.branch.show_pickup_delivery_option_moo != 1 ||
        !this.shouldApplyDeliveryFee()
      ) {
        return false;
      }

      const threshold = parseFloat(this.branch.minimum_total_for_free_delivery_fee);

      if (!Number.isFinite(threshold) || threshold <= 0) return false;

      // Tính subtotal KHÔNG bao gồm delivery fee item
      const subtotalWithoutDelivery = (this.itemSelect || []).reduce((total, product) => {
        if (product.is_delivery_fee_item) return total;
        const price = this.isLogined
          ? (product.member_price ?? product.price_default ?? 0)
          : (product.price_default ?? 0);
        return total + price * (product.quantity ?? 0);
      }, 0);

      const netSubtotal = subtotalWithoutDelivery;
      return netSubtotal >= threshold;
    },
    effectiveDeliveryFeePrice() {
      if (!this.shouldApplyDeliveryFee() || !this.branch || !this.branch.delivery_fee_item) {
        return 0;
      }
      // M1004: the CBD surcharge is added on top, and still charged once delivery is free.
      const cbd = Number(this.cbdSurcharge) || 0;
      if (this.freeDeliveryThresholdReached) {
        return cbd;
      }
      if (this.isDeliveryFeeByDistance && this.deliveryFeeQuote !== null) {
        return Math.round((this.deliveryFeeQuote + cbd) * 100) / 100;
      }

      const priceDefault = parseFloat(this.branch.delivery_fee_item.price_default);
      const memberPrice = parseFloat(this.branch.delivery_fee_item.member_price);

      let result = 0;
      if (this.isLogined) {
        if (Number.isFinite(memberPrice)) result = memberPrice;
        else if (Number.isFinite(priceDefault)) result = priceDefault;
        else result = 0;
      } else {
        result = Number.isFinite(priceDefault) ? priceDefault : 0;
      }

      return Math.round((result + cbd) * 100) / 100;
    },
    isSelectedDateToday() {
      if (!this.pickupDetails.date) return true;

      const today = new Date();
      const selectedDate = new Date(this.pickupDetails.date);

      return (
        selectedDate.getFullYear() === today.getFullYear() &&
        selectedDate.getMonth() === today.getMonth() &&
        selectedDate.getDate() === today.getDate()
      );
    },
    totalBcrs() {
      if (!this.isEnableBcrs) return 0;

      const eachBcrsAmount = parseFloat(this.branch && this.branch.each_bcrs_amount) || 0;
      if (eachBcrsAmount <= 0) return 0;

      if (!this.itemSelect || this.itemSelect.length === 0) return 0;

      let totalQty = 0;

      this.itemSelect.forEach((item) => {
        if (!item) return;
        if (item.is_delivery_fee_item) return;

        const mainQty = parseInt(item.quantity) || 0;
        if (mainQty <= 0) return;

        // Main item
        if (parseInt(item.eligible_bcrs) === 1) {
          totalQty += mainQty;
        }

        if (item.choice) {
          // Choice item
          if (item.choice_selected && item.choice_selected.items) {
            item.choice_selected.items.forEach((itemChoice) => {
              const choiceQty = parseInt(itemChoice.qty) || 0;
              if (choiceQty <= 0) return;

              // Choice item itself
              if (
                itemChoice.item_detail &&
                parseInt(itemChoice.item_detail.eligible_bcrs) === 1
              ) {
                totalQty += choiceQty * mainQty;
              }

              // Modifier group of choice item
              if (itemChoice.item_detail && itemChoice.item_detail.modifier_group) {
                itemChoice.item_detail.modifier_group.forEach((group) => {
                  if (!group.items) return;
                  group.items.forEach((itemModifier) => {
                    const modQty = parseInt(itemModifier.quantity) || 0;

                    if (parseInt(itemModifier.eligible_bcrs) === 1) {
                      totalQty += modQty * choiceQty * mainQty;
                    }

                    // Sub modifier of modifier group of choice item
                    if (
                      itemModifier.item_in_mog &&
                      itemModifier.item_in_mog.modifier_group
                    ) {
                      itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                        if (!subGroup.items) return;
                        subGroup.items.forEach((subItemModifier) => {
                          const subModQty = parseInt(subItemModifier.quantity) || 0;
                          if (parseInt(subItemModifier.eligible_bcrs) === 1) {
                            totalQty += subModQty * modQty * choiceQty * mainQty;
                          }
                        });
                      });
                    }
                  });
                });
              }
            });
          }
        } else {
          // Modifier group of item without choice
          if (item.modifier_group) {
            item.modifier_group.forEach((group) => {
              if (!group.items) return;
              group.items.forEach((itemModifier) => {
                const modQty = parseInt(itemModifier.quantity) || 0;

                if (parseInt(itemModifier.eligible_bcrs) === 1) {
                  totalQty += modQty * mainQty;
                }

                // Sub modifier of modifier group of item without choice
                if (
                  itemModifier.item_in_mog &&
                  itemModifier.item_in_mog.modifier_group
                ) {
                  itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                    if (!subGroup.items) return;
                    subGroup.items.forEach((subItemModifier) => {
                      const subModQty = parseInt(subItemModifier.quantity) || 0;
                      if (parseInt(subItemModifier.eligible_bcrs) === 1) {
                        totalQty += subModQty * modQty * mainQty;
                      }
                    });
                  });
                }
              });
            });
          }
        }
      });

      return totalQty * eachBcrsAmount;
    },
    // SF230: branch toggle — service charge on the discounted subtotal (after
    // discount) when on, otherwise the gross subtotal (before discount).
    serviceChargeOnDiscountedSubtotal() {
      return parseInt(this.branch.service_charge_on_discounted_subtotal) === 1;
    },
  },
  methods: {
    // Item / modifier names come from the POS in the source language; this
    // returns the translation for the active locale (original on English).
    tName(source) {
      return translatedName(source);
    },

    // Translate every name in the cart (items, choices, modifiers, upsells)
    // into the locale currently active.
    syncCartNames() {
      syncMenuTranslations(
        collectItemNames([
          ...(this.itemSelect || []),
          ...(this.popularAddOns || []),
        ])
      );
    },

    blendWhite(color, ratio) {
      // Accept #rrggbb, #rgb, or rgb()/rgba() — the merchant-admin colour picker
      // may persist any of these. Only bail if we truly can't parse it.
      if (typeof color !== "string") return color;
      const s = color.trim();
      let r, g, b, m;
      if ((m = s.match(/^#([0-9a-fA-F]{6})$/))) {
        r = parseInt(m[1].slice(0, 2), 16);
        g = parseInt(m[1].slice(2, 4), 16);
        b = parseInt(m[1].slice(4, 6), 16);
      } else if ((m = s.match(/^#([0-9a-fA-F]{3})$/))) {
        r = parseInt(m[1][0] + m[1][0], 16);
        g = parseInt(m[1][1] + m[1][1], 16);
        b = parseInt(m[1][2] + m[1][2], 16);
      } else if ((m = s.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i))) {
        r = +m[1];
        g = +m[2];
        b = +m[3];
      } else {
        return color;
      }
      const mix = (c) => Math.round(ratio * c + (1 - ratio) * 255);
      const h = (v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0");
      return "#" + h(mix(r)) + h(mix(g)) + h(mix(b));
    },
    // Covers the case where the customer never made it back through the gateway's own
    // redirect at all (reload, lost connection, navigated straight back) - so there was
    // no cancel/session query param for mounted()'s block to react to, yet a payment may
    // have gone through in the meantime. Also re-run from the bfcache pageshow handler,
    // since a back/forward navigation restoring this page from cache does not re-run
    // created()/mounted() at all. Only takes any visible action (clears the cart and
    // navigates to payment-success) if it actually finds a confirmed-paid match - a no-op
    // otherwise, so it's safe to run in the background without affecting what's on screen.
    async checkPendingPaymentAndRefreshCart() {
      const paid = await clearCartIfPendingPaymentPaid(this.cartName, this.branchCode, {
        tableInfo: this.tableInfo,
        tableCode: this.tableCode,
      });

      if (paid) {
        return;
      }

      // Backing out of the gateway produces no cancel/session param for the two
      // branches in created() to react to, so this is the only place that sees
      // it. The marker surviving the call above is the signal: that helper
      // clears it on a confirmed payment and on an expired or corrupt entry, and
      // leaves it in place only when a payment was started for this cart and
      // polling says it is still unpaid.
      const pendingSurvived = !!localStorage.getItem(
        localStorageName("PENDING_PAYMENT_TXN")
      );

      if (pendingSurvived && this.dropVoucherAfterCancelledPayment()) {
        this.txtNotification = "Payment is cancelled" + VOUCHER_DROPPED_NOTE;
        $(".btn-notification-modal").click();
      }
    },
    handlePageShow(event) {
      if (event.persisted) {
        this.checkPendingPaymentAndRefreshCart();
      }
    },
    async confirmCancelledOrRedirectIfPaid(extraQuery, paidTransactionId) {
      // Read branch_code from the store directly, not this.branchCode - created() is
      // async and Vue does not await it before mounted() runs, so this.branchCode can
      // still be unset at this point.
      const branchCode = this.$store.state.branchCode;
      const isPaid = await pollTransactionPaid(branchCode, paidTransactionId, {
        maxAttempts: 5,
        delayMs: 3000,
      });

      this.hideLoader();

      if (isPaid) {
        redirectToPaymentSuccess(branchCode, paidTransactionId, {
          tableInfo: this.tableInfo,
          tableCode: this.tableCode,
          extraQuery,
        });
      } else {
        this.txtNotification =
          "We couldn't confirm your payment status. Please check your order history before paying again.";
        $(".btn-notification-modal").click();
      }
    },
    totalPayable() {
      const finalTotalNum = parseFloat(this.finalTotal()) || 0;
      const bcrsNum = parseFloat(this.totalBcrs) || 0;
      return (finalTotalNum + bcrsNum).toFixed(2);
    },
    isDeliveryFeeEnabledForBranch() {
      return (
        this.branch &&
        this.branch.show_pickup_delivery_option_moo == 1 &&
        this.branch.delivery_fee_item
      );
    },
    cleanupDeliveryFeeItemIfInvalid() {
      if (!this.isDeliveryFeeEnabledForBranch()) {
        this.removeDeliveryFeeItem();
      }
    },
    selectPickup() {
      this.btnSelected = 1;
      this.removeDeliveryFeeItem();
    },
    selectDelivery() {
      this.btnSelected = 2;
      this.addDeliveryFeeItem();
      this.loadDeliverySlots();
      this.loadDeliveryFee();
    },
    // M986 follow-up: keep the customer's slot while it is still offered, otherwise
    // fall back to the earliest one.
    loadDeliverySlots() {
      return OrderService.getDeliverySlots({ branch_code: this.$store.state.branchCode, cart_quantity: this.cartItemQuantity }).then(
        (response) => {
          this.deliverySlotsLoaded = true;
          if (!response.data.result.isSuccess) return;

          const data = response.data.data;
          this.deliveryDays = data.days || [];
          this.deliveryMinimumOrder = parseFloat(data.minimum_order) || 0;

          const stillOffered = this.deliveryDays.some(
            (d) => d.date === this.deliveryDate && d.slots.some((slot) => slot.time === this.deliveryTime)
          );
          if (!stillOffered) {
            this.deliveryDate = data.earliest ? data.earliest.date : "";
            this.deliveryTime = data.earliest ? data.earliest.time : "";
          }
        },
        () => {
          this.deliverySlotsLoaded = true;
        }
      );
    },
    // M986 follow-up: price a by-distance delivery from the postal code the customer typed.
    // M1004: also asked on a fixed fee, for the CBD surcharge; only a by-distance quote can
    // fail the delivery.
    loadDeliveryFee() {
      this.deliveryFeeError = "";
      const postalCode = String(this.deliveryAddress.postal_code || "").trim();
      if (this.btnSelected != 2) return;
      if (!/^\d{6}$/.test(postalCode)) {
        this.deliveryFeeQuote = null;
        this.deliveryDistanceKm = null;
        this.cbdSurcharge = 0;
        return;
      }

      OrderService.getDeliveryFee({
        branch_code: this.$store.state.branchCode,
        postal_code: postalCode,
        is_member: this.isLogined ? 1 : 0,
      }).then(
        (response) => {
          if (String(this.deliveryAddress.postal_code || "").trim() !== postalCode) return;
          if (response.data.result.isSuccess) {
            this.cbdSurcharge = parseFloat(response.data.data.cbd_surcharge) || 0;
            if (!this.isDeliveryFeeByDistance) return;
            this.deliveryFeeQuote = parseFloat(response.data.data.fee) || 0;
            this.deliveryDistanceKm = response.data.data.distance_km;
          } else {
            this.cbdSurcharge = 0;
            if (!this.isDeliveryFeeByDistance) return;
            this.deliveryFeeQuote = null;
            this.deliveryDistanceKm = null;
            this.deliveryFeeError = response.data.result.message;
          }
        },
        () => {
          this.cbdSurcharge = 0;
          if (this.isDeliveryFeeByDistance) this.deliveryFeeQuote = null;
        }
      );
    },
    // M988: fill in the delivery address from the postal code the customer keys in.
    // Runs on typing only, so an address restored from the saved cart form is left alone.
    // The address fields are read-only, so a changed postal code clears the old address
    // rather than leaving one the customer cannot correct.
    lookupDeliveryAddress() {
      this.addressLookupError = "";
      this.deliveryAddress.address_line_1 = null;
      this.deliveryAddress.address_line_2 = null;
      const postalCode = String(this.deliveryAddress.postal_code || "").trim();
      if (!/^\d{6}$/.test(postalCode)) return;

      OrderService.lookupAddress({ postal_code: postalCode }).then(
        (response) => {
          if (String(this.deliveryAddress.postal_code || "").trim() !== postalCode) return;
          if (response.data.result.isSuccess) {
            this.deliveryAddress.address_line_1 = response.data.data.address_line_1;
            this.deliveryAddress.address_line_2 = response.data.data.address_line_2;
          } else {
            this.addressLookupError = this.$t("cart.postalCodeNotFound", { postal: postalCode });
          }
        },
        () => {}
      );
    },
    validatePickup() {
      this.pickupError = "";
      if (this.pickupShortfall > 0) {
        this.pickupError = this.$t("cart.pickupMinimumShortfall", {
          amount: "$" + this.pickupShortfall.toFixed(2),
          minimum: "$" + this.pickupMinimumOrder.toFixed(2),
        });
        scrollToFirstInvalid();
        return false;
      }
      return true;
    },
    onDeliveryDateChange() {
      const slots = this.deliverySlotsForDate;
      this.deliveryTime = slots.length ? slots[0].time : "";
    },
    validateDelivery() {
      this.deliveryError = "";
      if (
        !(this.deliveryAddress.address_line_1 || "").trim() ||
        !/^\d{6}$/.test(String(this.deliveryAddress.postal_code || "").trim())
      ) {
        this.deliveryError = this.$t("cart.deliveryAddressRequired");
      } else if (this.isDeliveryFeeByDistance && this.deliveryFeeQuote === null) {
        this.deliveryError = this.deliveryFeeError || this.$t("cart.deliveryFeePending");
      } else if (!this.deliveryDate || !this.deliveryTime) {
        this.deliveryError = this.$t("cart.deliverySlotRequired");
      } else if (this.deliveryShortfall > 0) {
        this.deliveryError = this.$t("cart.deliveryMinimumShortfall", {
          amount: "$" + this.deliveryShortfall.toFixed(2),
          minimum: "$" + this.deliveryMinimumOrder.toFixed(2),
        });
      }

      if (this.deliveryError) {
        scrollToFirstInvalid();
        return false;
      }
      return true;
    },
    syncDeliveryFeeItem() {
      if (this.btnSelected === 2) {
        if (this.shouldApplyDeliveryFee() && this.branch && this.branch.delivery_fee_item) {
          const hasFee = (this.itemSelect || []).some((it) => it && it.is_delivery_fee_item);
          if (!hasFee) {
            this.addDeliveryFeeItem();
          }
        }
      } else {
        const hasFee = (this.itemSelect || []).some((it) => it && it.is_delivery_fee_item);
        if (hasFee) {
          this.removeDeliveryFeeItem();
        }
      }
    },
    addDeliveryFeeItem() {
      // Guard conditions
      if (!this.shouldApplyDeliveryFee() || !this.branch.delivery_fee_item) return;

      // Remove existing delivery fee item to avoid duplicates
      this.itemSelect = (this.itemSelect || []).filter(
        (it) => !it.is_delivery_fee_item
      );

      const fee = Number(this.effectiveDeliveryFeePrice);
      const priceDefault = fee;
      const memberPrice = fee;

      const deliveryItem = {
        ...this.branch.delivery_fee_item,
        id: this.branch.delivery_fee_item.id ?? "delivery_fee",
        item_name:
          this.branch.delivery_fee_item.item_name ?? "Delivery Fee",
        description:
          this.branch.delivery_fee_item.description ??
          this.branch.delivery_fee_item.item_name ??
          "Delivery Fee",
        price_default: priceDefault,
        member_price: memberPrice,
        // M986 follow-up: the order detail reads these - keep them on the fee actually charged.
        price_default_no_modifier_option: priceDefault,
        member_price_no_modifier_option: memberPrice,
        quantity: 1,
        is_delivery_fee_item: true,
        is_free_item: false,
        modifier_group: [],
        modifier_group_full: [],
        choice: false,
        choice_selected: null,
        source: "delivery_fee",
        category_id: this.branch.delivery_fee_item.category_id ?? 0,
      };

      this.itemSelect.push(deliveryItem);
      this.updateCartOrder();
    },
    removeDeliveryFeeItem() {
      const before = this.itemSelect ? this.itemSelect.length : 0;
      this.itemSelect = (this.itemSelect || []).filter(
        (it) => !it.is_delivery_fee_item
      );
      // Update storage only when something changed to avoid needless writes
      if (this.itemSelect && this.itemSelect.length !== before) {
        this.updateCartOrder();
      }
    },
    checkTrimLength(value) {
      return value && value.trim().length > 0;
    },
    formatPrice(price) {
      return "$ " + parseFloat(price).toFixed(2);
    },
    // MTH102: round money half-up to the cent, the way the backend's PHP
    // round() does. `.toFixed(2)` rounds a .5 cent DOWN (0.175 -> "0.17"),
    // so a percentage discount shown here would undercut the booked one.
    roundMoney(value) {
      return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    },

    // MTH104 step 1: the part of the voucher that fits on the items. Everything
    // priced off the subtotal — the service charge base, the GST base — is built
    // from this, so a voucher worth more than the cart can no longer drive them
    // below zero and have the negative figures stored on the transaction.
    itemVoucherDiscount() {
      const raw = Number(this.totalVoucherDiscount) || 0;
      if (raw <= 0) return 0;
      return this.roundMoney(Math.min(raw, this.calculateTotal()));
    },

    // MTH104 step 2: once the items are free, whatever the voucher still has
    // left absorbs the fees. Capping at the subtotal alone would leave the
    // member paying a service charge they do not pay today.
    feeVoucherDiscount() {
      const remainder =
        (Number(this.totalVoucherDiscount) || 0) - this.itemVoucherDiscount();
      if (remainder <= 0) return 0;
      return this.roundMoney(
        Math.min(remainder, this.calculateTotalAfterGST())
      );
    },

    // MTH104: the two steps together — what the summary shows and what checkout
    // is told, never more than the bill was worth.
    appliedVoucherDiscount() {
      return this.roundMoney(
        this.itemVoucherDiscount() + this.feeVoucherDiscount()
      );
    },

    // MTH104: the summary keeps showing the real service charge and GST — the
    // voucher row is what absorbs them, so Subtotal - Voucher + SC + GST still
    // adds up to Bill Total. Scaling the fee rows down as well would subtract
    // the fees twice on screen. What gets STORED as tax is scaled to the amount
    // actually charged, and that is decided by the backend (MTH104 in the API).
    format(date) {
      const getDay = String(date.getDate());
      const day = getDay.padStart(2, "0");
      const getMonth = String(date.getMonth() + 1);
      const month = getMonth.padStart(2, "0");
      const year = String(date.getFullYear());
      return `${day}/${month}/${year}`;
    },
    formatTime(input) {
      if (!input) return "00:00";

      if (typeof input === 'object' && 'hours' in input) {
        const h = String(input.hours ?? 0).padStart(2, "0");
        const m = String(input.minutes ?? 0).padStart(2, "0");
        return `${h}:${m}`;
      }

      // Case 2: ISO string / timestamp
      const d = new Date(input);

      if (isNaN(d.getTime())) {
        return "00:00";
      }

      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");

      return `${hours}:${minutes}`;
    },

    persistCartFormState() {
      try {
        if (!this.cartFormStorageKey) return;

        const payload = {
          btnSelected: this.btnSelected,
          pickupDetails: {
            date: this.pickupDetails?.date ? new Date(this.pickupDetails.date).toISOString() : null,
            time: this.pickupDetails?.time ? new Date(this.pickupDetails.time).toISOString() : null,
          },
          deliveryAddress: { ...(this.deliveryAddress || {}) },
          deliveryContact: { ...(this.deliveryContact || {}) },
          deliveryDate: this.deliveryDate,
          deliveryTime: this.deliveryTime,
          contactDetails: { ...(this.contactDetails || {}) },
          isEnableOpenRequestOptionMoo: this.isEnableOpenRequestOptionMoo,
          openRequestRemark: this.openRequestRemark,
          updatedAt: Date.now(),
        };

        localStorage.setItem(this.cartFormStorageKey, JSON.stringify(payload));
      } catch (e) {
        // ignore persistence errors (e.g. storage full)
      }
    },

    restoreCartFormState() {
      try {
        if (!this.cartFormStorageKey) return;

        const raw = localStorage.getItem(this.cartFormStorageKey);
        if (!raw) return;

        const parsed = JSON.parse(raw);

        if (parsed && (parsed.btnSelected === 1 || parsed.btnSelected === 2)) {
          this.btnSelected = parsed.btnSelected;
        }

        if (parsed && parsed.pickupDetails) {
          if (parsed.pickupDetails.date) {
            const d = new Date(parsed.pickupDetails.date);
            if (!isNaN(d.getTime())) this.pickupDetails.date = d;
          }
          if (parsed.pickupDetails.time) {
            const t = new Date(parsed.pickupDetails.time);
            if (!isNaN(t.getTime())) this.pickupDetails.time = t;
          }
        }

        if (parsed && parsed.deliveryAddress) {
          this.deliveryAddress = { ...(this.deliveryAddress || {}), ...(parsed.deliveryAddress || {}) };
        }

        if (parsed && parsed.deliveryDate) {
          this.deliveryDate = parsed.deliveryDate;
          this.deliveryTime = parsed.deliveryTime || "";
        }

        if (parsed && parsed.deliveryContact) {
          this.deliveryContact = { ...(this.deliveryContact || {}), ...(parsed.deliveryContact || {}) };
        }

        // If logged in, contactDetails should be overridden by member info later.
        // If NOT logged in, restore what user typed.
        if (!this.isLogined && parsed && parsed.contactDetails) {
          this.contactDetails = { ...(this.contactDetails || {}), ...(parsed.contactDetails || {}) };
        }

        if (parsed && typeof parsed.isEnableOpenRequestOptionMoo !== 'undefined') {
          this.isEnableOpenRequestOptionMoo = parsed.isEnableOpenRequestOptionMoo;
        }

        if (parsed && typeof parsed.openRequestRemark !== 'undefined') {
          this.openRequestRemark = parsed.openRequestRemark;
        }
      } catch (e) {
        // ignore restore errors
      }
    },

    clearCartFormState() {
      try {
        if (!this.cartFormStorageKey) return;
        localStorage.removeItem(this.cartFormStorageKey);
      } catch (e) {
        // ignore
      }
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    // MTH057: hiện thông báo "chỉ nhập tối đa N ký tự" (tiếng Anh, lấy từ
    // i18n nên các locale khác tự fallback về en).
    showSpecialInstructionsLimitMessage() {
      this.message = this.$t("cart.specialInstructionsMaxLength", {
        max: this.specialInstructionsMaxLength,
      });
      this.snackbar = "danger";
      this.setTimeOutNotification();
    },
    // MTH057: thuộc tính maxlength chặn ký tự thứ 26 một cách im lặng, nên
    // watcher `notes` không bao giờ chạy khi gõ tay. Bắt ở beforeinput để
    // biết người dùng vừa cố nhập vượt giới hạn mà báo cho họ.
    onSpecialInstructionsBeforeInput(event) {
      const el = event.target;
      if (!el || el.id !== "special-instructions") return;
      if (!event.inputType || !event.inputType.startsWith("insert")) return;

      const max = this.specialInstructionsMaxLength;
      const selectionLength =
        (el.selectionEnd ?? 0) - (el.selectionStart ?? 0);
      const incoming =
        event.data ??
        (event.dataTransfer && event.dataTransfer.getData("text")) ??
        "";
      const incomingLength = incoming.length || 1;

      if ((el.value || "").length - selectionLength + incomingLength > max) {
        this.showSpecialInstructionsLimitMessage();
      }
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    goBack() {
      this.removeDeliveryFeeItem();
      this.gotoPath(this.queue ? "Queue" : "Order");
    },
    gotoSignIn() {
      gotoMemberLogin("mycart", this.queue, "login");
    },
    gotoSignUp() {
      gotoMemberLogin("mycart", this.queue, "signup");
    },
    triggerEventCutlery(value) {
      if (typeof value == "boolean") {
        this.isActiveCutlery = !this.isActiveCutlery;
      }
    },
    triggerEventUseCashback(value) {
      if (typeof value == "boolean") {
        this.isActiveUseCashback = !this.isActiveUseCashback;
      }
    },
    changeDiningOption(value) {
      $(".btn-hide-modal-select-dining-option").click();

      if (getCartItemIndexesInvalidForDiningOption(this.itemSelect, value).length) {
        this.pendingDiningOption = value;
        // Let the dining option modal finish closing before the confirm opens.
        setTimeout(() => $(".btn-confirm-modal").click(), 400);
        return;
      }

      this.applyDiningOption(value);
    },
    applyDiningOption(value) {
      this.takeAwayOrDineIn = value;
      localStorage.setItem(
        localStorageName("DINING_OPTION"),
        this.takeAwayOrDineIn
      );
    },
    confirmDiningOptionChange() {
      $(".btn-close-modal-confirm").click();
      const value = this.pendingDiningOption;
      this.pendingDiningOption = null;

      const invalidIndexes = getCartItemIndexesInvalidForDiningOption(this.itemSelect, value);
      this.itemSelect = this.itemSelect.filter((item, index) => !invalidIndexes.includes(index));
      this.updateCartOrder();
      this.syncDeliveryFeeItem();

      this.applyDiningOption(value);
    },
    openDiningOptionModal() {
      if (!this.canSwitchDiningOption) return;
      $(".btn-show-modal-select-dining-option").click();
    },
    calculateTotal() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        return this.itemSelect.reduce((total, product) => {
          if (this.isLogined) {
            total += product.member_price
              ? product.member_price * product.quantity
              : 0;
          } else {
            total += product.price_default
              ? product.price_default * product.quantity
              : 0;
          }

          return total;
        }, 0);
      } else {
        return 0;
      }
    },
    shouldApplyDeliveryFee() {
      return this.btnSelected == 2 && this.isDeliveryFeeEnabledForBranch();
    },
    deliveryFeeAmount() {
      if (!this.shouldApplyDeliveryFee()) return 0;
      const fee = parseFloat(this.branch.delivery_fee);
      return Number.isFinite(fee) ? fee : 0;
    },
    openModalNotes() {
      $(".btn-notes-modal").click();
    },
    async getPopularAddOns() {
      try {
        const setId = this.branch && this.branch.menuset_id;
        if (!setId) {
          return;
        }
        const dataForm = { set_id: setId };
        const checkResponse = await OrderService.checkShowUpsellItems(dataForm);
        if (
          !checkResponse ||
          !checkResponse.data ||
          !checkResponse.data.result ||
          !checkResponse.data.result.isSuccess
        ) {
          return;
        }
        if (!checkResponse.data.data || !checkResponse.data.data.is_enabled_upsell) {
          return;
        }
        const itemsResponse = await OrderService.getUpsellItems(dataForm);
        if (
          itemsResponse &&
          itemsResponse.data &&
          itemsResponse.data.result &&
          itemsResponse.data.result.isSuccess
        ) {
          this.popularAddOns = (itemsResponse.data.data && itemsResponse.data.data.upsell_items) || [];
          this.syncCartNames();
        }
      } catch (error) {
        this.popularAddOns = [];
      }
    },
    async addPopularAddOnToCart(upsellItem) {
      if (!upsellItem || !upsellItem.item) {
        return;
      }
      // Base this off itemSelect (not localStorage directly) so the in-memory
      // free item, which is deliberately never persisted to localStorage, isn't
      // wiped out when we overwrite itemSelect below.
      let orderInfo = (this.itemSelect || []).filter((item) => !item.is_free_item);
      const existingIndex = orderInfo.findIndex(
        (cartItem) =>
          cartItem.id === upsellItem.item.id &&
          parseFloat(cartItem.price_default) ===
            parseFloat(upsellItem.item.price_default)
      );
      if (existingIndex > -1) {
        orderInfo[existingIndex].quantity =
          (orderInfo[existingIndex].quantity || 0) + 1;
      } else {
        orderInfo.push({
          id: upsellItem.item.id,
          choice: upsellItem.item.choice,
          choices: upsellItem.item.choices,
          item_name: upsellItem.item.item_name,
          item_no: upsellItem.item.item_no,
          description: upsellItem.item.description,
          price_default: parseFloat(upsellItem.item.price_default),
          price_default_no_modifier_option: parseFloat(
            upsellItem.item.price_default
          ),
          member_price: parseFloat(
            upsellItem.item.member_price || upsellItem.item.price_default
          ),
          member_price_no_modifier_option: parseFloat(
            upsellItem.item.member_price || upsellItem.item.price_default
          ),
          quantity: 1,
          category_id: upsellItem.item.category_id || 0,
          menuset_id: upsellItem.item.menuset_id || 0,
          branch_code: this.branchCode,
          image: upsellItem.item.image || null,
          source: "upsell",
        });
      }
      localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
      const freeItems = (this.itemSelect || []).filter((item) => item.is_free_item);
      this.itemSelect = [...orderInfo, ...freeItems];

      // Re-evaluate free delivery threshold and voucher discount after cart change
      this.syncDeliveryFeeItem();
      this.showLoader();
      await this.refreshVoucherAfterCartChange();
      this.hideLoader();
    },
    selectReward() {
      if (this.isLogined) {
        localStorage.removeItem(localStorageName("ORDER_NOTES"));
        if (this.notes) {
          localStorage.setItem(localStorageName("ORDER_NOTES"), this.notes);
        }
        this.$router.push({
          name: "MyReward",
          params: {
            merchant_code: this.merchantCode,
            type: this.pathType,
            branch_code: this.branchCode,
            table_code: this.tableCode,
            from_cart: true,
          },
        });
      } else {
        this.showGuestPrompt = true;
      }
    },

    // MTH075: same destination the cart already uses for its other sign-in
    // entry points, so the guest lands back on the cart with items intact.
    gotoSignInFromGuestPrompt() {
      this.showGuestPrompt = false;
      gotoMemberLogin("mycart", this.queue, "login");
    },

    enterPromoCode() {
      $(".btn-show-modal-promo-code-moo").click();
    },
    // Promo code methods
    async handleApplyPromoCode(promoCode, isRecheck = false) {
      this.showLoader();

      let dataForm = {
        branch_code: this.branch.branch_code,
        member_id: this.memberId,
        promo_code: promoCode,
        order_total: this.calculateTotal(),
        // M977: a report-group promo is checked against the items in the cart
        items: this.itemSelect,
      };

      try {
        await OrderService.checkPromoCode(dataForm).then((response) => {
          if (response.data.result.isSuccess) {
            const promoData = response.data.data;
            this.promoCodeApplied = promoData;
            this.isPromoCodeApplied = true;

            // Promo discount will be calculated dynamically
            localStorage.setItem(
              localStorageName("PROMO_CODE_APPLIED"),
              JSON.stringify(this.promoCodeApplied)
            );
          } else if (isRecheck && isPromoCodeError(response.data.data)) {
            // The code saved with the cart no longer works (expired, out of its schedule ...).
            this.onPromoCodeUnavailable(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message), promoCode);
          } else if (isRecheck) {
            // Not about the code (member / branch lookup, server error): keep it, save-order
            // checks it again.
            return;
          } else {
            this.snackbar = "danger";
            this.message = promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message);
            this.setTimeOutNotification();
          }
        });
      } catch (error) {
        this.snackbar = "danger";
        this.message = error;
        this.setTimeOutNotification();
      } finally {
        this.hideLoader();
      }
    },
    finalTotal() {
      let finalTotal = 0;

      if (this.isPromoCodeApplied && this.promoCodeApplied) {
        finalTotal = this.calculateFinalTotalWithPromoCode();
      } else {
        finalTotal = this.calculateTotalAfterGST();
      }

      // MTH104 step 2: the items are already free, so whatever the voucher still
      // has left comes off the fees — the member keeps paying what they pay
      // today instead of being left with a service charge.
      finalTotal = Math.max(0, finalTotal - this.feeVoucherDiscount()).toFixed(2);

      if (this.memberInfo) {
        this.disablePayWithMintyWallet = parseFloat(parseFloat(this.memberInfo.amount_in_account).toFixed(2)) < parseFloat(finalTotal);
      }

      return finalTotal;
    },
    calculateFinalTotalWithPromoCode() {
      if (!this.promoCodeApplied) {
        return this.calculateTotalAfterGST();
      }

      // Calculate base total (subtotal)
      let baseTotal = this.calculateTotal();

      // MTH102: Bill Total is built from the same figure the discount line shows.
      let promoDiscount = this.calculatePromoDiscount(baseTotal);

      // Apply both voucher and promo discounts
      // MTH104: item-only part of the voucher, floored at 0 — see calculateTotalAfterGST().
      let finalAmount = Math.max(
        0,
        baseTotal - this.itemVoucherDiscount() - promoDiscount
      );

      // add service charge if there is
      // SF230: service charge base — discounted subtotal when the branch
      // toggle is on, otherwise the gross subtotal (before discount).
      if (
        this.takeAwayOrDineIn == DINE_IN &&
        this.branch.service_charge_rate > 0
      ) {
        const serviceChargeBase = this.serviceChargeOnDiscountedSubtotal
          ? finalAmount
          : baseTotal;
        const serviceCharge =
          serviceChargeBase * (this.branch.service_charge_rate / 100);
        finalAmount += serviceCharge;
      }

      // add tax if it is EXCLUSIVE (gst_rate > 0)
      const numericValue = parseFloat(this.branch.gst_rate);
      if (numericValue > 0) {
        const gstAmount = finalAmount * (numericValue / 100);
        finalAmount += gstAmount;
      }

      return finalAmount > 0 ? finalAmount : 0;
    },
    handleOpenBoxMintyWallet() {
      this.openBoxMintyWallet = !this.openBoxMintyWallet;
    },
    checkEnableVoucher() {
      if (this.rewardSelect && this.rewardSelect.length > 0) {
        if (this.rewardSelect[0].order_minimum == 2) {
          if (this.calculateTotal() < this.rewardSelect[0].order_total) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      return false;
    },
    // MTH094: the minimum spend a voucher advertises. Mirrors MyReward's
    // minSpendFor(): the CRM nulls `order_total` whenever a voucher is saved
    // with order_minimum = None, so a positive value is exactly the case where
    // a minimum applies — the two screens can never read the same voucher
    // differently.
    voucherMinSpend(reward) {
      const minSpend = Number(reward && reward.order_total);
      return Number.isFinite(minSpend) && minSpend > 0 ? minSpend : 0;
    },
    // MTH094: what that minimum is measured against. Same definition MyReward
    // gates on, so a voucher can never be blocked there and kept here: the
    // delivery fee is not part of what was ordered, and the voucher's own free
    // item must not pay for the minimum that unlocked it.
    cartSubtotalForMinSpend() {
      return (this.itemSelect || []).reduce((total, product) => {
        if (!product || product.is_delivery_fee_item || product.is_free_item) {
          return total;
        }
        const unitPrice = Number(
          this.isLogined
            ? product.member_price ?? product.price_default ?? 0
            : product.price_default ?? 0
        );
        const quantity = Number(product.quantity ?? 0);
        if (!Number.isFinite(unitPrice) || !Number.isFinite(quantity)) {
          return total;
        }
        return total + unitPrice * quantity;
      }, 0);
    },
    meetsCartMinSpend() {
      const minSpend = this.voucherMinSpend(this.appliedReward);
      return minSpend <= 0 || this.cartSubtotalForMinSpend() >= minSpend;
    },
    // MTH094: a voucher applied while the cart was big enough must not survive
    // the cart shrinking back under its minimum spend.
    shouldAutoRemoveVoucher() {
      if (!this.appliedReward) return false;
      // MTH090: the pay-later session voucher's minimum is settled by the
      // backend across the whole table bill, not by what is in this cart.
      if (this.isSessionLockedVoucher) return false;
      return !this.meetsCartMinSpend();
    },
    // Drop the voucher and everything that hangs off it, in place — no reload,
    // unlike removeReward() behind the × button, because the callers here are
    // automatic and must not throw away what the member has typed.
    dropAppliedVoucher() {
      // A free-item voucher parks its item in itemSelect (deliberately never
      // persisted to localStorage) — it has to leave with the voucher.
      this.itemSelect = (this.itemSelect || []).filter(
        (item) => !item || !item.is_free_item
      );
      this.rewardSelect = null;
      this.itemVoucherApplied = [];
      this.totalVoucherDiscount = 0;
      this.voucher_deducted_format = "";
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      this.hanldeSelectPaymentMethod();
    },
    // A payment that did not complete still left an order row behind, and the
    // member reward was locked to it before the customer ever reached the
    // gateway. The cart would otherwise keep showing a voucher the backend has
    // already spent, and the next Pay Now would be rejected on it.
    //
    // Returns true when something was actually removed, so the caller can say so
    // instead of letting it vanish under the member's hands.
    dropVoucherAfterCancelledPayment() {
      if (!this.appliedReward) return false;
      // MTH090's pay-later voucher belongs to the whole table session, not to
      // this one transaction — getTableVoucherLock() re-surfaces it on purpose.
      if (this.isSessionLockedVoucher) return false;

      this.dropAppliedVoucher();
      return true;
    },
    // MTH094: drop the voucher and everything that hangs off it. Returns true
    // when a voucher was actually removed, so the caller can tell the member.
    // The backend rejection inside calculateVoucherPrice() stays as the safety
    // net for anything this local check cannot see.
    autoRemoveVoucherBelowMinSpend() {
      if (!this.shouldAutoRemoveVoucher()) return false;
      this.dropAppliedVoucher();
      return true;
    },
    // MTH094: the rule in one call — drop the voucher the cart no longer earns
    // and say so in a snackbar. The blocking error modal the backend rejection
    // raises (raw, untranslated copy) is what this exists to get ahead of.
    enforceVoucherMinSpend() {
      if (!this.autoRemoveVoucherBelowMinSpend()) return false;
      this.message = this.$t("cart.voucherAutoRemoved");
      // MTH094: warning, not danger — nothing failed, the cart simply stopped
      // qualifying. MaterialSnackbar already maps `warning` to its amber accent
      // and ! icon; the cart's own guard just had to let the colour through.
      this.snackbar = "warning";
      this.setTimeOutNotification();
      return true;
    },
    // MTH094: every cart mutation goes through here — the local minimum-spend
    // check first (it covers free-item vouchers too, which the pricing call
    // deliberately skips), then the usual repricing for a voucher that stays.
    async refreshVoucherAfterCartChange() {
      if (this.enforceVoucherMinSpend()) return;
      if (this.appliedReward && this.appliedReward.reward_type != FREE_ITEM) {
        await this.calculateVoucherPrice();
      }
    },
    hanldeSelectPaymentMethod() {
      if (this.memberInfo && this.memberInfo.amount_in_account && this.branch.allow_ewallet) {
        var amount_in_account = Number(this.memberInfo.amount_in_account);
        if (Number(amount_in_account.toFixed(2)) < Number(this.finalTotal())) {
          this.disablePayWithMintyWallet = true;
          this.selectPaymentMethod = 2;
          localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
          localStorage.setItem(localStorageName("PAYMENT_METHOD"), 2);
        } else {
          this.disablePayWithMintyWallet = false;
          if (this.selectPaymentMethod != 2) {
            this.selectPaymentMethod = 1;
            localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
            localStorage.setItem(localStorageName("PAYMENT_METHOD"), 1);
          }
        }
      } else {
        this.disablePayWithMintyWallet = true;
        this.selectPaymentMethod = 2;
        localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
        localStorage.setItem(localStorageName("PAYMENT_METHOD"), 2);
      }
    },
    // MTH090: the voucher belongs to the whole pay-later table session, so the
    // cart re-surfaces it on the second and later orders — the previous submit
    // cleared SELECTED_REWARD and the member reward itself is locked, so it can
    // never come back through the normal apply flow.
    async getTableVoucherLock() {
      if (!this.isOrderPayLater || !this.tableCode || !this.branchCode) return;

      try {
        const response = await OrderService.getTableVoucherLock({
          branch_code: this.branchCode,
          table_code: this.tableCode,
        });

        if (!response.data.result.isSuccess) return;

        const lock = response.data.data;
        this.tableVoucherLock = lock;

        if (!lock.voucherLocked) return;
        // A voucher the member picked in this cart wins — it is either the same
        // one (the backend settles that) or a change the backend will refuse.
        if (this.appliedReward) return;

        this.rewardSelect = [
          {
            code: lock.voucherCode,
            reward_title: lock.voucherLabel,
            reward_type: lock.voucherType,
            reward_unit: lock.voucherUnit,
            // Minimum spend was already met by the session as a whole, so the
            // cart-level gate must not zero the discount out again.
            order_minimum: 1,
            order_total: 0,
            is_session_locked: true,
          },
        ];
        this.projectSessionVoucherDiscount();
      } catch (e) {
        // The lock is an enhancement — a cart that can't read it still orders.
        this.tableVoucherLock = null;
      }
    },
    // MTH090: what the session's voucher is worth on THIS order — a percentage
    // scales with the cart, a fixed-$ voucher only has its remainder left.
    projectSessionVoucherDiscount() {
      const lock = this.tableVoucherLock;
      if (!lock || !lock.voucherLocked) {
        this.totalVoucherDiscount = 0;
        return;
      }

      const subtotal = Number(this.calculateTotal()) || 0;
      const minSpend = Number(lock.minSpend) || 0;
      let discount = 0;

      if (Number(lock.pastTotal) + subtotal >= minSpend) {
        if (lock.voucherType == PERCENTAGE_OFF) {
          discount = (subtotal * (Number(lock.voucherUnit) || 0)) / 100;
        } else if (lock.voucherType == FIXED_AMOUNT_OFF) {
          discount = Math.min(Number(lock.voucherRemaining) || 0, subtotal);
        }
      }

      this.totalVoucherDiscount = this.roundMoney(discount);
    },
    async calculateVoucherPrice() {
      // MTH090: a session-locked voucher is priced by the same rule the backend
      // books it with — calculate-voucher-price knows nothing about the session
      // drawdown and would hand back the full face value again.
      if (this.isSessionLockedVoucher) {
        this.projectSessionVoucherDiscount();
        this.hanldeSelectPaymentMethod();
        return;
      }

      this.showLoader();
      try {
        if (
          this.memberInfo &&
          this.rewardSelect &&
          this.rewardSelect.length > 0
        ) {
          if (this.rewardSelect[0].reward_type == FREE_ITEM) {
            if (this.rewardSelect[0].item_selected) {
              this.itemSelect.push(this.rewardSelect[0].item_selected);
            }
          } else {
            let dataForm = {
              branch_code: this.branch.branch_code,
              memberId: this.memberId,
              voucherCode: this.rewardSelect[0].code,
              totalOrder: this.calculateTotal(),
              items: this.itemSelect,
            };

            await PromocodeService.calculateVoucherPrice(dataForm).then(
              (response) => {
                if (response.data.result.isSuccess) {
                  this.voucher_deducted_format =
                    response.data.data.voucher_deducted_format;
                  this.totalVoucherDiscount = response.data.data.voucher_deducted;
                  this.itemVoucherApplied =
                    response.data.data.item_voucher_applied;
                  const errMessage = response.data.data.error_message;

                  if (errMessage) {
                    this.voucherError(errMessage);
                  }
                  this.hanldeSelectPaymentMethod();
                } else {
                  this.voucherError(response.data.result.message);
                }
              },
              (error) => {
                this.voucherError(error.response?.data?.result?.message ?? "Something went wrong. Please try again.");
              }
            );
          }
        } else {
          this.hanldeSelectPaymentMethod();
        }
      } finally {
        this.hideLoader();
      }
    },
    async handlePay(isPayTopup = 0) {
      this.showLoader();
      // MTH080: the mount-time heal in created() only covers the moment the page
      // loaded — MERCHANT_ID can still go missing before Pay is actually clicked
      // (cross-tab logout via Profile.vue's handleLogout, or a bfcache-restored
      // page where created() never re-ran). Re-check right at submission time.
      await ensureMerchantId(this.branchCode);
      let dataForm = {
        branch_code: this.branch.branch_code,
      };

      const trimmedNotes =
        this.notes && this.notes !== "" && this.notes.length > 25
          ? this.notes.slice(0, 25)
          : this.notes;

      OrderService.checkAvailableOrdering(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            if (response.data.data.status) {
              // Ensure delivery fee item price reflects free delivery threshold before sending to API
              const itemsForPayload = (this.itemSelect || []).map(item => {
                if (item.is_delivery_fee_item && this.freeDeliveryThresholdReached) {
                  // M1004: free delivery still pays the CBD surcharge.
                  const cbd = Number(this.cbdSurcharge) || 0;
                  return {
                    ...item,
                    price_default: cbd,
                    member_price: cbd,
                  };
                }
                return item;
              });

              dataForm = {
                branch_code: this.branch.branch_code,
                member_id: this.memberId,
                items: itemsForPayload,
                promocode: this.rewardSelect,
                isCutlery: this.cutleryChecked ? 1 : 0,
                take_away_or_dine_in: this.takeAwayOrDineIn,
                take_away_fee: this.totalDineInFee().toFixed(2),
                notes: trimmedNotes,
                use_cash_back: null,
                total_item: this.calculateTotal(),
                // MTH104: the two-step figure, never more than the bill was worth.
                total_voucher_discount: this.appliedVoucherDiscount(),
                total_cashback_deduct: 0,
                total_payment_amount: this.finalTotal(),
                total_cashback_earned: 0,
                select_payment_method: this.selectPaymentMethod,
                gst_amount: this.convertedValueGstRate().toFixed(2),
                voucher_name:
                  this.rewardSelect && this.rewardSelect.length > 0
                    ? this.rewardSelect[0].reward_title
                    : "",
                gst_rate: this.branch.gst_rate,
                table_code: this.tableCode,
                selectSpicyValue: this.selectSpicyValue,
                is_pay_topup: isPayTopup,
                promo_code: this.promoCodeApplied
                  ? this.promoCodeApplied.promo_code
                  : null,
                promo_name: this.promoCodeApplied?.promo_name || "",
                total_promo_discount: this.getPromoDiscountAmount() ?? 0,
                open_request: this.isEnableOpenRequestOptionMoo,
                open_request_remark: this.openRequestRemark,
                bcrs_deposit: this.totalBcrs,
                bcrs_deposit_qty: this.branch?.each_bcrs_amount ? parseInt(this.totalBcrs / this.branch.each_bcrs_amount) : 0,
                payment_mode: this.paymentMode,
              };

              if (this.isEnablePickup && this.btnSelected == 1) {
                dataForm.pickup_details = {
                  date: this.pickupDetails.date,
                  time: this.formatTime(this.pickupDetails.time)
                };
              }

              if (this.isEnableContact) {
                dataForm.contact_details = this.contactDetails;
              }

              if (this.btnSelected == 2) {
                // M996: the order has no unit column, so the unit number leads address
                // line 2 ("#05-12, Building") and reaches POS, Lalamove and receipts as is.
                const { unit_no: unitNo, ...deliveryAddress } = this.deliveryAddress;
                dataForm.delivery_address = {
                  ...deliveryAddress,
                  address_line_2: [String(unitNo || "").trim(), deliveryAddress.address_line_2]
                    .filter(Boolean)
                    .join(", "),
                };
                if (this.isShowDeliveryContact) {
                  dataForm.delivery_contact = this.deliveryContact;
                }
                dataForm.delivery_slot = { date: this.deliveryDate, time: this.deliveryTime };
              }

              const numericValue = parseFloat(this.branch.gst_rate);
              if (numericValue < 0) {
                dataForm.gst_amount = this.totalGSTInclusive().toFixed(2);
              }

              const merchantCode = this.$store.state.merchantCode;
              const branchCode = this.$store.state.branchCode;

              if (this.isOrderPayLater) {
                dataForm.guest = this.guest;
                dataForm.is_your_friend_logined = this.isYourFriendLogined;

                OrderService.saveOrderQR(dataForm).then(
                  (response) => {
                    if (response.data.result.isSuccess) {
                      let data = response.data.data;
                      localStorage.setItem(this.cartName, null);
                      localStorage.removeItem(
                        localStorageName("SELECTED_REWARD")
                      );
                      localStorage.removeItem(
                        localStorageName("PROMO_CODE_APPLIED")
                      );
                      localStorage.removeItem(
                        localStorageName("DINING_OPTION")
                      );
                      this.payLoad = false;

                      // Don't clear itemSelect here — it just re-renders the
                      // cart as empty for a frame before window.location.href
                      // finishes navigating away, causing a visible flicker.
                      let url =
                        location.protocol +
                        "//" +
                        location.host +
                        "/" +
                        this.merchantCode +
                        "/QR/" +
                        this.branchCode +
                        "/" +
                        this.tableCode +
                        "/payment-success/" +
                        data.request_id +
                        "/PL";
                      window.location.href = url;
                    } else if (isPromoCodeError(response.data.data)) {
                      this.onPromoCodeUnavailable(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message));
                    } else if (response.data.data && response.data.data.error_code === "CART_PRICE_MISMATCH") {
                      this.onCartPriceMismatch();
                    } else {
                      this.snackbar = "danger";
                      this.message = response.data.result.message;
                      this.setTimeOutNotification();
                      this.payLoad = false;
                    }
                    this.hideLoader();
                  },
                  (error) => {
                    this.snackbar = "danger";
                    this.message = error;
                    this.setTimeOutNotification();
                    this.hideLoader();
                    this.payLoad = false;
                  }
                );
              } else {
                if (this.finalTotal() > 0 && this.finalTotal() < 0.50) {
                  this.txtNotification = "The minimum payment amount is $0.50.";
                  $(".btn-notification-modal").click();
                  this.payLoad = false;
                  this.hideLoader();
                  return;
                }

                OrderService.saveOrder(dataForm).then(
                  (response) => {
                    if (response.data.result.isSuccess) {
                      let transactionId = response.data.data.transaction_id;

                      if (isPayTopup) {
                        localStorage.removeItem(this.cartName);
                        localStorage.removeItem(
                          localStorageName("SELECTED_REWARD")
                        );
                        localStorage.removeItem(
                          localStorageName("PROMO_CODE_APPLIED")
                        );
                        localStorage.removeItem(
                          localStorageName("DINING_OPTION")
                        );
                        this.payLoad = false;
                        this.itemSelect = [];
                        this.processPaymentTopUp(transactionId);
                      } else {
                        // M1051: a $0 Stripe order still goes through Stripe so its
                        // page/receipt lists the items and the discount.
                        if (this.selectPaymentMethod == 2 && (this.finalTotal() > 0 || this.paymentMode == STRIPE)) {
                          this.processPayment(transactionId);
                        } else {
                          localStorage.removeItem(this.cartName);
                          localStorage.removeItem(
                            localStorageName("SELECTED_REWARD")
                          );
                          localStorage.removeItem(
                            localStorageName("PROMO_CODE_APPLIED")
                          );
                          localStorage.removeItem(
                            localStorageName("DINING_OPTION")
                          );
                          this.payLoad = false;
                          // Don't clear itemSelect here — it just re-renders the
                          // cart as empty for a frame before window.location.href
                          // finishes navigating away, causing a visible flicker.
                          var url =
                            location.protocol +
                            "//" +
                            location.host +
                            "/" +
                            merchantCode;

                          if (this.tableInfo) {
                            url +=
                              "/QR/" +
                              branchCode +
                              "/" +
                              this.tableCode +
                              "/payment-success/" +
                              transactionId;
                          } else {
                            url +=
                              "/" +
                              branchCode +
                              "/payment-success/" +
                              transactionId;
                          }

                          window.location.href = url;
                        }
                      }
                    } else if (isPromoCodeError(response.data.data)) {
                      this.onPromoCodeUnavailable(promoReasonText(this.$t.bind(this), response.data.data, response.data.result.message));
                    } else if (response.data.data && response.data.data.error_code === "CART_PRICE_MISMATCH") {
                      this.onCartPriceMismatch();
                    } else {
                      this.snackbar = "danger";
                      this.message = response.data.result.message;
                      this.setTimeOutNotification();
                      this.payLoad = false;
                      // M986 follow-up: the picked slot closed meanwhile - offer the current ones.
                      if (response.data.data && response.data.data.error_code == "DELIVERY_SLOT_UNAVAILABLE") {
                        this.loadDeliverySlots();
                      }
                    }
                    this.hideLoader();
                  },
                  (error) => {
                    this.snackbar = "danger";
                    this.message = error;
                    this.setTimeOutNotification();
                    this.hideLoader();
                    this.payLoad = false;
                  }
                );
              }
            } else {
              this.txtNotification =
                "This restaurant is currently not available for ordering. Please try again later, your order is saved in the cart.";
              $(".btn-notification-modal").click();
              this.hideLoader();
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
            this.payLoad = false;
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
          this.payLoad = false;
        }
      );
    },
    // Called when saveOrder/saveOrderQR reject the order because a cart price
    // doesn't match the server's price (tampered localStorage, or the menu
    // changed while the item sat in the cart). Runs on the confirm modal's
    // "Yes" button — clears the stale cart so the next add-to-cart pulls
    // current prices.
    // Price Schedules: checkout refused a cart kept past a price change (a schedule
    // starting or ending). reloadOrder reprices it in place; when no line moved, the
    // mismatch came from something else and the old "clear the cart?" prompt stays.
    async onCartPriceMismatch() {
      this.pendingDiningOption = null;
      this.payLoad = false;
      this.lastReloadPriceChanges = 0;
      await this.reloadOrder();
      if (!this.lastReloadPriceChanges) {
        $(".btn-confirm-modal").click();
      }
    },
    // order/reload returns `prices` (current base price per line) on a QR request.
    // Applies them, keeps earlier highlights, and lists the changed lines to the guest.
    applyReloadPrices(prices, previousItems) {
      this.repricedLines = carryRepricedLines(this.repricedLines, previousItems, this.itemSelect);
      this.lastReloadPriceChanges = 0;
      if (!Array.isArray(prices)) {
        return [];
      }
      const changed = applyCartPrices(this.itemSelect, prices, this.isLogined);
      if (!changed.length) {
        return changed;
      }
      this.lastReloadPriceChanges = changed.length;
      this.repricedLines = [...this.repricedLines.filter((line) => !changed.some((c) => c.item === line.item)), ...changed];
      this.syncDeliveryFeeItem();
      this.pricesUpdatedLines = changed.map((c) => ({
        name: this.tName(c.item.item_name),
        quantity: c.item.quantity,
        from: c.from,
        to: c.to,
      }));
      this.$refs.pricesUpdatedModal.open();
      return changed;
    },
    priceUpdateOf(item) {
      return this.repricedLines.find((line) => line.item === item) || null;
    },
    clearCartOnPriceMismatch() {
      $(".btn-close-modal-confirm").click();
      // Unlike the post-checkout cleanups (which immediately navigate away),
      // this stays on the cart page — clearIsEditQuantity()/hideDiv() run on
      // the next click and JSON.parse() a fresh localStorage read, so the key
      // must still hold a valid empty array rather than being removed outright.
      localStorage.setItem(this.cartName, JSON.stringify([]));
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      localStorage.removeItem(localStorageName("PROMO_CODE_APPLIED"));
      localStorage.removeItem(localStorageName("DINING_OPTION"));
      this.itemSelect = [];
    },
    processPayment(transaction_id) {
      this.showLoader();
      const merchantCode = this.$store.state.merchantCode;
      const branchCode = this.$store.state.branchCode;
      var url = location.protocol + "//" + location.host + "/" + merchantCode;
      var cancelUrl = url;

      if (this.tableInfo) {
        url += "/QR/" + branchCode + "/" + this.tableCode + "/payment-success/" + transaction_id;
        cancelUrl += "/QR/" + branchCode + "/" + this.tableCode + "/my-cart?cancel=true&transaction_id=" + transaction_id;
      } else {
        url += "/" + branchCode + "/payment-success/" + transaction_id;
        cancelUrl += "/" + branchCode + "/my-cart?cancel=true&transaction_id=" + transaction_id;
      }

      var dataSend = {
        images: "",
        name: "Order Items",
        unit_amount: this.finalTotal(),
        quantity: 1,
        branch_code: this.branchCode,
        transaction_id: transaction_id,
        member_id: this.memberId,
        merchant_id: localStorage.getItem(localStorageName("MERCHANT_ID"), 0),
        isPaymentItem: 1,
      };
  
      if (this.paymentMode == ALLINPAY) {
        dataSend = {
          ...dataSend,
          return_url: url,
        };

        AllinpayService.cnpSale(dataSend).then(
          (response) => {
            if (response.data.result.isSuccess) {
              localStorage.setItem(
                localStorageName("PENDING_PAYMENT_TXN"),
                JSON.stringify({ transaction_id, created_at: new Date().toISOString() })
              );
              window.location.href = response.data.data.payUrl;
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.payLoad = false;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.payLoad = false;
          }
        );
      } else if (this.paymentMode == QLUB) {
        // ?qlub=1 tells payment-success / my-cart to confirm against our own order:
        // reaching the success URL is not proof of payment, Qlub's Close Order is.
        dataSend = {
          ...dataSend,
          success_url: url + "?qlub=1",
          cancel_url: cancelUrl + "&qlub=1",
        };

        OrderService.checkoutQlub(dataSend)
          .then((response) => {
            if (!response.data.result.isSuccess) {
              throw new Error(response.data.result.message || "Payment failed, please try again");
            }
            localStorage.setItem(
              localStorageName("PENDING_PAYMENT_TXN"),
              JSON.stringify({ transaction_id, created_at: new Date().toISOString() })
            );
            window.location.href = response.data.data.url;
          })
          .catch((error) => {
            this.snackbar = "danger";
            this.message = error.message || error;
            this.setTimeOutNotification();
            this.payLoad = false;
            this.hideLoader();
          });
      } else if (this.paymentMode == AIRWALLEX) {
        dataSend = {
          ...dataSend,
          success_url: url,
          cancel_url: cancelUrl,
        };

        // The loader stays up on success while the SDK loads and navigates away.
        OrderService.checkoutHppAirwallex(dataSend)
          .then((response) => {
            if (!response.data.result.isSuccess) {
              throw new Error(response.data.result.message || "Payment failed, please try again");
            }
            localStorage.setItem(
              localStorageName("PENDING_PAYMENT_TXN"),
              JSON.stringify({ transaction_id, created_at: new Date().toISOString() })
            );
            return AirwallexService.redirectToHpp(response.data.data, () => {
              this.payLoad = false;
              this.hideLoader();
            });
          })
          .catch((error) => {
            this.snackbar = "danger";
            this.message = error.message || error;
            this.setTimeOutNotification();
            this.payLoad = false;
            this.hideLoader();
          });
      } else {
        dataSend = {
          ...dataSend,
          success_url: url,
          cancel_url: cancelUrl,
        };

        OrderService.checkoutSessionStripe(dataSend).then(
          (response) => {
            if (response.data.result.isSuccess) {
              localStorage.setItem(
                localStorageName("PENDING_PAYMENT_TXN"),
                JSON.stringify({ transaction_id, created_at: new Date().toISOString() })
              );
              window.location.href = response.data.data.url;
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.payLoad = false;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.payLoad = false;
          }
        );
      }
    },
    getMemberInfo() {
      if (this.memberInfo) {
        let dataForm = {
          memberId: this.memberId,
        };

        AuthService.getMemberInfo(dataForm, this.merchantCode).then(
          (response) => {
            if (response.data.result.isSuccess) {
              localStorage.setItem(
                localStorageName("memberInfo"),
                JSON.stringify(response.data.data.user)
              );
              this.memberInfo = response.data.data.user;
              MemberService.getMemberInfo(this.merchantCode).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.contactDetails.name = response.data.data.member.name ?? null;
                    this.contactDetails.phone = response.data.data.member.phone_number ?? null;
                    this.contactDetails.email = response.data.data.member.email ?? null;
                  }
                }
              );
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      }
    },
    async removeItemFromItemsSelected(id, index) {
      this.itemSelect.splice(index, 1);

      this.updateCartOrder();
      this.showLoader();
      await this.refreshVoucherAfterCartChange();
      this.hideLoader();
    },
    totalDineInFee() {
      if (
        this.takeAwayOrDineIn == DINE_IN &&
        this.branch.service_charge_rate > 0
      ) {
        // Calculate base amount for service charge
        let baseAmount = this.calculateTotal();

        // Calculate promo discount
        const promoDiscount = this.calculatePromoDiscount(baseAmount);

        // SF230: base on the discounted subtotal only when the branch toggle
        // is on; otherwise use the gross subtotal (before discount).
        // MTH104: only the part of the voucher that fits on the items comes off
        // here, and the base is floored at 0 — a voucher worth more than the
        // cart used to make this return a negative service charge.
        if (this.serviceChargeOnDiscountedSubtotal) {
          baseAmount = Math.max(
            0,
            baseAmount - this.itemVoucherDiscount() - promoDiscount
          );
        }

        return baseAmount * (this.branch.service_charge_rate / 100);
      } else {
        return 0;
      }
    },
    convertedValueGstRate() {
      const numericValue = parseFloat(this.branch.gst_rate);

      if (numericValue > 0) {
        // Calculate base amount for GST
        let baseAmount = this.calculateTotal();

        // Calculate promo discount
        const promoDiscount = this.calculatePromoDiscount(baseAmount);

        // Add service charge to base amount for GST calculation
        // SF230: service charge itself is based on the discounted subtotal
        // only when the branch toggle is on.
        if (this.takeAwayOrDineIn == DINE_IN && this.branch.service_charge_rate > 0) {
          // MTH104: same floored, item-only discount the service charge row uses.
          const serviceChargeBase = this.serviceChargeOnDiscountedSubtotal
            ? Math.max(0, baseAmount - this.itemVoucherDiscount() - promoDiscount)
            : baseAmount;
          const serviceCharge = serviceChargeBase * (this.branch.service_charge_rate / 100);
          baseAmount += serviceCharge;
        }

        // GST itself is always computed on the discounted subtotal (+ SC above).
        // MTH104: floored at 0 so an over-value voucher cannot produce negative GST.
        baseAmount = Math.max(
          0,
          baseAmount - this.itemVoucherDiscount() - promoDiscount
        );

        // Round half-up to 2 decimals so display and Bill Total stay consistent.
        const rawGst = baseAmount * (numericValue / 100);
        return Math.round((rawGst + Number.EPSILON) * 100) / 100;
      } else {
        // inclusive
        return 0;
      }
    },
    // Helper function to calculate promo discount
    calculatePromoDiscount(baseAmount) {
      if (!this.isPromoCodeApplied || !this.promoCodeApplied) {
        return 0;
      }

      // MTH102: rounded half-up to the cent so the total agrees with the
      // discount line and with what the backend books.
      // M977: a report-group promo is taken from the eligible items only.
      return this.roundMoney(
        promoDiscountAmount(this.promoCodeApplied, baseAmount, this.itemSelect, this.isLogined)
      );
    },
    calculateTotalAfterGST() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        // Calculate base total (subtotal)
        let baseTotal = this.itemSelect.reduce((total, product) => {
          if (this.isLogined) {
            total += product.member_price
              ? product.member_price * product.quantity
              : 0;
          } else {
            total += product.price_default
              ? product.price_default * product.quantity
              : 0;
          }

          return total;
        }, 0);

        // Calculate promo discount
        const promoDiscount = this.calculatePromoDiscount(baseTotal);

        // Apply both voucher and promo discounts
        // MTH104: only the part of the voucher that fits on the items, floored at
        // 0. What is left of the voucher is taken off further down the chain, in
        // finalTotal(), once the fees on this amount are known.
        let finalAmount = Math.max(
          0,
          baseTotal - this.itemVoucherDiscount() - promoDiscount
        );

        if (parseFloat(this.branch.gst_rate) < 0) {
          // INCLUSIVE - GST is already included in the price
          // Add service charge if there is
          // SF230: service charge base — discounted subtotal when the branch
          // toggle is on, otherwise the gross subtotal (before discount).
          if (this.takeAwayOrDineIn == DINE_IN && this.branch.service_charge_rate > 0) {
            const serviceChargeBase = this.serviceChargeOnDiscountedSubtotal
              ? finalAmount
              : baseTotal;
            const serviceCharge = serviceChargeBase * (this.branch.service_charge_rate / 100);
            finalAmount += serviceCharge;
          }
          return finalAmount > 0 ? finalAmount : 0;
        } else {
          // EXCLUSIVE - GST needs to be added
          // Add service charge if there is
          // SF230: service charge base — discounted subtotal when the branch
          // toggle is on, otherwise the gross subtotal (before discount).
          if (this.takeAwayOrDineIn == DINE_IN && this.branch.service_charge_rate > 0) {
            const serviceChargeBase = this.serviceChargeOnDiscountedSubtotal
              ? finalAmount
              : baseTotal;
            const serviceCharge = serviceChargeBase * (this.branch.service_charge_rate / 100);
            finalAmount += serviceCharge;
          }

          // Add GST (use the rounded value so display and Bill Total stay consistent)
          const numericValue = parseFloat(this.branch.gst_rate);
          if (numericValue > 0) {
            finalAmount += this.convertedValueGstRate();
          }

          return finalAmount > 0 ? finalAmount : 0;
        }
      } else {
        return 0;
      }
    },
    calculateTotalBeforeDiscount() {
      if (this.itemSelect && this.itemSelect.length > 0) {
        if (parseFloat(this.branch.gst_rate) < 0) {
          // INCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total += this.totalDineInFee();
          return total > 0 ? total : 0;
        } else {
          // EXCLUSIVE
          let total = this.itemSelect.reduce((total, product) => {
            if (this.isLogined) {
              total += product.member_price
                ? product.member_price * product.quantity
                : 0;
            } else {
              total += product.price_default
                ? product.price_default * product.quantity
                : 0;
            }

            return total;
          }, 0);

          total += this.totalDineInFee() + this.convertedValueGstRate();
          return total > 0 ? total : 0;
        }
      } else {
        return 0;
      }
    },
    totalGSTInclusive() {
      var gstConverted = Math.abs(this.branch.gst_rate) / 100;
      const rawGst =
        (this.calculateTotalAfterGST() / (1 + gstConverted)) * gstConverted;
      // Round half-up to 2 decimals (avoid `.toFixed(2)` rounding 0.495 down to 0.49).
      return Math.round((rawGst + Number.EPSILON) * 100) / 100;
    },
    allModifierGroups() {
      let allModifierGroups = [];

      if (this.itemSelect && this.itemSelect.length > 0) {
        this.itemSelect.forEach((item) => {
          let modifierGroups = item.modifier_group_full || [];

          modifierGroups.forEach((modifierGroup) => {
            allModifierGroups.push({ items: modifierGroup.items || [] });
          });
        });
      }

      return allModifierGroups;
    },
    getSlides() {
      let itemIds = [];
      if (this.itemSelect && this.itemSelect.length > 0) {
        this.itemSelect.forEach((item) => {
          if (item.id) {
            itemIds.push(item.id);
          }
        });
        // Remove duplicate IDs (if any)
        itemIds = [...new Set(itemIds)];
      }

      var dataForm = {
        branch_code: this.$store.state.branchCode,
        itemArray: itemIds,
      };
      SlideService.getListSlidesOnCheckout(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            var resutltSlide = response.data.data;
            var usedItems = [];
            resutltSlide &&
              resutltSlide.forEach((slide) => {
                if (slide.direct_to_suggested_adds_on === 1) {
                  this.allModifierGroups().forEach((modifierGroup) => {
                    const selectedItem = modifierGroup.items.find(
                      (item) => item.price > 0 && !usedItems.includes(item.id)
                    );
                    if (selectedItem) {
                      usedItems.push(selectedItem.id);
                      slide.itemSelected = selectedItem;
                    } else {
                      const selectedItemPriceIsZero = modifierGroup.items.find(
                        (item) =>
                          item.price == 0 && !usedItems.includes(item.id)
                      );
                      if (selectedItemPriceIsZero) {
                        usedItems.push(selectedItemPriceIsZero.id);
                        slide.itemSelected = selectedItemPriceIsZero;
                      }
                    }
                  });
                }
              });
            this.slides = resutltSlide;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
        }
      );
    },
    clickLink(slide) {
      if (slide && slide.destination_link != "") {
        window.open(slide.destination_link);
      } else if (
        slide &&
        slide.direct_to_menu_item != "" &&
        !slide.direct_to_suggested_adds_on
      ) {
        this.$router.push({
          name: "Order",
          params: {
            merchant_code: this.merchantCode,
            type: this.pathType,
            branch_code: this.branchCode,
            table_code: this.tableCode,
            itemId: slide.direct_to_menu_item ?? 0,
          },
        });
      }
    },
    resetRequired() {
      this.contactFieldRequired.name = false;
      this.contactFieldRequired.phone = false;
    },
    processValidate() {
      this.resetRequired();
      var isValid = true;

      if (this.contactDetails.name == "" || this.contactDetails.name == null) {
        this.contactFieldRequired.name = true;
        isValid = false;
      }

      const phoneRegex = /^[89]\d{7}$/;
      if (this.contactDetails.phone == "" || this.contactDetails.phone == null || !phoneRegex.test(this.contactDetails.phone)) {
        this.contactFieldRequired.phone = true;
        isValid = false;
      }

      if (!isValid) {
        // The buyer details sit at the top of a cart that is usually taller than
        // the screen, so without this the customer taps Pay at the bottom and
        // nothing appears to happen.
        scrollToFirstInvalid();
      }

      return isValid;
    },
    async reloadOrder(isPay = 0, isPayTopup = 0) {
      if (this.payLoad) {
        return;
      }

      this.payLoad = true;

      if (isPay == 1) {
        if (!this.isOrderPayLater && this.isEnableContact && !this.processValidate()) {
          this.payLoad = false;
          return;
        }

        if (!this.isOrderPayLater && !this.queue && this.btnSelected == 2 && this.branch.show_pickup_delivery_option_moo == 1 && !this.validateDelivery()) {
          this.payLoad = false;
          return;
        }

        if (!this.isOrderPayLater && !this.queue && this.isEnablePickup && this.btnSelected == 1 && !this.validatePickup()) {
          this.payLoad = false;
          return;
        }

        await this.checkBranchStatus();
      }

      if (this.stopOrdering) {
        this.txtNotification =
          "The QR Ordering is currently not available, please proceed to cashier counter.";
        $(".btn-notification-modal").click();
        this.payLoad = false;
      } else {
        this.messageErrorVoucher = "";
        this.showLoader();
        let dataForm = {
          items: JSON.parse(localStorage.getItem(this.cartName, [])),
          branch_code: this.$store.state.branchCode,
          member_id: this.memberId,
          // MTH095: the session voucher was locked on purpose by the request
          // that applied it, so revalidating it here fails with "Voucher is
          // locked" and disables the submit button for the rest of the table
          // session. saveOrderQR re-projects it onto this request (MTH090),
          // which is what decides the discount — reload has no say in it.
          promocode: this.isSessionLockedVoucher ? [] : this.rewardSelect,
          total_item: this.calculateTotal(),
          // This cart lives in localStorage with no expiry: have reload refuse
          // lines no longer on the channel's current menu set.
          check_menuset: 1,
        };

        await OrderService.reload(dataForm).then(
          async (response) => {
            if (response.data.result.isSuccess) {
              let dataResponse = response.data.data;

              if (this.tableInfo && this.tableInfo.type == 2) {
                // STATIC QR
                if (!this.isOrderPayLater != dataResponse.stripe_connect) {
                  window.location.reload();
                }
              }

              this.MERCHANT_BRAND_NAME = dataResponse.merchant_brand_name ?? "";
              this.isCheckMerchantConnectedStripe =
                dataResponse.isCheckMerchantConnectedStripe;
              const previousItems = this.itemSelect || [];
              this.itemSelect = dataResponse.items;
              const priceChanges = this.applyReloadPrices(dataResponse.prices, previousItems);
              this.syncCartNames();
              if (dataResponse.isCanPay == 0) {
                $(".btn-notification-out-stock-items-modal").click();
              } else {
                $(".btn-close-out-stock-items").click();
              }
              this.isCanPay = dataResponse.isCanPay;
              this.paymentMode = dataResponse.payment_mode;
              this.updateCartOrder();

              // MTH094: the cart can shrink while the member is away (items
              // removed on the Menu screen, an out-of-stock row dropped), so
              // the voucher is re-checked on every reload — including the one
              // created() runs — before it can be priced or submitted.
              const voucherRemoved = this.enforceVoucherMinSpend();

              // A repriced cart is shown to the guest before it is paid.
              if (this.isCanPay && this.isCanPay == 1 && isPay && !priceChanges.length) {
                if (
                  this.memberInfo &&
                  this.rewardSelect &&
                  this.rewardSelect.length > 0
                ) {
                  if (this.rewardSelect[0].reward_type == FREE_ITEM) {
                    if (this.rewardSelect[0].item_selected) {
                      this.itemSelect.push(this.rewardSelect[0].item_selected);
                    }
                  }
                }

                this.handlePay(isPayTopup);
              } else {
                if (!voucherRemoved) {
                  await this.calculateVoucherPrice();
                }
                this.payLoad = false;
                this.hideLoader();
              }
            } else {
              let warningMessage = response.data.result.message;
              var prefix = "prefixVoucherError-";
              if (warningMessage.startsWith(prefix)) {
                this.messageErrorVoucher = warningMessage.substring(
                  prefix.length
                );
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              $(".btn-close-out-stock-items").click();
              this.payLoad = false;
              this.hideLoader();
            }
          },
          (error) => {
            $(".btn-close-out-stock-items").click();
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
            this.payLoad = false;
          }
        );
      }
    },
    checkItemsSelectedStock(type) {
      this.showLoader();
      let dataForm = {
        items: JSON.parse(localStorage.getItem(this.cartName, [])),
        branch_code: this.$store.state.branchCode,
      };

      OrderService.checkItemsSelectedStock(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.itemSelect = response.data.data.items;
            this.isCanPay = response.data.data.isCanPay;
            if (
              response.data.data.isCanPay &&
              response.data.data.isCanPay == 1
            ) {
              if (type == 1) {
                this.handlePay();
              } else {
                this.hideLoader();
              }
            } else {
              this.hideLoader();
            }
          } else {
            console.log(response.data.result.message);
            this.hideLoader();
          }
        },
        (error) => {
          console.log(error);
          this.hideLoader();
        }
      );
    },
    removeItemModifierFromItemsSelected(id) {
      for (let i = 0; i < this.itemSelect.length; i++) {
        if (this.itemSelect[i] && this.itemSelect[i].modifier_group) {
          for (let j = 0; j < this.itemSelect[i].modifier_group.length; j++) {
            if (this.itemSelect[i].modifier_group[j].items) {
              for (
                let k = 0;
                k < this.itemSelect[i].modifier_group[j].items.length;
                k++
              ) {
                if (this.itemSelect[i].modifier_group[j].items[k].id === id) {
                  this.itemSelect[i].modifier_group[j].items.splice(k, 1);
                  if (this.itemSelect[i].modifier_group[j].items.length === 0) {
                    this.itemSelect[i].modifier_group.splice(j, 1);
                  }
                  this.updateCartOrder();
                  this.checkItemsSelectedStock(0);
                  return;
                }
              }
            }
          }
        }
      }
    },
    selectInputStripe() {
      // v-model="selectPaymentMethod" on both radios already keeps their
      // checked state in sync — no need to touch the DOM directly (and doing
      // so via getElementById crashed whenever the other payment method's
      // radio wasn't rendered, e.g. e-wallet unavailable, which is why
      // clicking anywhere in the row besides the radio itself did nothing).
      this.selectPaymentMethod = 2;
      localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
      localStorage.setItem(localStorageName("PAYMENT_METHOD"), 2);
    },
    selectInputMintyWallet() {
      // disablePayWithMintyWallet is the same flag the "insufficient" hint and
      // the radio's own :disabled already use — re-deriving the balance check
      // here from calculateTotalAfterGST() instead could disagree with it and
      // silently no-op the click (while the radio still toggled via v-model,
      // bypassing this guard entirely), which is why clicking the row appeared
      // to do nothing except when clicking the radio itself.
      if (!this.disablePayWithMintyWallet) {
        this.selectPaymentMethod = 1;
        localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
        localStorage.setItem(localStorageName("PAYMENT_METHOD"), 1);
      }
    },
    calculateTotalYouSave() {
      var data = this.itemSelect ?? [];
      let total = 0;
      data &&
        data.length > 0 &&
        data.forEach((item) => {
          if (this.isLogined && item.member_price_no_modifier_option > 0) {
            total +=
              item.price_default_no_modifier_option -
              item.member_price_no_modifier_option;
          }
        });
      return total;
    },
    getMainItemPriceAndModifiersPrice(item) {
      // Use the already calculated price that includes modifiers
      var finalPrice = 0;

      if (this.isLogined) {
        finalPrice = item.member_price ? item.member_price : item.price_default;
      } else {
        finalPrice = item.price_default;
      }

      return this.formatPrice(finalPrice * item.quantity);
    },
    // The item's own price, excluding whatever its selected modifiers add —
    // shown next to the item name, separate from each modifier's own price.
    itemOwnPrice(item) {
      var price =
        this.isLogined && item.member_price_no_modifier_option
          ? item.member_price_no_modifier_option
          : item.price_default_no_modifier_option;
      return price ? this.formatPrice(price * item.quantity) : "";
    },
    // The item's own pre-discount price, shown struck through next to
    // itemOwnPrice() when the member price differs from the list price.
    // KSK119: while a price schedule sells the line lower, its usual price (order/reload's
    // original_*_no_modifier_option; a member's is the usual member price) instead.
    itemOwnPriceWas(item) {
      if (!item.is_free_item) {
        const atMemberPrice = this.isLogined && item.member_price_no_modifier_option;
        const original = parseFloat(atMemberPrice
          ? item.original_member_price_no_modifier_option
          : item.original_price_no_modifier_option) || 0;
        const paid = parseFloat(atMemberPrice
          ? item.member_price_no_modifier_option
          : item.price_default_no_modifier_option) || 0;
        if (original > paid) {
          return this.formatPrice(original * item.quantity);
        }
      }
      if (
        this.isLogined &&
        item.member_price_no_modifier_option &&
        item.price_default_no_modifier_option != item.member_price_no_modifier_option
      ) {
        return this.formatPrice(item.price_default_no_modifier_option * item.quantity);
      }
      return "";
    },
    // A selected modifier's display name, prefixed with its count when the same
    // modifier was picked more than once ("3x Sour Plum Drink"). The line price
    // below is the total for all of them, so the count has to be on the line —
    // repeating the name once per unit made it read as 3 x $9.00.
    modifierName(modifierItem) {
      if (!modifierItem) return "";
      var name = this.tName(modifierItem.item_name);
      var qty = Number(modifierItem.quantity || 1);
      return qty > 1 ? qty + "x " + name : name;
    },
    // A selected modifier's (or item_in_mog sub-modifier's) own add-on price,
    // scaled by its own quantity and the parent item's quantity so it lines
    // up with the total getMainItem()/getMainItemPriceAndModifiersPrice() add.
    modifierLinePrice(modifierItem, parentQty) {
      if (!modifierItem || !modifierItem.price_default) return "";
      var qty = modifierItem.quantity || 1;
      return "+" + this.formatPrice(modifierItem.price_default * qty * parentQty);
    },
    getMainItem(item) {
      var priceMainAndModifer = 0;
      priceMainAndModifer =
        this.isLogined && item.member_price_no_modifier_option
          ? item.price_default_no_modifier_option * item.quantity
          : 0;
      var totalPriceModifer = 0;

      if (item.choice) {
        item.choice_selected.items.forEach((itemChoice) => {
          if (itemChoice.item_detail) {
            itemChoice.item_detail.modifier_group.forEach((group) => {
              group.items.forEach((itemModifier) => {
                totalPriceModifer +=
                  itemModifier.price_default *
                  itemModifier.quantity *
                  itemChoice.qty;

                if (
                  itemModifier.item_in_mog &&
                  itemModifier.item_in_mog.modifier_group
                ) {
                  itemModifier.item_in_mog.modifier_group.forEach(
                    (subGroup) => {
                      subGroup.items.forEach((subItemModifier) => {
                        totalPriceModifer +=
                          subItemModifier.price_default *
                          subItemModifier.quantity *
                          itemModifier.quantity *
                          itemChoice.qty;
                      });
                    }
                  );
                }
              });
            });
          }
        });
      } else {
        if (item.modifier_group) {
          item.modifier_group.forEach((group) => {
            group.items.forEach((itemModifier) => {
              totalPriceModifer +=
                itemModifier.price_default * itemModifier.quantity;

              if (
                itemModifier.item_in_mog &&
                itemModifier.item_in_mog.modifier_group
              ) {
                itemModifier.item_in_mog.modifier_group.forEach((subGroup) => {
                  subGroup.items.forEach((subItemModifier) => {
                    totalPriceModifer +=
                      subItemModifier.price_default *
                      subItemModifier.quantity *
                      itemModifier.quantity;
                  });
                });
              }
            });
          });
        }
      }

      return priceMainAndModifer > 0
        ? this.formatPrice(
            priceMainAndModifer + totalPriceModifer * item.quantity
          )
        : "";
    },
    removeReward() {
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      // MTH092: mounted() clears ORDER_NOTES right after data() reads it, so
      // the reload below would wipe anything typed into Special Instructions
      // unless it is written back first (same guard selectReward() uses).
      localStorage.removeItem(localStorageName("ORDER_NOTES"));
      if (this.notes) {
        localStorage.setItem(localStorageName("ORDER_NOTES"), this.notes);
      }
      location.reload();
    },
    // The applied code can no longer be used (expired, out of its schedule, used up ...), seen
    // when the cart opens or when the order is placed: drop it (no reload) and say why in a
    // modal, so the customer sees the new total before paying.
    onPromoCodeUnavailable(reason, code = this.promoCodeApplied?.promo_code) {
      this.promoCodeApplied = null;
      this.isPromoCodeApplied = false;
      localStorage.removeItem(localStorageName("PROMO_CODE_APPLIED"));
      this.payLoad = false;
      this.txtNotification = promoRemovedMessage({
        title: this.$t("cart.promoCodeRemoved", { code: code || "" }),
        reason,
        note: this.$t("cart.promoCodeRemovedNote"),
      });
      $(".btn-notification-modal").click();
    },
    removePromoCode() {
      this.promoCodeApplied = null;
      this.isPromoCodeApplied = false;
      localStorage.removeItem(localStorageName("PROMO_CODE_APPLIED"));
      location.reload();
    },

    getPromoDiscountAmount() {
      if (!this.isPromoCodeApplied || !this.promoCodeApplied) {
        return 0;
      }

      // MTH102: both the figure shown in the summary and the one posted to checkout.
      return this.calculatePromoDiscount(this.calculateTotal());
    },
    showQuantityForMainItem(itemIndex) {
      this.clearIsEditQuantity();
      if (itemIndex !== -1) {
        if (!this.itemSelect[itemIndex].isEditQuantity) {
          this.itemSelect[itemIndex].isEditQuantity = true;
        } else {
          this.itemSelect[itemIndex].isEditQuantity = false;
        }
      }
    },
    async handleQuantityForMainItem(mainItem, type, itemIndex) {
      // 1 is - | 2 is +
      if (itemIndex !== -1 && type == 1) {
        if (this.itemSelect[itemIndex].quantity === 1) {
          // If quantity is going to be decremented to 0, show confirm dialog
          this.decrementItemQuantity(itemIndex);
        } else {
          this.decrementItemQuantity(itemIndex);
        }
      } else if (itemIndex !== -1 && type == 2) {
        this.itemSelect[itemIndex].quantity =
          this.itemSelect[itemIndex].quantity + 1;
        this.updateCartOrder();
      }

      // Re-evaluate free delivery threshold after quantity change
      this.syncDeliveryFeeItem();

      this.showLoader();
      await this.refreshVoucherAfterCartChange();
      this.hideLoader();
    },

    decrementItemQuantity(itemIndex) {
      this.itemSelect[itemIndex].quantity =
        this.itemSelect[itemIndex].quantity - 1;
      if (this.itemSelect[itemIndex].quantity === 0) {
        this.itemSelect.splice(itemIndex, 1);
      }
      this.updateCartOrder();

      // Re-evaluate free delivery threshold after quantity change
      this.syncDeliveryFeeItem();
    },

    clearIsEditQuantity() {
      this.itemSelect.forEach((item) => {
        delete item.isEditQuantity;
      });
      var dataItems = JSON.parse(localStorage.getItem(this.cartName, []));
      localStorage.removeItem(this.cartName);
      dataItems.forEach((itemObject) => {
        delete itemObject.isEditQuantity;
      });
      localStorage.setItem(this.cartName, JSON.stringify(dataItems));
    },
    hideDiv(event) {
      const clickedElement = event.target;

      // Check if the clicked element doesn't have the class 'boxEditQuantityNormal'
      if (
        clickedElement &&
        !clickedElement.classList.contains("boxEditQuantity")
      ) {
        this.clearIsEditQuantity();
      }
    },
    countQuantityItems() {
      var totalQuantityItems = 0;

      this.itemSelect.forEach((mainItem) => {
        totalQuantityItems += mainItem.quantity;
      });

      return totalQuantityItems;
    },
    gotoPath(name) {
      this.$router.push({
        name: name,
        params: {
          merchant_code: this.merchantCode,
          type: this.pathType,
          branch_code: this.branchCode,
          table_code: this.tableCode,
        },
      });
    },
    getTopupList() {
      if (this.memberInfo) {
        MemberService.getTopupList().then(
          (response) => {
            this.promotionalTopupList = response.data.data.promotionTopup;
            this.topupList = response.data.data.topup;
          },
          (error) => {
            console.log("error", error);
            this.hideLoader();
          }
        );
      }
    },
    processPaymentTopUp(transactionId = null) {
      var item = this.topupCurrentlyHandle;
      const merchantCode = this.$store.state.merchantCode;
      var url = location.protocol + "//" + location.host + "/" + merchantCode;

      if (this.tableInfo) {
        url += "/QR/" + this.branchCode + "/" + this.tableCode + "/my-cart";
      } else {
        url += "/" + this.branchCode + "/my-cart";
      }

      var cancelUrl = url + "?cancel=true";

      var payment_amount = new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(item.payment_amount);

      var dataSend = {
        images: "",
        name: "TOP UP " + payment_amount,
        unit_amount: item.payment_amount,
        quantity: 1,
        branch_code: this.branchCode,
        transaction_id: transactionId,
        isTopupOnMember: 1,
        topup_id: item.id,
        member_id: this.memberInfo.id,
      };

      // Qlub only pays orders: the API takes no top-up through it.
      if (this.paymentMode == QLUB) {
        $(".btn-close-confirm-topup-modal").click();
        this.snackbar = "danger";
        this.message = "Top-up is not available for this outlet";
        this.setTimeOutNotification();
        this.payLoad = false;
        this.hideLoader();
        return;
      }

      if (this.paymentMode == ALLINPAY) {
        dataSend = {
          ...dataSend,
          return_url: url,
        };

        AllinpayService.cnpSale(dataSend).then(
          (response) => {
            if (response.data.result.isSuccess) {
              window.location.href = response.data.data.payUrl;
            } else {
              $(".btn-close-confirm-topup-modal").click();
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.payLoad = false;
            this.hideLoader();
          },
          (error) => {
            $(".btn-close-confirm-topup-modal").click();
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.payLoad = false;
          }
        );
      } else if (this.paymentMode == AIRWALLEX) {
        dataSend = {
          ...dataSend,
          success_url: url,
          cancel_url: cancelUrl,
        };

        OrderService.checkoutHppAirwallex(dataSend)
          .then((response) => {
            if (!response.data.result.isSuccess) {
              throw new Error(response.data.result.message || "Payment failed, please try again");
            }
            return AirwallexService.redirectToHpp(response.data.data, () => {
              this.payLoad = false;
              this.hideLoader();
            });
          })
          .catch((error) => {
            $(".btn-close-confirm-topup-modal").click();
            this.snackbar = "danger";
            this.message = error.message || error;
            this.setTimeOutNotification();
            this.payLoad = false;
            this.hideLoader();
          });
      } else {
        dataSend = {
          ...dataSend,
          success_url: url,
          cancel_url: cancelUrl,
        };

        OrderService.checkoutSessionStripe(dataSend).then(
          (response) => {
            if (response.data.result.isSuccess) {
              window.location.href = response.data.data.url;
            } else {
              $(".btn-close-confirm-topup-modal").click();
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              this.payLoad = false;
              this.hideLoader();
            }
          },
          (error) => {
            $(".btn-close-confirm-topup-modal").click();
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.payLoad = false;
            this.hideLoader();
          }
        );
      }
    },
    openModalConfirmTopup(item) {
      this.topupCurrentlyHandle = item;
      $(".btn-confirm-topup-modal").click();
    },
    openModalConfirmPromotionalTopup(item) {
      let topupAmount = item.payment_amount * this.finalTotal();
      this.topupCurrentlyHandle = {
        id: item.id,
        topup_amount: topupAmount,
        payment_amount: topupAmount,
        expiry_number: item.expiry_number,
        expiry_unit: item.expiry_unit,
        limit_number: item.limit_number,
        limit_type: item.limit_type,
        limit_unit: item.limit_unit,
        promotion_type: item.promotion_type,
      };
      $(".btn-confirm-topup-modal").click();
    },
    checkMemberPermissions() {
      if (this.memberInfo) {
        MemberService.checkMemberPermissions().then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.memberPermissions = response.data.data;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    closedModalOrderFail() {
      location.reload();
    },
    async checkBranchStatus() {
      var dataForm = {
        branch_code: this.branchCode,
      };

      await OrderService.checkbranchStatus(dataForm).then(
        (response) => {
          this.stopOrdering = response.data.data.stop_ordering;
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    selectNonSpicy() {
      var input = document.getElementById("spicy");
      input.checked = false;
      var input1 = document.getElementById("non-spicy");
      input1.checked = true;
      this.selectSpicyValue = "不辣 Non-Spicy";
    },
    selectSpicy() {
      var input = document.getElementById("spicy");
      input.checked = true;
      var input1 = document.getElementById("non-spicy");
      input1.checked = false;
      this.selectSpicyValue = "辣 Spicy";
    },
    updateCartOrder() {
      localStorage.removeItem(this.cartName);
      const itemSelectedWithOutFreeItem = this.itemSelect.filter(
        (item) => !item.is_free_item
      );
      localStorage.setItem(
        this.cartName,
        JSON.stringify(itemSelectedWithOutFreeItem)
      );
    },
    voucherError(errMessage) {
      this.txtNotification = errMessage;
      $(".btn-notification-modal").click();

      this.rewardSelect = null;
      this.itemVoucherApplied = [];
      this.totalVoucherDiscount = 0;
      this.voucher_deducted_format = "";
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
    },

    // Terms and Conditions methods
    openTermsModal() {
      $(".btn-terms-modal").click();
    },

    async editCartItem(item, index) {
      this.editItemIndex = index;
      this.showLoader();

      try {
        // Lấy category_id từ item hoặc từ store
        // Nếu item không có category_id, cần lấy từ API
        let categoryId = item.category_id || 0;

        // Nếu không có category_id trong item, cần fetch từ API
        if (!categoryId) {
          // Có thể cần gọi API để lấy category_id dựa trên item_id
          // Hoặc lưu category_id khi add to cart
        }

        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId,
          item_id: item.id,
          branch_code: this.branch.branch_code ?? "",
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 0,
        };

        await OrderService.getItemDetail(dataForm).then(
          async (response) => {
            if (response.data.result.isSuccess) {
              let itemDetail = response.data.data;

              // Restore modifiers từ cart item vào itemDetail
              await this.restoreModifiersFromCart(itemDetail, item, categoryId);

              // Set quantity từ cart item
              itemDetail.quantity = item.quantity;

              // Set prices
              itemDetail.price_default = parseFloat(item.price_default || itemDetail.price_default);
              itemDetail.member_price = parseFloat(item.member_price || itemDetail.member_price);

              this.categoryIdSelect = categoryId;
              this.itemIdSelect = item.id;
              this.itemDetail = itemDetail;
              this.reloadModal = Math.random().toString();

              // Mở modal
              setTimeout(() => {
                $('.btn-show-item-detail-modal').click();
              }, 100);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      } catch (error) {
        this.hideLoader();
        console.error('Error editing item:', error);
      }
    },

    resetModifiersState(itemDetail) {
      // Reset modifiers for regular item
      if (itemDetail.modifier_group) {
        itemDetail.modifier_group.forEach((group) => {
          group.total_selected = 0;
          group.items.forEach((item) => {
            item.selected = false;
            item.quantity = 1;
            // Reset nested modifiers
            if (item.item_in_mog && item.item_in_mog.modifier_group) {
              this.resetModifiersState({ modifier_group: item.item_in_mog.modifier_group });
            }
          });
        });
      }

      // Reset modifiers for choice items
      if (itemDetail.choices) {
        itemDetail.choices.forEach((choice) => {
          if (choice.items) {
            choice.items.forEach((choiceItem) => {
              if (choiceItem.item_detail && choiceItem.item_detail.modifier_group) {
                this.resetModifiersState(choiceItem.item_detail);
              }
            });
          }
        });
      }
    },

    async restoreModifiersFromCart(itemDetail, cartItem, categoryId) {
      // Step important: Reset all modifiers to initial state before restoring
      this.resetModifiersState(itemDetail);

      // If item has choice (combo)
      if (cartItem.choice_selected && cartItem.choice_selected.items) {
        itemDetail.choice_selected = JSON.parse(JSON.stringify(cartItem.choice_selected));

        // Find choice tab corresponding to itemDetail.choices by id
        if (itemDetail.choices) {
          const matchingChoiceIndex = itemDetail.choices.findIndex(
            (c) => c.id === cartItem.choice_selected.id
          );
          const matchingChoice = matchingChoiceIndex >= 0
            ? itemDetail.choices[matchingChoiceIndex]
            : null;

          // Restore modifiers for each item in the selected choice
          if (matchingChoice && matchingChoice.items) {
            for (const savedChoiceItem of cartItem.choice_selected.items) {
              if (savedChoiceItem.item_detail && savedChoiceItem.item_detail.modifier_group) {
                const matchingItem = matchingChoice.items.find(ci => ci.id === savedChoiceItem.id);
                if (matchingItem && matchingItem.item_detail) {
                  await this.restoreModifierGroup(
                    matchingItem.item_detail.modifier_group,
                    savedChoiceItem.item_detail.modifier_group,
                    categoryId
                  );
                }
              }
            }
          }
        }
      } else if (cartItem.modifier_group) {
        // Restore modifiers for regular item
        await this.restoreModifierGroup(itemDetail.modifier_group, cartItem.modifier_group, categoryId);
      }
    },

    async restoreModifierGroup(detailModifiers, cartModifiers, categoryId) {
      if (!detailModifiers || !cartModifiers) return;

      // Map by id but ensure each detailGroup is used only once
      const usedDetailIndexes = new Set();

      for (const cartGroup of cartModifiers) {
        const detailIndex = detailModifiers.findIndex(
          (dg, idx) => dg.id === cartGroup.id && !usedDetailIndexes.has(idx)
        );
        if (detailIndex === -1) continue;

        const detailGroup = detailModifiers[detailIndex];
        usedDetailIndexes.add(detailIndex);

        // Reset group to clean state
        detailGroup.total_selected = 0;
        detailGroup.items_selected = [];
        detailGroup.items.forEach((it) => {
          it.selected = false;
          it.quantity = 1;
          if (it.item_in_mog && it.item_in_mog.modifier_group) {
            this.resetModifiersState({ modifier_group: it.item_in_mog.modifier_group });
          }
        });

        // Restore from cart: item, quantity, selected, items_selected, total_selected
        for (const cartItem of cartGroup.items) {
          const detailIndex = detailGroup.items.findIndex((di) => di.id === cartItem.id);
          if (detailIndex === -1) continue;

          const detailItem = detailGroup.items[detailIndex];

          detailItem.selected = !!cartItem.selected;
          detailItem.quantity = cartItem.quantity || 1;

          if (detailItem.selected) {
            // Add index to items_selected like runtime logic
            if (!detailGroup.items_selected) detailGroup.items_selected = [];
            if (!detailGroup.items_selected.includes(detailIndex)) {
              detailGroup.items_selected.push(detailIndex);
            }
          }

          // Nested modifiers
          if (cartItem.item_in_mog && cartItem.item_in_mog.modifier_group) {
            if (!detailItem.item_in_mog || !detailItem.item_in_mog.id) {
              // Fresh item detail has no nested data (multi-select/checkbox
              // options aren't pre-selected, so the API omits their item_in_mog).
              // The cart only stores the previously-selected options, so fetch
              // this option's own full detail (its full modifier_group) the
              // same way the item-detail modal does when an option is (re)selected.
              detailItem.item_in_mog = await this.fetchFullModifierOptionDetail(
                detailItem.id,
                categoryId
              );
            }

            if (detailItem.item_in_mog && detailItem.item_in_mog.modifier_group) {
              await this.restoreModifierGroup(
                detailItem.item_in_mog.modifier_group,
                cartItem.item_in_mog.modifier_group,
                categoryId
              );
            } else {
              // Fetch failed or the option truly has no modifier_group — fall
              // back to the cart's (selected-only) data so nothing is lost.
              detailItem.item_in_mog = JSON.parse(
                JSON.stringify(cartItem.item_in_mog)
              );
            }

            // Auto-show the nested modifiers for selected options, so editing
            // from cart displays them the same way single-select already does.
            if (detailItem.selected) {
              detailItem.is_show_modifier = true;
            }
          }
        }

        // Finally, get total_selected from cart (if available) or recalculate from items_selected
        if (typeof cartGroup.total_selected === "number") {
          detailGroup.total_selected = cartGroup.total_selected;
        } else {
          detailGroup.total_selected = detailGroup.items_selected
            ? detailGroup.items_selected.length
            : 0;
        }
      }
    },

    // Fetch the full item detail (incl. its own modifier_group) for a
    // modifier option — mirrors ModalCustomization.vue's gotoOrderDetail,
    // used here to repopulate the full nested option list during cart-edit restore.
    async fetchFullModifierOptionDetail(itemId, categoryId) {
      try {
        const response = await OrderService.getItemDetail({
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId ?? 0,
          item_id: itemId,
          branch_code: this.branch.branch_code ?? "",
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 0,
        });
        if (response.data.result.isSuccess) {
          return response.data.data;
        }
      } catch (error) {
        // Ignore — caller falls back to the cart's stored (selected-only) data.
      }
      return null;
    },

    handleItemUpdated(updatedItem) {
      // When item is updated from modal, replace item in cart
      if (this.editItemIndex >= 0 && this.editItemIndex < this.itemSelect.length) {
        // Remove old item and add new item
        this.itemSelect.splice(this.editItemIndex, 1, updatedItem);
        this.updateCartOrder();

        // MTH094: an edit can cut the line total (fewer units, cheaper
        // modifiers) below the minimum spend, so it takes the same path every
        // other cart mutation does. FREE_ITEM still skips the pricing call —
        // calculateVoucherPrice() unconditionally pushes the free item, which
        // would duplicate it here.
        this.refreshVoucherAfterCartChange();
      }

      this.editItemIndex = -1;
    },

    clearDataItem() {
      this.itemIdSelect = 0;
      this.itemDetail = {};
      this.editItemIndex = -1;
    },

  },
  watch: {
    // MTH057: chặn cứng ở ký tự thứ 26. Thuộc tính maxlength của input chỉ
    // chặn lúc gõ tay — watcher này bắt cả paste, autofill lẫn gán qua
    // v-model, nên không đường nào vượt được giới hạn.
    notes(val) {
      const max = this.specialInstructionsMaxLength;
      if (typeof val === "string" && val.length > max) {
        this.notes = val.slice(0, max);
        this.showSpecialInstructionsLimitMessage();
      }
    },

    'pickupDetails.date'(newDate) {
      if (!newDate) return;

      const now = new Date();
      const selectedDate = new Date(newDate);

      const isSameDay =
        selectedDate.getFullYear() === now.getFullYear() &&
        selectedDate.getMonth() === now.getMonth() &&
        selectedDate.getDate() === now.getDate();
        
      if (isSameDay) {
        this.pickupDetails.time = new Date();
      }
    },

    btnSelected: {
      handler() {
        this.persistCartFormState();
        this.syncDeliveryFeeItem();
      },
      immediate: false,
    },

    freeDeliveryThresholdReached: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.shouldApplyDeliveryFee() && this.branch && this.branch.delivery_fee_item) {
          this.addDeliveryFeeItem();
        }
      },
      immediate: false,
    },

    pickupDetails: {
      handler() {
        this.persistCartFormState();
      },
      deep: true,
      immediate: false,
    },

    deliveryAddress: {
      handler() {
        this.persistCartFormState();
      },
      deep: true,
      immediate: false,
    },

    deliveryContact: {
      handler() {
        this.persistCartFormState();
      },
      deep: true,
      immediate: false,
    },

    contactDetails: {
      handler() {
        this.persistCartFormState();
      },
      deep: true,
      immediate: false,
    },

    isEnableOpenRequestOptionMoo: {
      handler() {
        this.persistCartFormState();
      },
      immediate: false,
    },

    openRequestRemark: {
      handler() {
        this.persistCartFormState();
      },
      immediate: false,
    },

    deliveryDate() {
      this.persistCartFormState();
    },

    "deliveryAddress.postal_code"() {
      this.loadDeliveryFee();
    },

    deliveryFeeQuote() {
      if (this.shouldApplyDeliveryFee() && this.branch && this.branch.delivery_fee_item) {
        this.addDeliveryFeeItem();
      }
    },

    cbdSurcharge() {
      if (this.btnSelected == 2 && this.shouldApplyDeliveryFee() && this.branch && this.branch.delivery_fee_item) {
        this.addDeliveryFeeItem();
      }
    },

    deliveryTime() {
      this.deliveryError = "";
      this.persistCartFormState();
    },
  }
};
</script>
<style scoped>
/* Price Schedules: label under a cart line just repriced (applyReloadPrices). */
.moo-price-updated {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: #a86b00;
}
/* M986 follow-up: delivery slot pickers and the delivery minimum note. */
.delivery-select {
  flex: 1 1 0;
  min-width: 0;
}
.delivery-minimum {
  font-size: 14px;
  color: #b26a00;
}
.delivery-minimum.delivery-minimum-met {
  color: #2e7d32;
}
.delivery-fee-note {
  font-size: 13px;
  opacity: 0.8;
}
/* ── MTH019 theme2 shell (Phase 1) ── */
.moo-cart-page {
  /* theme2: brown accent -> var(--color); light surfaces -> theme colour blended over white (opacity tiers) */
  /* MTH066: same tier as the top bar (OrderTopBar uses --theme-30) so the page
     body and the sticky header read as one continuous surface — --theme-20 was
     lighter. Mirrors the fix already applied to OrderHistory. */
  --adv-surface: var(--theme-30, #f2e5e4);
  --adv-surface-lowest: #ffffff;
  --adv-surface-low: var(--theme-20, #fef1ef);
  --adv-surface-container: var(--theme-30, #f8ebea);
  --adv-surface-high: var(--theme-30, #f2e5e4);
  --adv-surface-highest: var(--theme-40, #ece0de);
  --adv-primary: var(--color);
  --adv-primary-container: var(--color);
  --adv-on-primary-container: #ffffff;
  --adv-on-surface: #201a1a;
  --adv-on-surface-variant: #524342;
  --adv-outline: #857372;
  --adv-outline-variant: var(--theme-40, #d7c2c0);
  /* MTH068: advocado's --advocado-success, used for the discount rows. Fixed
     green (not a --theme-N tier) — same as advocado, where the discount line
     stays green whatever the merchant colour is. */
  --adv-success: #1f8a4c;
  background: var(--adv-surface);
}
.moo-cart-page .mask {
  background-color: var(--adv-surface);
}
.cart-shell {
  max-width: 480px !important;
  margin: 0 auto;
  background: var(--adv-surface);
  /* MTH023: clear the fixed SubmitOrderBar at the bottom. M961: +26px for the
     waiting-time line the bar now carries above its button. */
  padding-bottom: calc(122px + env(safe-area-inset-bottom, 0px));
}
.cart-header-bar {
  background: var(--theme-30, #ffffff);
  border-bottom: 1px solid var(--theme-40, rgba(0, 0, 0, 0.06));
}
.cart-header-bar .cart-title {
  color: #201a1a;
}
/* MTH019 Phase 2 — item region */
.cart-divider {
  width: 100%;
  height: 1px;
  background: var(--theme-20, #ece0de);
  margin: 6px 0;
}
/* Phase B — cart item rows as rounded cards (design 7cartReview) */
.moo-cart-page .div-order-items {
  background: var(--adv-surface-lowest);
  border: 1px solid var(--adv-outline-variant);
  border-radius: 16px;
  padding: 10px 12px;
  margin-bottom: 12px;
}
/* Phase B (B2) — always-visible quantity pill on the cart item card */
.moo-cart-page .moo-cart-item-name {
  display: block;
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--adv-on-surface);
}
.moo-cart-page .moo-cart-edit {
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  height: 32px;
  padding: 0 0.6rem;
  background: none;
  border: 1px solid var(--adv-outline-variant);
  border-radius: 9999px;
  color: var(--adv-primary);
  font-weight: 700;
  font-size: 0.78rem;
  cursor: pointer;
}
.moo-cart-page .moo-cart-edit .material-icons {
  font-size: 16px;
}
.moo-cart-page .moo-cart-edit--disabled {
  opacity: 0.3;
  cursor: default;
}
.moo-cart-page .cart-qty-pill {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  background: var(--adv-surface-highest);
  border-radius: 9999px;
  height: 32px;
  padding: 0 4px;
  -webkit-user-select: none;
  user-select: none;
}
.moo-cart-page .cart-qty-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: var(--adv-primary);
  cursor: pointer;
}
.moo-cart-page .cart-qty-num {
  min-width: 22px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  color: var(--adv-on-surface);
}
/* Phase B (B4) — order summary rows (scoped so shared .total-section/.fee-section stay intact) */
.moo-cart-page .total-section,
.moo-cart-page .fee-section {
  align-items: center;
  padding: 3px 0;
  font-size: 0.9rem;
}
.moo-cart-page .total-label,
.moo-cart-page .fee-label {
  color: var(--adv-on-surface-variant);
  font-weight: 500;
  font-size: 0.9rem;
}
.moo-cart-page .total-amount,
.moo-cart-page .fee-amount {
  color: var(--adv-on-surface);
  font-weight: 600;
  font-size: 0.9rem;
}
/* MTH068 — voucher / promo-code discount row, green like advocado's summary.
   Only the discount rows are coloured; every other row keeps the default text
   colour set above. */
.moo-cart-page .fee-section.moo-summary-row--discount .fee-label,
.moo-cart-page .fee-section.moo-summary-row--discount .fee-amount {
  color: var(--adv-success);
  font-weight: 600;
}
.moo-cart-page .total-section.font-weight-bold,
.moo-cart-page .fee-section.font-weight-bold {
  align-items: baseline;
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--adv-outline-variant);
  gap: 12px;
}
.moo-cart-page .total-section.font-weight-bold .total-label,
.moo-cart-page .fee-section.font-weight-bold .fee-label {
  color: var(--adv-on-surface);
  font-weight: 800;
  font-size: 0.95rem;
  width: auto;
  flex: 0 1 auto;
}
.moo-cart-page .total-section.font-weight-bold .total-amount,
.moo-cart-page .fee-section.font-weight-bold .fee-amount {
  color: var(--adv-primary);
  font-weight: 800;
  font-size: 1.15rem;
  width: auto;
  flex: 0 0 auto;
  white-space: nowrap;
}
/* Phase B — Apply Voucher / Promo Code as dashed CTA cards (design 7cartReview) */
.moo-cart-page .cart-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px dashed var(--adv-outline-variant);
  border-radius: 14px;
  padding: 14px 16px;
  margin: 10px 0;
  cursor: pointer;
  background: var(--adv-surface-lowest);
  transition: border-color 0.15s ease, background 0.15s ease;
}
.moo-cart-page .cart-cta:active {
  background: var(--adv-surface-low);
}
.moo-cart-page .cart-cta__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.moo-cart-page .cart-cta__icon {
  color: var(--adv-primary);
  font-size: 22px;
}
.moo-cart-page .cart-cta__label {
  font-weight: 700;
  color: var(--adv-on-surface);
  font-size: 15px;
}
.moo-cart-page .cart-cta__chevron {
  color: var(--adv-outline);
  font-size: 22px;
}
/* MTH105 — collapsed promo-code entry: a quiet text link instead of a second
   dashed CTA card. */
.moo-cart-page .moo-cart-promo-link {
  display: block;
  margin: 2px auto 12px;
  padding: 4px 8px;
  border: 0;
  background: none;
  color: var(--adv-on-surface-variant);
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.moo-cart-page .moo-cart-promo-link:active {
  opacity: 0.7;
}
/* MTH092 — applied-voucher card that sits above the "Change Voucher" CTA
   (mirrors advocado's AppliedRewardCard). */
.moo-cart-page .moo-applied-voucher {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin: 10px 0;
  background: var(--adv-surface-lowest);
  border: 1px solid var(--adv-outline-variant);
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(25, 28, 30, 0.03);
}
.moo-cart-page .moo-applied-voucher__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--adv-surface-low);
  color: var(--adv-primary);
  font-size: 20px;
}
.moo-cart-page .moo-applied-voucher__body {
  flex: 1;
  min-width: 0;
}
.moo-cart-page .moo-applied-voucher__title {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.25;
  color: var(--adv-on-surface);
  word-break: break-word;
}
.moo-cart-page .moo-applied-voucher__subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: var(--adv-on-surface-variant);
}
.moo-cart-page .moo-applied-voucher__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: none;
  color: var(--adv-primary);
  cursor: pointer;
}
.moo-cart-page .moo-applied-voucher__remove .material-icons {
  font-size: 20px;
}
.moo-cart-page .moo-applied-voucher__remove:active {
  transform: scale(0.92);
  background: var(--adv-surface-low);
}
/* Phase B (#1) — Popular Add-Ons card: 2-col grid + emoji (matches advocado) */
.moo-cart-page .moo-addons-card {
  padding: 1.5rem;
  background: var(--adv-surface-lowest);
  border-radius: 16px;
  border: 1px solid var(--adv-outline-variant);
  box-shadow: 0 4px 14px rgba(25, 28, 30, 0.04);
  margin: 10px 0;
}
.moo-cart-page .moo-addons-card__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.moo-cart-page .moo-addons-card__emoji {
  font-size: 1.2rem;
}
.moo-cart-page .moo-addons-card__title {
  margin: 0;
  font-weight: 700;
  font-size: 1rem;
  color: var(--adv-on-surface);
}
.moo-cart-page .moo-addons-card__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.85rem;
}
.moo-cart-page .moo-addons-card__item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}
.moo-cart-page .moo-addons-card__item:active {
  transform: scale(0.97);
}
.moo-cart-page .moo-addons-card__image-wrap {
  aspect-ratio: 1 / 1;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: var(--adv-surface-container);
}
.moo-cart-page .moo-addons-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.moo-cart-page .moo-addons-card__image--placeholder {
  background: var(--adv-surface-container);
}
.moo-cart-page .moo-addons-card__meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}
.moo-cart-page .moo-addons-card__label {
  flex: 1;
  min-width: 0;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--adv-on-surface);
  text-align: left;
  line-height: 1.2;
}
.moo-cart-page .moo-addons-card__price {
  flex-shrink: 0;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--adv-primary);
  text-align: right;
  line-height: 1.2;
}
/* Phase B (#3) — Order Summary heading */
.moo-cart-page .moo-summary-card {
  padding: 1.25rem;
  background: var(--adv-surface-lowest);
  border-radius: 16px;
  border: 1px solid var(--adv-outline-variant);
  box-shadow: 0 4px 14px rgba(25, 28, 30, 0.04);
  margin: 10px 0;
}
.moo-cart-page .moo-summary-heading {
  margin: 0 0 0.25rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--adv-on-surface-variant);
}
/* Phase B (B7) — cart table pill (matches advocado cart) */
/* MTH072: --adv-surface-container resolves to the same --theme-30 as the page
   background, so the pill had no visible surface. --adv-surface-highest
   (--theme-40) is the next tier up and reads as a chip against the page. */
.moo-cart-page .moo-cart-pills-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.25rem auto 1rem;
}
/* Waiting time used to be a thin grey line under the pills and customers kept
   missing it. It is now a slim card in the same shell as the item cards (white,
   hairline outline, shared .card-body width) with the summary row rhythm — muted
   label left, brand-coloured value right, the shape every amount on this page
   uses. Kept to a single line: the label is short and never wraps, so the card
   stays one row tall next to the pills. */
.moo-cart-page .moo-cart-waiting-card {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--adv-surface-lowest);
  border: 1px solid var(--adv-outline-variant);
  border-radius: 12px;
  padding: 7px 12px;
  margin-bottom: 12px;
}
.moo-cart-page .moo-cart-waiting-card__icon {
  flex-shrink: 0;
  font-size: 16px;
  color: var(--adv-success);
}
.moo-cart-page .moo-cart-waiting-card__label {
  color: var(--adv-on-surface-variant);
  font-weight: 500;
  font-size: 0.82rem;
  white-space: nowrap;
}
/* M961: green, not the merchant colour — same fixed --adv-success the discount
   rows use, so the waiting time reads as its own kind of information instead of
   as another price. */
.moo-cart-page .moo-cart-waiting-card__value {
  margin-left: auto;
  padding-left: 0.5rem;
  text-align: right;
  color: var(--adv-success);
  font-weight: 700;
  font-size: 0.82rem;
}
.moo-cart-page .moo-cart-table-pill {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  background: var(--adv-surface-highest);
  color: var(--adv-on-surface-variant);
  border-radius: 9999px;
  font-size: 0.8rem;
  font-weight: 600;
  width: fit-content;
}
.moo-cart-page .moo-cart-table-pill .material-icons {
  font-size: 16px;
}
.moo-cart-page .moo-cart-table-pill--clickable {
  cursor: pointer;
}
.moo-cart-page .moo-cart-table-pill__chevron {
  font-size: 14px;
  opacity: 0.7;
}
.moo-cart-page .moo-cart-updated-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0 auto 0.75rem;
  padding: 0.5rem 0.9rem;
  background: #fdecea;
  color: #c0392b;
  border-radius: 0.85rem;
  font-size: 0.85rem;
  font-weight: 600;
  width: fit-content;
}
.moo-cart-page .moo-cart-updated-banner .material-icons {
  font-size: 18px;
}
/* MTH020: theme the phone-prefix box only inside MyCart (.prefix is shared globally) */
.moo-cart-page .prefix {
  background: var(--theme-20, #f9f9f9);
  border-right-color: var(--theme-40, #ddd);
}
/* MTH021: payment-method rows as selectable cards (scoped so shared .flex-container/.voucher-container aren't touched) */
.moo-cart-page .pay-method-row {
  border: 1px solid var(--theme-40, #e6e0df);
  border-radius: 12px;
  padding: 10px 12px;
  margin-top: 10px;
  background: var(--theme-20, #ffffff);
  transition: border-color 0.15s ease, background 0.15s ease;
}
.moo-cart-page .pay-method-row.pay-method-row--active {
  border-color: var(--color);
  background: var(--theme-30, #f4f2ff);
}
.moo-cart-page .voucher-container {
  border-radius: 10px;
  background: var(--btn-color, var(--color));
}

.pickup-delivery-btn {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  line-height: 1.667;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -moz-user-select: none;
  user-select: none;
  background: #fff;
  border: 1px solid var(--theme-40, #ddd);
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  color: black;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.pickup-delivery-active {
  background: var(--color) !important;
  border-color: var(--color) !important;
  color: #fff !important;
}

input::placeholder {
  font-size: 15px !important;
  text-align: right !important;
  font-weight: 100 !important;
}
input {
  text-align: right !important;
}
.visa {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.visaActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.master {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.masterActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.googlePay {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.googlePayActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.applePay {
  width: 50%;
  text-align: left;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  height: 80px;
}
.applePayActive {
  width: 50%;
  text-align: left;
  border: 5px solid var(--color);
  border-radius: 5px;
  height: 80px;
}
.text-bold-500 {
  color: black;
  font-weight: 500;
}
.text-bold-400 {
  color: black;
  font-weight: 400;
}
.line {
  width: 100%;
  height: 5px;
  background: #bdbdbd;
}
.text-end {
  color: black;
  width: 20%;
  text-align: end;
}
.line {
  height: 5px;
  background-color: "gray";
}
.flex-container {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.back-button {
  width: 10%;
  height: 100%;
}

.cart-title {
  width: 90%;
  align-items: center;
  color: black;
  font-size: 15px;
  font-weight: bold;
}
.flex-container {
  justify-content: space-between;
  display: inline-flex;
  gap: 5px;
  align-items: center;
  width: 100%;
}

.location-icon {
  width: 10%;
}

.branch-info {
  color: black;
  line-break: anywhere;
}

.takeaway-dinein-button {
  width: 30%;
  align-items: center;
  justify-content: center;
  display: flex;
  height: fit-content;
  font-size: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.order-items-header {
  font-size: 18px;
  color: black;
  font-weight: 800;
}

.selected-items {
  width: 100%;
  margin-top: 10px;
  display: inline-flex;
}

.item-image {
  width: 30%;
}

.item-thumbnail {
  width: 50px;
  height: 50px;
}

.item-details {
  width: 70%;
}

.item-name,
.modifier-name {
  width: 65%;
  color: black;
}

.item-quantity,
.modifier-quantity {
  width: 5%;
  color: black;
}

.item-price,
.modifier-price {
  width: 30%;
  text-align: right;
  color: black;
}

.modifier-options,
.modifier-option {
  width: 100%;
  display: inline-flex;
}
.total-section,
.fee-section {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.total-label,
.fee-label {
  color: black;
  width: 70%;
}

.total-amount,
.fee-amount {
  color: black;
  width: 30%;
}

.divider {
  width: 100%;
  border-top: 1px solid black;
  margin: 10px 0;
}
.flex-container {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.item-icon {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 30px;
}

.icon-image {
  width: 30px;
  height: 30px;
}

.item-label {
  color: black;
}

.toggle-container {
  width: 100%;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
}

.toggle-control {
  width: 100%;
}

@media (min-width: 576px) {
  .toggle-control {
    width: auto;
  }
}

.flex-container {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.inline-flex-container {
  display: inline-flex;
  align-items: flex-start;
  gap: 5px;
}

.icon-container {
  align-items: center;
  justify-content: center;
  display: flex;
}

.title-text {
  color: black;
}

.text-container {
  color: black;
}

.orange-text {
  color: var(--color);
}

.bold-text {
  font-weight: 600;
}

#eventIcon {
  width: 30px;
}

.cashback-icon {
  width: 25px;
  height: 25px;
}
.wallet-icon {
  width: 30px;
  height: 30px;
}

.radio-input {
  -ms-transform: scale(1.5);
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
}
/* MTH019: theme the radios only inside MyCart (class is shared globally) */
.moo-cart-page .radio-input {
  accent-color: var(--color);
}

.horizontal-line {
  margin: 0;
}

.margin-top-text {
  margin-top: 5px;
}

.not-enough-text {
  width: 100%;
  margin-top: 5px;
}

.inline-flex-container.align-items-center {
  align-items: center;
}

.white-bold-text {
  color: white;
  font-size: 18px;
  font-weight: 800;
}

.voucher-container {
  width: 100%;
  height: 100%;
  background: #eb472f;
  border-radius: 3px;
  position: relative;
}

.padding-container {
  padding: 10px;
}

.voucher-text {
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.orange-bold-text {
  color: var(--color);
  font-size: 20px;
  font-weight: 600;
}

.grid-container {
  display: grid;
}

.bold-text {
  color: black;
  font-weight: 500;
  font-size: 20px;
}

.orange-bold-text {
  color: var(--color);
  font-weight: 500;
  font-size: 20px;
}

.light-text {
  color: black;
  font-weight: 200;
}

.orange-light-text {
  color: var(--color);
  font-weight: 200;
}

.disabled-pay-button {
  /* opacity: 0.5; */
  padding: 10px 10px;
  background: white;
  color: gray;
  font-size: 18px;
  font-weight: 500;
  border: 0.5px solid gray;
  text-align: center;
  border-radius: 10px;
}

.pay-button {
  padding: 10px 10px;
  background: var(--color);
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  border-radius: 10px;
}

.div_root_cutlery {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* MTH057: ô input cao hơn 40px (padding 10px + font 14px + border) nên
     height cố định sẽ làm tràn — nới thành min-height. Class này chỉ dùng
     đúng ở block Special Instructions nên không ảnh hưởng hàng nào khác. */
  min-height: 40px;
}

.cutlery-icon {
  width: 30px;
  height: 30px;
}

.icon-container {
  align-items: center;
  justify-content: center;
  display: flex;
}

.text-container {
  color: black;
}

.inline-flex-container {
  display: inline-flex;
  align-items: flex-start;
  gap: 5px;
}
.text-introduce {
  margin-top: 8px;
  font-size: 14px;
  color: black;
  font-style: italic;
}
.text-introduce span {
  font-size: 14px;
  color: var(--color) !important;
  text-decoration: underline;
  cursor: pointer;
}
.div-order-items {
  width: 100%;
  display: inline-flex;
  margin-top: 8px;
}
.empty-cart-order-more {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0px 8px 0px;
}
.order-more-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 22px;
  background: var(--color);
  color: white;
  font-size: 14px;
  font-weight: 500;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 6px;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
.order-more-button:active {
  transform: scale(0.97);
  opacity: 0.9;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 3px;
}
.div-items {
  width: 100%;
  display: inline-flex;
}
.item-name {
  width: 65%;
  color: black;
}
.item-quantity {
  width: 5%;
  color: black;
}
.item-price-format {
  width: 30%;
  text-align: right;
  color: black;
  font-weight: bold;
}
.div-item-total {
  justify-content: end;
  width: 100%;
  gap: 20px;
  align-items: center;
  margin-bottom: 10px;
}
.text-item-total {
  justify-content: space-between;
  gap: 10px;
}
.div_notes {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}
.div_notes .color-black {
  white-space: nowrap;
}
.notes-input {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
}
.notes-input .input-group {
  margin-bottom: 0;
}
.notes-input .form-control {
  text-align: right;
}
/* #special-instructions is rendered inside the <material-input> child
   component, so a plain scoped selector never matches it here — it needs
   :deep() to pierce past that child's own render root. */
:deep(#special-instructions) {
  width: 100%;
  padding: 10px 14px;
  background-color: #fff;
  border: 1px solid var(--theme-40, #ddd);
  /* MTH057: bo góc bằng các input khác trên trang (.custom-input = 15px).
     Cần !important vì material-dashboard đặt
     `.input-group-dynamic .form-control { border-radius: 0 !important }`
     (forms/_input-group.scss) — đó là lý do giá trị 15px trước đây không ăn,
     ô này bị bo 0px trong khi các ô còn lại 15px. */
  border-radius: 15px !important;
  font-size: 14px;
  text-align: left !important;
  outline: none;
}
:deep(#special-instructions:focus) {
  border-color: var(--color);
}
:deep(#special-instructions::placeholder) {
  text-align: left !important;
  font-weight: 400 !important;
  color: #767676;
}
.image_notes {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 30px;
}
.color-black {
  color: black;
}
.div_arrow {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
}
.custom-note {
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}

.icon-next {
  width: 20px;
  color: gray !important;
}

.color-green {
  color: green !important; /* You can adjust the color value as needed */
}

.md-30 {
  font-size: 30px; /* Or adjust the font size as needed */
}

.order-value-is-not {
  width: 100%;
  color: #f04b5e;
  font-size: 13.5px;
}
.reward_title {
  color: gray;
  border: 1px solid gray;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 2px;
}
.select-voucher {
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 2px;
}
.icon-select-voucher {
  width: 20px;
  color: gray !important;
}
.reward_title_acitve {
  color: var(--color);
  border: 1px solid var(--color);
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 2px;
}
.banner {
  position: relative;
}
.container_modifier {
  /* display: contents; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
.child_modifier {
  flex: 1;
  display: contents;
}
input[type="radio"] {
  accent-color: green;
}
.modal-dialog {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}

.modal-content {
  margin: 0 auto;
}

.item-voucher-applied {
  font-weight: bold;
  color: #e10072;
}

.dining-option > div {
  padding: 5px 10px;
  background: #bdbdbd;
  color: #fff;
  cursor: pointer;
  width: 100px;
  text-align: center;
}

.dining-option > div.active {
  background: var(--color);
}

/* MTH019: confine MyCart dining-toggle reskin to this page only (class is shared globally) */
.moo-cart-page .dining-option {
  border-radius: 10px;
  overflow: hidden;
}
.moo-cart-page .dining-option > div {
  padding: 6px 10px;
  background: var(--theme-40, #f0eae9);
  color: rgba(82, 67, 66, 0.7);
}
.moo-cart-page .dining-option > div.active {
  background: var(--color);
  color: #fff;
}


/* Pickup Details */
.date-wrapper {
  position: relative;
  display: inline-block;
}

.date-wrapper .dp__input_icon {
  display: none;
}

.date-wrapper .custom-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.date-wrapper .dp__input {
  border: 2px solid var(--color) !important;
  /* room for .custom-icon above so it doesn't overlap the date/time value */
  padding-left: 34px !important;
}

.date-wrapper .dp__input,
.date-wrapper .dp__input::placeholder {
  text-align: left !important;
  color: #222 !important;
}

/* Contact Details */
.custom-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--theme-40, #ddd);
  border-radius: 15px;
  font-size: 14px;
  outline: none;
  text-align: left !important;
}

/* M988: address filled from the postal code, not typed. */
.custom-input-locked {
  background-color: #f2f2f2;
  color: #555;
  cursor: not-allowed;
}

.custom-input::placeholder,
.input-prefix::placeholder {
  text-align: left !important;
}

.custom-input:focus {
  border-color: var(--color);
}

.custom-input-with-prefix {
  display: flex;
  align-items: center;
  border: 1px solid var(--theme-40, #ddd);
  border-radius: 15px;
  overflow: hidden;
}

.prefix {
  display: flex;
  align-items: center;
  padding: 0 8px;
  background: #f9f9f9;
  border-right: 1px solid #ddd;
  font-size: 14px;
  gap: 6px;
}

.prefix img {
  width: 20px;
  height: 14px;
}

.input-prefix {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 12px;
  font-size: 14px;
  text-align: left !important;
}

/* material-dashboard strips the default .form-check-input border unless it's
   wrapped in .form-check — this input isn't, so it needs its own border to
   be visible at all (previously hardcoded to red as a stopgap). */
#termsCheckbox {
  border: 1px solid var(--theme-40, #ddd);
  border-radius: 4px;
}

#termsCheckbox:checked {
  background-image: none;
  border: 1px solid var(--color) !important;
}

.form-check-label {
  margin-bottom: 0px;
  text-decoration: underline;
  cursor: pointer;
  text-decoration-color: var(--color);
}

#termsCheckbox:checked::after {
  content: "✓";
  color: var(--color);
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* Terms and Conditions Modal Custom Styling */
#modalTermsConditions .modal-dialog {
  margin: 0 auto;
  max-width: 95%;
  width: 800px;
}

#modalTermsConditions .modal-content {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

#modalTermsConditions .modal-body {
  max-height: 60vh;
  overflow-y: auto;
  flex: 1;
}

:deep(.custom-control-label) {
    margin-bottom: 0 !important;
}
</style>
